<template>
    <div
        class="design_studio design_studio_up product_details_update_v3 ds_ad_edt_itm"
    >
        <div class="container"></div>
        <section id="typography" class="design_studio_tool">
            <!-- Headings & Paragraph Copy -->
            <div class="">
                <div class="row">
                    <div class="col-md-6 p-0 col-xl-3 col-lg-5 scroll-panel">
                        <div class="tools">
                            <!-- Left Menus -->
                            <LeftMenus
                                :design_count="design_count"
                                @open-sidebar="showMenu"
                            />

                            <div
                                class="tab-content dsAddtext"
                                id="myTabContent"
                            >
                                <div
                                    :class="
                                        active_class == 'active'
                                            ? 'main_panel_check tab-pane fade show active'
                                            : 'main_panel_check tab-pane fade'
                                    "
                                    id="default1"
                                    role="tabpanel"
                                    aria-labelledby="default1-tab"
                                >
                                    <Dashboard
                                        ref="dashBoardComp"
                                        :product_title="product_title"
                                        :product_number="product_number"
                                        :product_id="product_id"
                                        :genders="genders"
                                        :t_shirt_24_hour="
                                            product_items.t_shirt_24_hour
                                        "
                                        :user_selected_values="
                                            user_selected_values
                                        "
                                        :activeColorIndex="activeColorIndex"
                                    />
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade template_tab_main_box"
                                    id="templates"
                                    role="tabpanel"
                                    aria-labelledby="add-templates-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel template_panel"
                                    >
                                        <div class="template_inside_category">
                                            <div
                                                v-show="category_heading"
                                                class="tools_headding catgory_headding w-100 template_heading"
                                            >
                                                <h4 class="heading5">
                                                    Choose Category
                                                </h4>
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeMenu('templates')
                                                    "
                                                    title="Close"
                                                    class="ml-auto"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="
                                                    selected_category_heading
                                                "
                                                class="tools_headding select_catgory_headding w-100"
                                            >
                                                <h4 class="heading5">
                                                    <a
                                                        href="#"
                                                        @click="
                                                            closeSelectedCategory(
                                                                'templates'
                                                            )
                                                        "
                                                        class="text_primary_blue"
                                                        ><img
                                                            src="/maincss/images/tool_back_arrow.svg"
                                                            alt=" "
                                                            class="mr_12"
                                                        /><span
                                                            v-text="
                                                                template_name
                                                            "
                                                            id="template_name"
                                                        ></span>
                                                    </a>
                                                </h4>
                                                <a
                                                    href="#"
                                                    class="ml-auto"
                                                    @click="
                                                        closeSelectedCategory(
                                                            'templates'
                                                        )
                                                    "
                                                    title="Close"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="category_heading"
                                                class="serach"
                                            >
                                                <div
                                                    class="search_field position-relative mg-b-12 search_desi"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search for category"
                                                        v-model="
                                                            template_search_query
                                                        "
                                                        class="form-control bg-transparent"
                                                        style="
                                                            border-bottom: 1px
                                                                solid #ccc !important;
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            template_search_query
                                                        "
                                                        @click="
                                                            template_search_query =
                                                                '';
                                                            template_category_search();
                                                        "
                                                        class="cross_image cursor-pointer"
                                                        src="/maincss/images/close_popup.svg"
                                                        alt=" "
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                v-show="category_heading"
                                                class="categorys two_col_category"
                                                v-if="
                                                    template_category_search.length >
                                                        0 &&
                                                    (template_search_query ==
                                                        null ||
                                                        template_search_query ==
                                                            '')
                                                "
                                            >
                                                <div
                                                    class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                                >
                                                    <div
                                                        v-for="(
                                                            template, ind
                                                        ) in template_category_search"
                                                        :key="ind"
                                                    >
                                                        <template>
                                                            <a
                                                                href="javascript:void(0);"
                                                                v-if="
                                                                    ind == 0 &&
                                                                    show_popular_templates
                                                                "
                                                                @click="
                                                                    showPopularTemplates
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                Popular
                                                            </a>
                                                            <a
                                                                href="#"
                                                                @click="
                                                                    selectTemplateCategory(
                                                                        template
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    template.name
                                                                }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                                <span
                                                    v-if="
                                                        !template_category_search ||
                                                        template_category_search.length ==
                                                            0
                                                    "
                                                    >No results found.</span
                                                >
                                            </div>
                                            <div
                                                class="categorys_open tem"
                                                v-show="category_heading"
                                                v-else-if="
                                                    template_category_search.length >
                                                        0 &&
                                                    (template_search_query !=
                                                        null ||
                                                        template_search_query !=
                                                            '')
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist new_template_main_box d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <span
                                                        v-if="
                                                            template_category_search &&
                                                            template_category_search.length ==
                                                                0
                                                        "
                                                        >No results found.</span
                                                    >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in template_category_search"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid cat_tempalte_object_fit mb_767_fit"
                                                        :class="
                                                            cate_image.selected_images ==
                                                            true
                                                                ? 'active'
                                                                : ''
                                                        "
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    cate_image.name
                                                                "
                                                                :src="
                                                                    cate_image.image
                                                                "
                                                                :alt="
                                                                    cate_image.name
                                                                "
                                                            />
                                                            <input
                                                                :id="
                                                                    selected_template_subcategory.id +
                                                                    '' +
                                                                    index
                                                                "
                                                                @click="
                                                                    setNewTemplateDesign(
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span
                                                v-if="
                                                    template_category_search &&
                                                    category_heading &&
                                                    template_category_search.length ==
                                                        0
                                                "
                                                >No results found.</span
                                            >
                                            <div
                                                v-show="
                                                    selected_template_category_show
                                                "
                                                class="serach"
                                            >
                                                <div
                                                    class="search_field position-relative mg-b-12 search_desi"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search for sub category"
                                                        v-model="
                                                            template_subcategory_search_query
                                                        "
                                                        class="form-control bg-transparent"
                                                        style="
                                                            border-bottom: 1px
                                                                solid #ccc !important;
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            template_subcategory_search_query
                                                        "
                                                        @click="
                                                            template_subcategory_search_query =
                                                                '';
                                                            template_subcategory_search();
                                                        "
                                                        class="cross_image cursor-pointer"
                                                        src="/maincss/images/close_popup.svg"
                                                        alt=" "
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                v-show="
                                                    selected_template_category_show
                                                "
                                                class="categorys two_col_category"
                                                v-if="
                                                    template_subcategory_search.length >
                                                        0 &&
                                                    (template_subcategory_search_query ==
                                                        null ||
                                                        template_subcategory_search_query ==
                                                            '')
                                                "
                                            >
                                                <div
                                                    class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                                    :key="index"
                                                >
                                                    <div
                                                        v-for="(
                                                            template_sub_category,
                                                            index
                                                        ) in template_subcategory_search"
                                                        :key="index"
                                                    >
                                                        <template>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    index % 2 ==
                                                                    0
                                                                "
                                                                @click="
                                                                    getCustomImages(
                                                                        template_sub_category
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    template_sub_category.name
                                                                }}
                                                            </a>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    (index +
                                                                        1) %
                                                                        2 !=
                                                                        0 &&
                                                                    index + 1 in
                                                                        template_subcategory_search
                                                                "
                                                                @click="
                                                                    getCustomImages(
                                                                        template_subcategory_search[
                                                                            index +
                                                                                1
                                                                        ]
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    template_subcategory_search[
                                                                        index +
                                                                            1
                                                                    ].name
                                                                }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                                <span
                                                    v-if="
                                                        !template_subcategory_search ||
                                                        template_subcategory_search.length ==
                                                            0
                                                    "
                                                    >No results found.</span
                                                >
                                            </div>
                                            <div
                                                class="categorys_open tem"
                                                v-show="
                                                    selected_template_category_show
                                                "
                                                v-else-if="
                                                    template_subcategory_search.length >
                                                        0 &&
                                                    (template_subcategory_search_query !=
                                                        null ||
                                                        template_subcategory_search_query !=
                                                            '')
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist new_template_main_box d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <span
                                                        v-if="
                                                            template_subcategory_search &&
                                                            template_subcategory_search.length ==
                                                                0
                                                        "
                                                        >No results found.</span
                                                    >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in template_subcategory_search"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid cat_tempalte_object_fit mb_767_fit"
                                                        :class="
                                                            cate_image.selected_images ==
                                                            true
                                                                ? 'active'
                                                                : ''
                                                        "
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    cate_image.name
                                                                "
                                                                :src="
                                                                    cate_image.image
                                                                "
                                                                :alt="
                                                                    cate_image.name
                                                                "
                                                            />
                                                            <input
                                                                :id="
                                                                    selected_template_subcategory.id +
                                                                    '' +
                                                                    index
                                                                "
                                                                @click="
                                                                    setNewTemplateDesign(
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span
                                                v-if="
                                                    template_subcategory_search &&
                                                    selected_template_category_show &&
                                                    template_subcategory_search.length ==
                                                        0
                                                "
                                                >No results found.</span
                                            >
                                            <div
                                                class="categorys_open tem"
                                                v-show="
                                                    selected_template_subcategory_show
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist new_template_main_box d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <span
                                                        v-if="
                                                            selected_template_subcategory.template_images &&
                                                            selected_template_subcategory
                                                                .template_images
                                                                .length == 0
                                                        "
                                                        >No templates
                                                        found.</span
                                                    >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in selected_template_subcategory.template_images"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid cat_tempalte_object_fit mb_767_fit"
                                                        :class="
                                                            cate_image.selected_images ==
                                                            true
                                                                ? 'active'
                                                                : ''
                                                        "
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    cate_image.name
                                                                "
                                                                :src="
                                                                    cate_image.image
                                                                "
                                                                :alt="
                                                                    cate_image.name
                                                                "
                                                            />
                                                            <input
                                                                :id="
                                                                    selected_template_subcategory.id +
                                                                    '' +
                                                                    index
                                                                "
                                                                @click="
                                                                    setNewTemplateDesign(
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <ClipSetting
                                                :data="selectImageProps"
                                                :addDeleteBtn="addDeleteBtn"
                                                :closeEdit="closeEdit"
                                                :showMenu="showMenu"
                                                :selectedType="selectedType"
                                                :edit_template="edit_template"
                                                :canvasActiveObject="backCanvas"
                                                :selectedObjectColors="
                                                    selected_object_colors
                                                "
                                                @undoAndRedo="saveCanvasData"
                                                :rotationAngle="rotationAngle"
                                                :vendor_colors_list="
                                                    vendor_colors_list
                                                "
                                                :decorationType="
                                                    gender_groups_items[
                                                        active_gender_key
                                                    ].item.decoration_type
                                                "
                                                :printAreaBond="printAreaBond"
                                                :active_flip="active_flip"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="add-text"
                                    role="tabpanel"
                                    aria-labelledby="add-text-tab"
                                >
                                    <AddText
                                        :data="textData"
                                        v-on:closeMenu="closeMenu"
                                        :addDeleteBtn="addDeleteBtn"
                                        :canvasActiveObject="backCanvas"
                                        :selectedObjectColors="
                                            selected_object_colors
                                        "
                                        :designBox="design_box"
                                        @undoAndRedo="saveCanvasData"
                                        :fontCanvasWidth="front_canvas_width"
                                        :fontCanvasHeight="front_canvas_height"
                                        :fontCanvasTop="front_canvas_top"
                                        :fontCanvasLeft="front_canvas_left"
                                        :rotationAngle="rotationAngle"
                                        @triggerLoader="triggerLoader"
                                        :vendor_colors_list="vendor_colors_list"
                                        :decorationType="
                                            gender_groups_items[
                                                active_gender_key
                                            ].item.decoration_type
                                        "
                                        :printAreaBond="printAreaBond"
                                        :active_flip="active_flip"
                                    />
                                </div>

                                <div
                                    class="main_panel_check tab-pane fade add_clip_art_main_box_sec"
                                    id="add-clipart"
                                    role="tabpanel"
                                    aria-labelledby="add-clipart-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel left_no_scroll"
                                        v-if="!clipart_subcategory_div"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <div v-if="clipart_category_div">
                                            <div
                                                v-show="category_heading"
                                                class="tools_headding catgory_headding w-100 artwork_cate"
                                            >
                                                <h4 class="heading5">
                                                    Artwork Categories
                                                </h4>
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeMenu('add-clipart')
                                                    "
                                                    class="ml-auto"
                                                    title="Close"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="
                                                    selected_category_heading
                                                "
                                                class="tools_headding select_catgory_headding w-100"
                                            >
                                                <h4 class="heading5">
                                                    <a
                                                        href="#"
                                                        @click="
                                                            closeSelectedCategory(
                                                                'clipart_image'
                                                            )
                                                        "
                                                        class="text_primary_blue"
                                                        ><img
                                                            src="/maincss/images/tool_back_arrow.svg"
                                                            alt=" "
                                                            class="mr_12"
                                                        /><span
                                                            v-text="
                                                                clipart_name
                                                            "
                                                            id="clipart_name"
                                                        ></span>
                                                    </a>
                                                </h4>
                                                <a
                                                    href="#"
                                                    class="ml-auto"
                                                    title="Close"
                                                    ><img
                                                        src="/maincss/images/tool_close.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                            <div
                                                v-show="
                                                    category_heading ||
                                                    selected_category_heading
                                                "
                                                class="serach"
                                            >
                                                <div
                                                    class="search_field position-relative mg-b-12 search_desi"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search here"
                                                        v-model="
                                                            clipart_search_query
                                                        "
                                                        class="form-control bg-transparent"
                                                        style="
                                                            border-bottom: 1px
                                                                solid #cccccc !important;
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            clipart_search_query
                                                        "
                                                        @click="
                                                            clipart_search_query =
                                                                '';
                                                            clipart_category_search();
                                                        "
                                                        class="cross_image cursor-pointer"
                                                        src="/maincss/images/close_popup.svg"
                                                        alt=" "
                                                    />
                                                    <a
                                                        href="#"
                                                        class="search_icon"
                                                        ><img
                                                            src="/maincss/images/side_bar_serach.svg"
                                                            alt=" "
                                                    /></a>
                                                </div>
                                            </div>

                                            <div
                                                v-show="category_heading"
                                                class="categorys two_col_category"
                                                v-if="
                                                    clipart_category_search.length >
                                                        0 &&
                                                    (clipart_search_query ==
                                                        null ||
                                                        clipart_search_query ==
                                                            '')
                                                "
                                            >
                                                <div
                                                    class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                                >
                                                    <div
                                                        v-for="(
                                                            clipart,
                                                            clipart_index
                                                        ) in clipart_category_search"
                                                        :key="clipart_index"
                                                    >
                                                        <template>
                                                            <a
                                                                href="javascript:void(0);"
                                                                v-if="
                                                                    clipart_index ==
                                                                        0 &&
                                                                    show_popular_cliparts
                                                                "
                                                                @click="
                                                                    showPopularCliparts
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                Popular
                                                            </a>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    clipart_index %
                                                                        2 ==
                                                                    0
                                                                "
                                                                @click="
                                                                    getClipartCliparts(
                                                                        clipart.id,
                                                                        clipart.category_name
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    clipart.category_name
                                                                }}
                                                            </a>
                                                            <a
                                                                href="#"
                                                                v-if="
                                                                    clipart_index >
                                                                        0 &&
                                                                    (clipart_index +
                                                                        1) %
                                                                        2 !=
                                                                        0 &&
                                                                    clipart_index +
                                                                        1 in
                                                                        clipart_category_search
                                                                "
                                                                @click="
                                                                    getClipartCliparts(
                                                                        clipart_category_search[
                                                                            clipart_index +
                                                                                1
                                                                        ].id,
                                                                        clipart_category_search[
                                                                            clipart_index +
                                                                                1
                                                                        ]
                                                                            .category_name
                                                                    )
                                                                "
                                                                class="category_link w-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                {{
                                                                    clipart_category_search[
                                                                        clipart_index +
                                                                            1
                                                                    ]
                                                                        .category_name
                                                                }}
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-show="category_heading"
                                                class="categorys_open"
                                                v-else-if="
                                                    clipart_category_search.length >
                                                        0 &&
                                                    (clipart_search_query !=
                                                        null ||
                                                        clipart_search_query !=
                                                            '')
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in clipart_category_search"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid clipart_img_size"
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                            ><img
                                                                v-tooltip="
                                                                    cate_image.image_name
                                                                "
                                                                :src="
                                                                    cate_image.image_path
                                                                "
                                                                :alt="
                                                                    cate_image.image_path
                                                                "
                                                            />
                                                            <input
                                                                class="clipart_item"
                                                                @click="
                                                                    placeImage(
                                                                        $event,
                                                                        cate_image.image_path,
                                                                        cate_image.des_std_clipart_id,
                                                                        index,
                                                                        'clipart',
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-else
                                                >No results found.</span
                                            >
                                            <div
                                                class="categorys_open"
                                                v-show="
                                                    selected_clipart_category_show
                                                "
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <div
                                                        v-for="(
                                                            cate_image, index
                                                        ) in selected_clipart_category.DesignStudioClipartImagesModels"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid clipart_img_size"
                                                    >
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                            ><img
                                                                v-tooltip="
                                                                    cate_image.image_name
                                                                "
                                                                :src="
                                                                    cate_image.image_path
                                                                "
                                                                :alt="
                                                                    cate_image.image_path
                                                                "
                                                            />
                                                            <input
                                                                class="clipart_item"
                                                                @click="
                                                                    placeImage(
                                                                        $event,
                                                                        cate_image.image_path,
                                                                        selected_clipart_category.id,
                                                                        index,
                                                                        'clipart',
                                                                        cate_image
                                                                    )
                                                                "
                                                                type="radio"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- here the end categoty-->
                                    <div
                                        class="left_panel design_studio_panel"
                                        v-if="clipart_subcategory_div"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <div
                                            v-show="category_heading"
                                            class="tools_headding catgory_headding w-100"
                                        >
                                            <h4 class="heading5">
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeSelectedCategory(
                                                            'clipart'
                                                        )
                                                    "
                                                    class="text_primary_blue"
                                                    ><img
                                                        src="/maincss/images/tool_back_arrow.svg"
                                                        alt=" "
                                                        class="mr_12"
                                                    /><span
                                                        v-text="
                                                            clipart_category_name
                                                        "
                                                        id="clipart_category_name"
                                                    ></span>
                                                </a>
                                            </h4>
                                            <a
                                                href="#"
                                                @click="
                                                    closeMenu('add-clipart')
                                                "
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="selected_category_heading"
                                            class="tools_headding select_catgory_headding w-100"
                                        >
                                            <h4 class="heading5">
                                                <a
                                                    href="#"
                                                    @click="
                                                        closeSelectedCategory(
                                                            'clipart_image'
                                                        )
                                                    "
                                                    class="text_primary_blue"
                                                    ><img
                                                        src="/maincss/images/tool_back_arrow.svg"
                                                        alt=" "
                                                        class="mr_12"
                                                    /><span
                                                        v-text="clipart_name"
                                                        id="clipart_name"
                                                    ></span>
                                                </a>
                                            </h4>
                                            <a
                                                href="#"
                                                @click="
                                                    closeMenu('add-clipart')
                                                "
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="serach"
                                        >
                                            <div
                                                class="search_field position-relative mg-b-12 search_desi"
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Search here"
                                                    v-model="
                                                        clipart_subcategory_search_query
                                                    "
                                                    class="form-control bg-transparent"
                                                    style="
                                                        border-bottom: 1px solid
                                                            #cccccc !important;
                                                    "
                                                />
                                                <img
                                                    v-if="
                                                        clipart_subcategory_search_query
                                                    "
                                                    @click="
                                                        clipart_subcategory_search_query =
                                                            '';
                                                        clipart_subcategory_search();
                                                    "
                                                    class="cross_image cursor-pointer"
                                                    src="/maincss/images/close_popup.svg"
                                                    alt=" "
                                                />
                                                <a href="#" class="search_icon"
                                                    ><img
                                                        src="/maincss/images/side_bar_serach.svg"
                                                        alt=" "
                                                /></a>
                                            </div>
                                        </div>
                                        <!--@click="getImages(clipart, 'clipart',clipart_index)"-->
                                        <div
                                            v-show="category_heading"
                                            class="categorys two_col_category"
                                            v-if="
                                                clipart_subcategory_search.length >
                                                    0 &&
                                                (clipart_subcategory_search_query ==
                                                    null ||
                                                    clipart_subcategory_search_query ==
                                                        '')
                                            "
                                        >
                                            <div
                                                class="w-100 d-flex justify-content-center align-items-center desi_grid"
                                            >
                                                <div
                                                    v-for="(
                                                        clipart, clipart_index
                                                    ) in clipart_subcategory_search"
                                                    :key="clipart_index"
                                                >
                                                    <template>
                                                        <a
                                                            href="#"
                                                            v-if="
                                                                clipart_index %
                                                                    2 ==
                                                                0
                                                            "
                                                            @click="
                                                                getImages(
                                                                    clipart,
                                                                    'clipart',
                                                                    clipart_index
                                                                )
                                                            "
                                                            class="category_link w-100 d-flex justify-content-center align-items-center"
                                                        >
                                                            {{ clipart.name }}
                                                        </a>
                                                        <a
                                                            href="#"
                                                            v-if="
                                                                (clipart_index +
                                                                    1) %
                                                                    2 !=
                                                                    0 &&
                                                                clipart_index +
                                                                    1 in
                                                                    clipart_subcategory_search
                                                            "
                                                            @click="
                                                                getImages(
                                                                    clipart_subcategory_search[
                                                                        clipart_index +
                                                                            1
                                                                    ],
                                                                    'clipart',
                                                                    clipart_index +
                                                                        1
                                                                )
                                                            "
                                                            class="category_link w-100 d-flex justify-content-center align-items-center"
                                                        >
                                                            {{
                                                                clipart_subcategory_search[
                                                                    clipart_index +
                                                                        1
                                                                ].name
                                                            }}
                                                        </a>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="categorys"
                                            v-else-if="
                                                clipart_subcategory_search.length >
                                                    0 &&
                                                (clipart_subcategory_search_query !=
                                                    null ||
                                                    clipart_subcategory_search_query !=
                                                        '')
                                            "
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        cate_image, index
                                                    ) in clipart_subcategory_search"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid clipart_img_size"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                cate_image.image_name
                                                            "
                                                            :src="
                                                                cate_image.image_path
                                                            "
                                                            :alt="
                                                                cate_image.image_path
                                                            "
                                                        />
                                                        <div
                                                            v-if="
                                                                cate_image.image_colors
                                                            "
                                                            v-html="
                                                                designColorsHtml(
                                                                    cate_image.image_colors
                                                                )
                                                            "
                                                        ></div>
                                                        <input
                                                            class="clipart_item"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    cate_image.image_path,
                                                                    cate_image.des_std_clipart_id,
                                                                    index,
                                                                    'clipart',
                                                                    cate_image
                                                                )
                                                            "
                                                            type="radio"
                                                        />
                                                        <!-- v-model="cate_image.selected_images" -->

                                                        <!-- <span class="checkmark"></span> -->
                                                    </label>
                                                    <!-- <span class="tooltip-title">Tooltip title</span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <span v-show="category_heading" v-else
                                            >No results found.</span
                                        >
                                        <div
                                            class="categorys_open"
                                            v-show="
                                                selected_clipart_category_show
                                            "
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        cate_image, index
                                                    ) in selected_clipart_category.DesignStudioClipartImagesModels"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid clipart_img_size"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                cate_image.image_name
                                                            "
                                                            :src="
                                                                cate_image.image_path
                                                            "
                                                            :alt="
                                                                cate_image.image_path
                                                            "
                                                        />
                                                        <div
                                                            v-if="
                                                                cate_image.image_colors
                                                            "
                                                            v-html="
                                                                designColorsHtml(
                                                                    cate_image.image_colors
                                                                )
                                                            "
                                                        ></div>
                                                        <input
                                                            class="clipart_item"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    cate_image.image_path,
                                                                    selected_clipart_category.id,
                                                                    index,
                                                                    'clipart',
                                                                    cate_image
                                                                )
                                                            "
                                                            type="radio"
                                                        />
                                                        <!-- v-model="cate_image.selected_images" -->

                                                        <!-- <span class="checkmark"></span> -->
                                                    </label>
                                                    <!-- <span class="tooltip-title">{{ cate_image.image_name }}</span> -->
                                                </div>
                                            </div>
                                            <span
                                                v-show="
                                                    selected_clipart_category_show &&
                                                    selected_clipart_category
                                                        .DesignStudioClipartImagesModels
                                                        .length == 0
                                                "
                                                >No results found.</span
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade add_shap_frontend_box_custom"
                                    id="add-shape"
                                    role="tabpanel"
                                    aria-labelledby="add-shape-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />

                                        <div
                                            v-show="category_heading"
                                            class="tools_headding catgory_headding w-100 heading-pd"
                                        >
                                            <h4 class="heading5">Add Shape</h4>
                                            <a
                                                href="#"
                                                @click="closeMenu('add-shape')"
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="categorys_open mt_14 shape_open"
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        shape, index
                                                    ) in shapes"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid add_shap_pd"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                shape.image_name
                                                            "
                                                            :src="
                                                                shape.image_path
                                                            "
                                                            :alt="
                                                                shape.image_name
                                                            "
                                                        />
                                                        <input
                                                            type="radio"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    shape.image_path,
                                                                    shape.image_path,
                                                                    index,
                                                                    'shape',
                                                                    shape
                                                                )
                                                            "
                                                        />
                                                        <!-- <span class="checkmark"></span> -->
                                                    </label>
                                                    <!-- <span class="tooltip-title">{{ shape.image_name }}</span> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="add-patch"
                                    role="tabpanel"
                                    aria-labelledby="add-patch-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd a"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />

                                        <div
                                            v-show="category_heading"
                                            class="tools_headding catgory_headding w-100 heading-pd"
                                        >
                                            <h4 class="heading5">Add Patch</h4>
                                            <a
                                                href="#"
                                                @click="closeMenu('add-patch')"
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            v-show="category_heading"
                                            class="categorys_open mt_14 shape_open add-patch"
                                            style="margin-top: 0px !important"
                                        >
                                            <div
                                                id="avatarlist"
                                                class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                            >
                                                <div
                                                    v-for="(
                                                        patch, index
                                                    ) in patches"
                                                    :key="index"
                                                    class="form-check pl-0 img-polaroid patch_no_img tooltip-space-patch"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select"
                                                        ><img
                                                            v-tooltip="
                                                                patch.image_name
                                                            "
                                                            :src="
                                                                patch.image_path
                                                            "
                                                            :alt="
                                                                patch.image_name
                                                            "
                                                        />
                                                        <input
                                                            type="radio"
                                                            @click="
                                                                placeImage(
                                                                    $event,
                                                                    patch.image_path,
                                                                    patch.image_path,
                                                                    index,
                                                                    'patch',
                                                                    patch
                                                                )
                                                            "
                                                            v-model="
                                                                patch.selected_images
                                                            "
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="nn-tab"
                                    role="tabpanel"
                                    aria-labelledby="nn-tab"
                                >
                                    <NameAndNumber
                                        ref="nameAndNumberRef"
                                        :activeGenderKey="active_gender_key"
                                        :activeColorIndex="activeColorIndex"
                                        :selectedCheckbox="selectedCheckbox"
                                        @activeFrontType="activeFrontType"
                                        :canvasActiveObject="backCanvas"
                                        :frontCanvasTop="front_canvas_top"
                                        :frontCanvasLeft="front_canvas_left"
                                        v-on:closeMenu="closeMenu"
                                        @flipTshirt="flipTshirt"
                                        @undoAndRedo="saveCanvasData"
                                        @updateNameNumberFees="
                                            updateNameNumberFees
                                        "
                                        :designBox="design_box"
                                        :adminOptions="adminOptions"
                                        :gender-groups-items="
                                            gender_groups_items
                                        "
                                        :build-id="build_id"
                                    />
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="distress-effects"
                                    role="tabpanel"
                                    aria-labelledby="distress-effects-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_pd"
                                    >
                                        <DistressImageList
                                            :addDistressImage="
                                                add_distress_images
                                            "
                                            :showImageList="showImageList"
                                            @closeImageList="closeImageList"
                                            :canvasActiveObj="backCanvas"
                                            v-on:set-value="updateDistressImage"
                                            :selectedDistressImage="
                                                selectedDistressImage
                                            "
                                            @undoAndRedo="saveCanvasData"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade upload_main_panel"
                                    id="upload"
                                    role="tabpanel"
                                    aria-labelledby="add-upload-tab"
                                >
                                    <div
                                        class="left_panel design_studio_panel_images"
                                    >
                                        <ClipSetting
                                            :data="selectImageProps"
                                            :addDeleteBtn="addDeleteBtn"
                                            :closeEdit="closeEdit"
                                            :showMenu="showMenu"
                                            :selectedType="selectedType"
                                            :edit_template="edit_template"
                                            :canvasActiveObject="backCanvas"
                                            :selectedObjectColors="
                                                selected_object_colors
                                            "
                                            @undoAndRedo="saveCanvasData"
                                            :rotationAngle="rotationAngle"
                                            @triggerLoader="triggerLoader"
                                            :vendor_colors_list="
                                                vendor_colors_list
                                            "
                                            :decorationType="
                                                gender_groups_items[
                                                    active_gender_key
                                                ].item.decoration_type
                                            "
                                            :printAreaBond="printAreaBond"
                                            :active_flip="active_flip"
                                        />
                                        <div
                                            class="tools_headding catgory_headding w-100 upload_heading"
                                            v-show="category_heading"
                                        >
                                            <h4 class="heading5 heading-space">
                                                Upload
                                            </h4>
                                            <a
                                                href="#"
                                                @click="closeMenu('upload')"
                                                class="ml-auto"
                                                title="Close"
                                                ><img
                                                    src="/maincss/images/tool_close.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                        <div
                                            class="form-group mt_16 upload-group"
                                            v-show="category_heading"
                                        >
                                            <label
                                                class="add_text_label label_text_add_text"
                                                >Image Name</label
                                            ><span class="highlight"></span>
                                            <input
                                                type="text"
                                                placeholder="Enter here"
                                                v-model="uploaded_image_name"
                                            />
                                        </div>
                                        <div
                                            class="well mx-0 p-0 file_upload"
                                            v-show="category_heading"
                                        >
                                            <div class="Upload_tc">
                                                <label
                                                    class="font-weight-bold d-block"
                                                    >Choose a file to
                                                    upload</label
                                                >
                                                <label class="font-weight-bold"
                                                    >(Note: Svg images only
                                                    editable)</label
                                                >
                                            </div>

                                            <form
                                                action=""
                                                method="post"
                                                enctype="multipart/form-data"
                                                @submit.prevent="ImageUpload"
                                                data-vv-scope="uploadform"
                                                :key="'uploadform'"
                                                class="choose_file_to_upload"
                                            >
                                                <div
                                                    class="upload_box d-flex justify-content-center align-items-center flex-column upload-img-box"
                                                    @click="
                                                        $refs.uploadDesignImage.click()
                                                    "
                                                >
                                                    <input
                                                        class="crop_bdr d-none"
                                                        accept="image/svg+xml, image/jpeg, image/jpg, image/png"
                                                        id="crop_bdr"
                                                        type="file"
                                                        ref="uploadDesignImage"
                                                        @click="
                                                            $refs.uploadDesignImage.value =
                                                                ''
                                                        "
                                                        @change="croppie"
                                                    />
                                                    <img
                                                        src="/maincss/images/cloud_computing.svg"
                                                        alt=" "
                                                    />
                                                    <h4 class="mt_16 mb-0">
                                                        Drag &amp; Drop or
                                                    </h4>
                                                    <h4 class="mb-0">
                                                        <a
                                                            href="#"
                                                            data-original-title=""
                                                            title=""
                                                            style="
                                                                color: #0079c1;
                                                            "
                                                            >Browse</a
                                                        >
                                                        Your Computer
                                                    </h4>
                                                </div>
                                                <div
                                                    class="upload_note upload-img-note"
                                                >
                                                    <div class="left_ins">
                                                        <p>
                                                            Accepted File Types
                                                        </p>
                                                        <p>(Max Size. 5 MB)</p>
                                                    </div>
                                                    <div class="rgt_ins">
                                                        <p>
                                                            Png, Jpg, Jpeg, SVG
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="upload_apply_button"
                                                ></div>
                                                <!--crop popup-->
                                                <div
                                                    class="modal login-form-popup fade h-auto"
                                                    id="crop_modal"
                                                    tabindex="-1"
                                                    aria-labelledby="login"
                                                    aria-hidden="true"
                                                    data-keyboard="false"
                                                    data-backdrop="static"
                                                >
                                                    <div
                                                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                                                    >
                                                        <div
                                                            class="modal-content"
                                                        >
                                                            <div
                                                                class="modal-body"
                                                            >
                                                                <a
                                                                    href="#"
                                                                    class="popup-close"
                                                                    id="popup-close"
                                                                    data-dismiss="modal"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/cancel.svg"
                                                                        alt=" "
                                                                    />
                                                                </a>
                                                                <div
                                                                    class="login-form"
                                                                >
                                                                    <h3>
                                                                        Upload
                                                                        and Crop
                                                                    </h3>
                                                                    <!--crop tool-->
                                                                    <div
                                                                        class="upload_crop_design_studio"
                                                                    >
                                                                        <input
                                                                            class="crop_bdr"
                                                                            id="crop_bdr"
                                                                            type="file"
                                                                            @change="
                                                                                croppie
                                                                            "
                                                                        />

                                                                        <small
                                                                            class="form-text text-error"
                                                                            v-if="
                                                                                crop_image_validation ==
                                                                                1
                                                                            "
                                                                            >Incorrect
                                                                            image
                                                                            format.Please
                                                                            upload
                                                                            the
                                                                            Png,
                                                                            Jpg,
                                                                            Jpeg,
                                                                            Svg
                                                                            image
                                                                            formats</small
                                                                        >
                                                                        <small
                                                                            class="form-text text-error"
                                                                            v-if="
                                                                                image_size_validation ==
                                                                                1
                                                                            "
                                                                            >Please
                                                                            upload
                                                                            images
                                                                            greater
                                                                            than
                                                                            1000px
                                                                            X
                                                                            1000px</small
                                                                        >
                                                                        <vue-croppie
                                                                            ref="croppieRef"
                                                                            :enableOrientation="
                                                                                true
                                                                            "
                                                                            :enableResize="
                                                                                false
                                                                            "
                                                                            :mouseWheelZoom="
                                                                                false
                                                                            "
                                                                            :boundary="{
                                                                                width: 300,
                                                                                height: 300
                                                                            }"
                                                                            :viewport="{
                                                                                width: 200,
                                                                                height: 200,
                                                                                type: 'square'
                                                                            }"
                                                                        >
                                                                        </vue-croppie>
                                                                    </div>
                                                                    <!-- the result -->
                                                                    <!-- <img :src="cropped"> -->
                                                                    <!-- Rotate angle is Number -->
                                                                    <div
                                                                        class="crp_bottom_btn"
                                                                    >
                                                                        <button
                                                                            class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                                                            type="button"
                                                                            @click="
                                                                                rotate(
                                                                                    -90
                                                                                )
                                                                            "
                                                                        >
                                                                            Rotate
                                                                            Left
                                                                        </button>
                                                                        <button
                                                                            class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                                                            type="button"
                                                                            @click="
                                                                                rotate(
                                                                                    90
                                                                                )
                                                                            "
                                                                        >
                                                                            Rotate
                                                                            Right
                                                                        </button>
                                                                        <button
                                                                            style="
                                                                                background-color: #f2790c !important;
                                                                                color: #fff !important;
                                                                                border: 1px
                                                                                    solid
                                                                                    #f2790c !important;
                                                                            "
                                                                            class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                                                            type="button"
                                                                            @click="
                                                                                crop
                                                                            "
                                                                            :disabled="
                                                                                !uploaded_design_image
                                                                            "
                                                                        >
                                                                            Crop
                                                                        </button>
                                                                    </div>

                                                                    <small
                                                                        class="form-text text-error text-left"
                                                                        v-show="
                                                                            errors.has(
                                                                                'uploadform.image'
                                                                            )
                                                                        "
                                                                    >
                                                                        {{
                                                                            errors.first(
                                                                                "uploadform.image"
                                                                            )
                                                                        }}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div class="bottom_upload_text">
                                                <p>
                                                    Have a different type of
                                                    file?
                                                    <a href="mailto:">Email</a>
                                                    it to us!
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            class="left_panel_s"
                                            style="padding-top: 0px !important"
                                            v-if="uploadedImages.length > 0"
                                            v-show="category_heading"
                                        >
                                            <div
                                                class="categorys_open mt_14 shape_open new_after_upload_main_scroll_box"
                                            >
                                                <div
                                                    id="avatarlist"
                                                    class="avatarlist d-flex flex-wrap well p-0 m-0 avatarlist-tooltip"
                                                >
                                                    <div
                                                        v-for="(
                                                            image, index
                                                        ) in uploadedImages"
                                                        :key="index"
                                                        class="form-check pl-0 img-polaroid add_shap_pd new_after_upload_mainbox_icon upload_image"
                                                    >
                                                        <label
                                                            class="checkbox_custom new_after_upload_delete_icon"
                                                            @click="
                                                                deleteUploadedImage(
                                                                    image.id
                                                                )
                                                            "
                                                        >
                                                            <img
                                                                class="delete_icon"
                                                                alt=""
                                                                src="/maincss/images/icons/delete_dark.svg"
                                                            />
                                                        </label>
                                                        <label
                                                            class="checkbox_custom brand_logo_select"
                                                        >
                                                            <img
                                                                v-tooltip="
                                                                    image.image_name
                                                                "
                                                                :src="
                                                                    image.image
                                                                "
                                                            />
                                                            <input
                                                                type="radio"
                                                                @click="
                                                                    bindUploadedDesignImage(
                                                                        image.image,
                                                                        image
                                                                    )
                                                                "
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span v-else> No images found. </span>
                                    </div>
                                </div>
                                <div
                                    class="main_panel_check tab-pane fade"
                                    id="designs"
                                    role="tabpanel"
                                    aria-labelledby="designs-tab"
                                >
                                    <MyDesigns
                                        :design_tab_active="design_tab_active"
                                        :current_design_id="current_design_id"
                                        @close-design="closeMenu('designs')"
                                        @set-new-design="setNewDesign"
                                    />
                                </div>

                                <div class="design_studio_btns d-none">
                                    <div class="save_btn">
                                        <button
                                            @click="save_all_design()"
                                            v-if="colors_validation == ''"
                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn"
                                            style="
                                                max-width: 80%;
                                                background: 0% 0% no-repeat
                                                    padding-box
                                                    rgb(35, 132, 204) !important;
                                            "
                                        >
                                            {{
                                                build_item_id
                                                    ? "EDIT/SAVE"
                                                    : "ADD/SAVE"
                                            }}
                                            THE BUILD
                                        </button>
                                        <button
                                            v-else
                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn"
                                            style="
                                                max-width: 80%;
                                                background: 0% 0% no-repeat
                                                    padding-box
                                                    rgb(35, 132, 204) !important;
                                            "
                                            disabled
                                        >
                                            {{
                                                build_item_id
                                                    ? "EDIT/SAVE"
                                                    : "ADD/SAVE"
                                            }}
                                            THE BUILD
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 p-0 col-xl-7 col-lg-7 design-area-v3">
                        <div class="bg-white h-100 design_studio_right_side">
                            <div class="reser_button"></div>

                            <div align="center" class="" style="">
                                <div class="clearfix">
                                    <div
                                        class="pull-right"
                                        align=""
                                        id="imageeditor"
                                        style="display: none"
                                    >
                                        <div class="btn-group">
                                            <button
                                                id="remove-selected"
                                                class="btn"
                                                title="Delete selected item"
                                                @click="delete_object()"
                                            >
                                                <i
                                                    class="icon-trash"
                                                    style="height: 19px"
                                                ></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  EDITOR      -->
                            <div class="mx-auto">
                                <div
                                    class="back_front_t-shirt right_sec_design_studio_t_shirt"
                                    style="display: none"
                                >
                                    <div
                                        class="btn_front front active"
                                        v-show="front_show"
                                    ></div>
                                    <div
                                        class="btn_front back"
                                        v-show="back_show"
                                    ></div>
                                    <div
                                        class="btn_front left"
                                        v-show="left_show"
                                    >
                                        <button
                                            id="left_flipbtn"
                                            type="button"
                                            class="btn"
                                            title="Left"
                                            @click="flipTshirt('left')"
                                            data-original-title="Show Left View"
                                            :disabled="disable_tshirt_canvas"
                                        >
                                            <img
                                                name="tshirtview"
                                                id=""
                                                src="/maincss/design-studio/img/lft_sl.png"
                                            />
                                        </button>
                                        <p>Left</p>
                                    </div>
                                    <div
                                        class="btn_front right"
                                        v-show="right_show"
                                    >
                                        <button
                                            id="right_flipbtn"
                                            type="button"
                                            class="btn"
                                            title="Right"
                                            @click="flipTshirt('right')"
                                            data-original-title="Show Right View"
                                            :disabled="disable_tshirt_canvas"
                                        >
                                            <img
                                                name="tshirtview"
                                                id=""
                                                src="/maincss/design-studio/img/rgt_slv.png"
                                            />
                                        </button>
                                        <p>Right</p>
                                    </div>
                                </div>
                                <div
                                    class="reset-btn"
                                    style="display: none"
                                ></div>
                                <div class="design_area_section">
                                    <div
                                        id="shirtDiv"
                                        class="page mx-auto mt_10"
                                        :style="`width: ${defaultWidthCanvas}px;
                                                                                                                                                            height: ${defaultHeightCanvas}px;
                              display: flex;
                              position: relative;
                              justify-content: center;
                              overflow:hidden;`"
                                    >
                                        <div
                                            id="drawingArea"
                                            class=""
                                            :style="`
                             position: absolute;
                             left: 0;
                              width: ${defaultWidthCanvas}px;
                                                                                                                                                                          height: ${defaultHeightCanvas}px;`"
                                        >
                                            <fabric-canvas
                                                :id="'bcanvas'"
                                                :height="defaultHeightCanvas"
                                                :width="defaultWidthCanvas"
                                                :stateful="false"
                                                @canvas-updated="
                                                    canvasImageUpdated
                                                "
                                            >
                                            </fabric-canvas>
                                        </div>
                                        <fabric-canvas
                                            :id="'tcanvas'"
                                            :height="defaultHeightCanvas"
                                            :width="defaultWidthCanvas"
                                            :stateful="true"
                                            @canvas-updated="canvasBackUpdated"
                                            @object-moved="objMoved"
                                            @object-moving="objMoving"
                                            @object-scaling="objScaling"
                                            @object-rotating="objRotating"
                                            @object-skweing="objSkewing"
                                            @object-modified="objModified"
                                            @object-removed="objRemoved"
                                            @selection-created="objSelected"
                                            @selection-updated="objSelected"
                                            @selection-cleared="
                                                objSelectionCleared
                                            "
                                            @drop="objDropped"
                                            @after-render="afterRender"
                                            @mousedown="objMouseDown"
                                            @mouseup="objMouseUp"
                                        >
                                        </fabric-canvas>
                                    </div>
                                    <div
                                        class="back_front_t-shirt right_sec_design_studio_t_shirt direction_block"
                                    >
                                        <PrintAreaIcons
                                            ref="printAreaIcons"
                                            @flipTshirt="flipTshirt"
                                            @getPrintAreaParent="
                                                getPrintAreaParent
                                            "
                                            @changePrintArea="
                                                (flip) => {
                                                    this.active_flip = flip;
                                                }
                                            "
                                            :front_show="front_show"
                                            :back_show="back_show"
                                            :left_show="left_show"
                                            :right_show="right_show"
                                            :product_design_area="
                                                design_area_data
                                            "
                                            :current_flip="active_flip"
                                            :gender_groups="gender_groups_items"
                                            :disabled="colors_validation != ''"
                                            :colors-validation="
                                                colors_validation
                                            "
                                        >
                                        </PrintAreaIcons>
                                    </div>
                                </div>
                                <div class="row slider_row">
                                    <!-- Slider -->
                                    <div class="col-md-6">
                                        <div
                                            class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color"
                                        >
                                            <div class="design_footer-flex">
                                                <div
                                                    class="col-md-12 slider_col"
                                                >
                                                    <ColorOwlCarousel
                                                        :user_selected_values="
                                                            user_selected_values
                                                        "
                                                        :build_item_id="
                                                            build_item_id
                                                        "
                                                        :activeColorIndex="
                                                            activeColorIndex
                                                        "
                                                        @set-canvas-color="
                                                            SetColorCanvas
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div
                                            class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color p-0"
                                        >
                                            <div
                                                class="col-md-12 artwork_colors pl-0"
                                            >
                                                <div
                                                    class="new_arts_color1"
                                                    v-show="
                                                        current_standard_colors.length >
                                                        0
                                                    "
                                                >
                                                    <label
                                                        >Standard Colors</label
                                                    >
                                                    <div
                                                        class="ui-palette-box mb_20 present_color"
                                                        style="
                                                            grid-template-columns: repeat(
                                                                auto-fill,
                                                                minmax(
                                                                    1.75rem,
                                                                    1fr
                                                                )
                                                            );
                                                            display: grid;
                                                            height: 28px;
                                                        "
                                                    >
                                                        <template
                                                            v-for="(
                                                                color, index
                                                            ) in current_standard_colors"
                                                        >
                                                            <div
                                                                :key="index"
                                                                v-if="
                                                                    color.hex !=
                                                                    tshirt_color
                                                                "
                                                                class="marign_color"
                                                                :style="
                                                                    'display: grid; background:' +
                                                                    color.hex +
                                                                    ';'
                                                                "
                                                                v-tooltip="{
                                                                    content:
                                                                        color.name
                                                                            ? `${color.name}<br/>${color.hex}`
                                                                            : color.hex,
                                                                    html: true
                                                                }"
                                                            ></div>
                                                        </template>
                                                    </div>
                                                    <div
                                                        v-if="
                                                            colors_validation &&
                                                            false
                                                        "
                                                        style="color: red"
                                                    >
                                                        {{ colors_validation }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-3 p-0">
                                        <div
                                            class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color p-0"
                                        >
                                            <div
                                                class="col-md-12 artwork_colors pl-0"
                                            >
                                                <div
                                                    class="new_arts_color1"
                                                    v-show="
                                                        total_non_standard_colors &&
                                                        total_non_standard_colors.length
                                                    "
                                                >
                                                    <label
                                                        v-if="
                                                            gender_groups_items[
                                                                active_gender_key
                                                            ].item
                                                                .decoration_type ==
                                                            1
                                                        "
                                                        >Total Custom Ink Mix
                                                        Colors ({{
                                                            icPriceFormat(
                                                                total_non_standard_fees
                                                            )
                                                        }})</label
                                                    >
                                                    <label
                                                        v-if="
                                                            gender_groups_items[
                                                                active_gender_key
                                                            ].item
                                                                .decoration_type ==
                                                            2
                                                        "
                                                        >Total Custom Thread
                                                        Colors ({{
                                                            icPriceFormat(
                                                                total_non_standard_fees
                                                            )
                                                        }})</label
                                                    >
                                                    <div
                                                        class="ui-palette-box mb_20 present_color"
                                                        style="
                                                            grid-template-columns: repeat(
                                                                auto-fill,
                                                                minmax(
                                                                    1.75rem,
                                                                    1fr
                                                                )
                                                            );
                                                            display: grid;
                                                            height: 28px;
                                                        "
                                                    >
                                                        <template
                                                            v-for="(
                                                                color, index
                                                            ) in total_non_standard_colors ||
                                                            []"
                                                        >
                                                            <div
                                                                :key="index"
                                                                v-if="
                                                                    color !=
                                                                    tshirt_color
                                                                "
                                                                class="marign_color"
                                                                v-tooltip="
                                                                    color
                                                                "
                                                                :style="
                                                                    'display: grid; background:' +
                                                                    color +
                                                                    ';'
                                                                "
                                                            ></div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div
                                            class="design_studio_footer design_studio_s design_studio_slider design_slider_with_color p-0"
                                        >
                                            <div
                                                class="col-md-12 artwork_colors pl-0"
                                            >
                                                <div
                                                    class="new_arts_color1"
                                                    v-show="
                                                        current_active_flip_colors &&
                                                        current_active_flip_colors.length
                                                    "
                                                >
                                                    <label
                                                        >Total Build Decoration
                                                        Colors ({{
                                                            this.toTitleCase(
                                                                active_flip
                                                            )
                                                        }})</label
                                                    >
                                                    <div
                                                        class="ui-palette-box mb_20 present_color"
                                                        style="
                                                            grid-template-columns: repeat(
                                                                auto-fill,
                                                                minmax(
                                                                    1.75rem,
                                                                    1fr
                                                                )
                                                            );
                                                            display: grid;
                                                            height: 28px;
                                                        "
                                                    >
                                                        <template
                                                            v-for="(
                                                                color, index
                                                            ) in prepareDecorationColors(
                                                                current_active_flip_colors
                                                            ) || []"
                                                        >
                                                            <div
                                                                :key="index"
                                                                v-if="
                                                                    color.hex !=
                                                                    tshirt_color
                                                                "
                                                                class="marign_color"
                                                                :style="
                                                                    'display: grid; background:' +
                                                                    color.hex +
                                                                    ';'
                                                                "
                                                                v-tooltip="{
                                                                    content:
                                                                        color.name
                                                                            ? `${color.name}<br/>${color.hex}`
                                                                            : color.hex,
                                                                    html: true
                                                                }"
                                                            ></div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="d-md-flex mt_20 cost_total_col outside_costs col-xl-2 col-md-6"
                    >
                        <div class="outside_costs_items">
                            <div class="quantity d-flex align-items-center">
                                <h4 class="font_size_22 mb-0 ml_10">Qty</h4>
                                <h3 class="font_size_35 mb-0 ml_10">
                                    {{
                                        gender_groups_items[active_gender_key]
                                            .total_qty
                                    }}
                                </h3>
                            </div>
                            <div
                                class="quantity d-flex align-items-center ml_10"
                            >
                                <h4 class="font_size_22 mb-0">Total Cost</h4>

                                <h3 class="font_size_35 mb-0 ml_10 d-flex">
                                    {{
                                        icPriceFormat(
                                            gender_groups_items[
                                                active_gender_key
                                            ].total_cost
                                        )
                                    }}
                                </h3>
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary v3-btn"
                                data-toggle="modal"
                                data-target="#itemDetailsModal"
                            >
                                Colors & Qty Details
                            </button>
                        </div>
                        <div class="design_studio_btns outer_btns">
                            <div class="save_btn">
                                <button
                                    v-if="colors_validation == ''"
                                    class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn"
                                    style="
                                        max-width: 80%;
                                        background: 0% 0% no-repeat padding-box
                                            rgb(35, 132, 204) !important;
                                    "
                                    @click="save_all_design()"
                                >
                                    {{
                                        build_item_id ? "EDIT/SAVE" : "ADD/SAVE"
                                    }}
                                    THE BUILD
                                </button>
                                <button
                                    v-else
                                    class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn"
                                    style="
                                        max-width: 80%;
                                        background: 0% 0% no-repeat padding-box
                                            rgb(35, 132, 204) !important;
                                    "
                                    disabled
                                >
                                    {{
                                        build_item_id ? "EDIT/SAVE" : "ADD/SAVE"
                                    }}
                                    THE BUILD
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="design_studio_drawer modal fade drawer right-align"
                        id="itemDetailsModal"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                    >
                        <div class="drawer_modal">
                            <div
                                class="modal-dialog main_dialog_drawer"
                                role="document"
                            >
                                <div class="modal-content">
                                    <div class="modal-header drawer_header">
                                        <button
                                            type="button"
                                            class="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true"
                                                >&times;</span
                                            >
                                        </button>
                                    </div>
                                    <div
                                        class="back_front_t-shirt right_sec_design_studio_t_shirt direction_block"
                                    >
                                        <div class="right_section_main">
                                            <div class="modal-body">
                                                <ItemDetails
                                                    ref="ItemDetails"
                                                    :product-id="product_id"
                                                    :product="product_items"
                                                    :tshirt-sides="tshirtSides"
                                                    :imprint-locations="
                                                        user_selected_values[
                                                            parseInt(
                                                                activeColorIndex
                                                            )
                                                        ].imprint_locations
                                                    "
                                                    :gender-groups="
                                                        gender_groups_items
                                                    "
                                                    :vendor-colors="
                                                        vendor_colors_list
                                                    "
                                                    :active-color-index="
                                                        activeColorIndex
                                                    "
                                                    :decoration-colors="
                                                        design_current_colors
                                                    "
                                                    :all-decoration-colors="
                                                        all_decoration_colors
                                                    "
                                                    :total-non-standard-fees="
                                                        total_non_standard_fees
                                                    "
                                                    :non-standard-fee-per-color="
                                                        non_standard_fee_per_color
                                                    "
                                                    :total-non-standard-colors="
                                                        total_non_standard_colors
                                                    "
                                                    :addToCart="addToCart"
                                                    :saveNewDesigns="
                                                        saveNewDesigns
                                                    "
                                                    :updatePrintAreas="
                                                        updatePrintAreas
                                                    "
                                                    :canvasDesignsStatus="
                                                        canvas_designs_status
                                                    "
                                                    :colorsValidation="
                                                        colors_validation
                                                    "
                                                    :colorsCount="colors_count"
                                                    :buildItemId="build_id"
                                                    :editable="false"
                                                    @updateNameAndNumbers="
                                                        changeNameAndNumbersAfterQtyUpdate
                                                    "
                                                    :selected-rush-option-id="selectedRushOptionId"
                                                    :vendor-services="vendorServices"
                                                />
                                            </div>
                                            <div class="modal-footer">
                                                <div class="design_studio_btns">
                                                    <div class="save_btn">
                                                        <button
                                                            data-toggle="modal"
                                                            v-if="
                                                                colors_validation ==
                                                                ''
                                                            "
                                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn"
                                                            style="
                                                                max-width: 80%;
                                                                background: 0%
                                                                    0% no-repeat
                                                                    padding-box
                                                                    rgb(
                                                                        35,
                                                                        132,
                                                                        204
                                                                    ) !important;
                                                            "
                                                            @click="
                                                                save_all_design()
                                                            "
                                                        >
                                                            {{
                                                                build_item_id
                                                                    ? "EDIT/SAVE"
                                                                    : "ADD/SAVE"
                                                            }}
                                                            THE BUILD
                                                        </button>
                                                        <button
                                                            data-toggle="modal"
                                                            v-else
                                                            class="btn btn_orange bg_primary_orange text_white w-100 mt_10 mb_10 btn_h60 save-blue-btn"
                                                            style="
                                                                max-width: 80%;
                                                                background: 0%
                                                                    0% no-repeat
                                                                    padding-box
                                                                    rgb(
                                                                        35,
                                                                        132,
                                                                        204
                                                                    ) !important;
                                                            "
                                                            disabled
                                                        >
                                                            {{
                                                                build_item_id
                                                                    ? "EDIT/SAVE"
                                                                    : "ADD/SAVE"
                                                            }}
                                                            THE BUILD
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 p-0">
                        <div class="design_studio_footer" style="display: none">
                            <!-- slider start -->
                            <div class="design_footer-flex">
                                <div class="col-md-8 col-lg-4"></div>

                                <!-- right sec start -->
                                <div class="col-md-12 col-lg-8">
                                    <div class="rgt_design_studios"></div>
                                </div>
                                <!-- right sec end -->
                            </div>

                            <!-- slider end -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Share Modal -->
        <div
            class="modal login-form-popup fade h-auto"
            id="share_design_modal"
            tabindex="-1"
            aria-labelledby="design-studio"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            @click="copied = false"
                            id="popup-close"
                            data-dismiss="modal"
                            class="popup-close"
                            data-original-title=""
                            title=""
                            ><img src="/maincss/images/cancel.svg" alt=" "
                        /></a>
                        <input
                            type="text"
                            id="share_link_input"
                            readonly
                            :value="shareable_link"
                            class="form-control"
                        />
                        <div class="my_30 d-flex justify-content-center">
                            <button
                                type="button"
                                v-if="!copied"
                                @click="copyClipboard"
                                class="btn btn_orange bg_primary_orange text_white"
                            >
                                Copy Link
                            </button>
                            <button
                                type="button"
                                v-else
                                class="btn btn_orange bg_primary_orange text_white"
                            >
                                Copied
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Saved Design Modal -->
        <div
            class="modal login-form-popup fade h-auto"
            id="save_design_modal"
            tabindex="-1"
            aria-labelledby="design-studio"
            data-backdrop="static"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable design_build_modal"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{
                                saved_type != "cart"
                                    ? "Save Design/Build"
                                    : "Save Design"
                            }}
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        method="post"
                        @submit.prevent="save_all_design"
                        data-vv-scope="addshapeform"
                    >
                        <div class="modal-body">
                            <div v-if="saved_type != 'cart'">
                                <label for="inputPassword5"
                                    >Select Item Type</label
                                >
                                <br />
                                <div
                                    class="custom-control custom-radio custom-control-inline"
                                >
                                    <input
                                        type="radio"
                                        id="single"
                                        v-model="saved_design.item_type"
                                        :value="'single'"
                                        name="single"
                                        class="custom-control-input"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="single"
                                        >Single Item</label
                                    >
                                </div>
                                <div
                                    class="custom-control custom-radio custom-control-inline"
                                >
                                    <input
                                        type="radio"
                                        id="build"
                                        v-model="saved_design.item_type"
                                        :value="'build'"
                                        name="build"
                                        class="custom-control-input"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="build"
                                        >Multiple Item Application (Create a
                                        Build)</label
                                    >
                                </div>
                            </div>
                            <div class="">
                                <label for="inputPassword5"
                                    >Enter Title Name</label
                                >
                                <input
                                    type="text"
                                    v-model="saved_design.name"
                                    name="Design name"
                                    required="required"
                                    placeholder="Enter Title Name"
                                    value=""
                                    class="form-control"
                                />

                                <small
                                    class="form-text text-error text-left"
                                    v-show="
                                        errors.has('addshapeform.Design name')
                                    "
                                >
                                    {{
                                        errors.first("addshapeform.Design name")
                                    }}
                                </small>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn_white border border-primary text_blue mt_20 mb_10 btn_h60"
                                data-dismiss="modal"
                            >
                                CANCEL
                            </button>
                            <button
                                type="submit"
                                class="add_cart btn btn_orange bg_primary_orange text_white mt_20 mb_10 btn_h60"
                                data-original-title=""
                                title=""
                            >
                                save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- reset popup start -->
        <div
            id="reset_popup"
            tabindex="-1"
            aria-labelledby="login"
            data-keyboard="false"
            data-backdrop="static"
            class="modal login-form-popup fade h-auto"
            aria-modal="true"
            role="dialog"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            id="popup-close"
                            data-dismiss="modal"
                            class="popup-close"
                            ><img src="/maincss/images/cancel.svg" alt=" "
                        /></a>
                        <div class="login-form">
                            <h3>Warning!</h3>
                            <p class="m-0">
                                Are you sure want to reset your design
                            </p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center my_20"
                        >
                            <a
                                href="Javascript:void(0);"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46 mr_8 mb_10"
                                @click="clearDesigns()"
                                >Reset Design</a
                            >
                            <a
                                href="Javascript:void(0);"
                                data-dismiss="modal"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_64 ml_8 mb_10"
                                >Keep Design</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- reset popup end  -->

        <!-- Model for sleeve design area Start -->
        <div
            id="show_sleeve"
            tabindex="-1"
            aria-labelledby="login"
            data-keyboard="false"
            data-backdrop="static"
            class="modal login-form-popup fade h-auto"
            aria-modal="true"
            role="dialog"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="basicModalLabel3">
                            Sleeve Design Area
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <img
                                src="/maincss/images/cancel.svg"
                                alt="Cancel Button"
                            />
                        </button>
                    </div>
                    <div class="modal-body img-popup-body">
                        <div class="login-form">
                            <div class="design_area_right_side_image_popup">
                                <fabric-canvas
                                    :id="`1122334455`"
                                    :height="defaultHeightCanvas"
                                    :width="defaultWidthCanvas"
                                    :stateful="true"
                                    @canvas-updated="canvasBackSleeveUpdated"
                                    @object-scaling="objScaling"
                                    @object-moving="objMoving"
                                >
                                    <fabric-background-image
                                        :id="`34566788`"
                                        :url="background_image"
                                        :scaleX="defaultWidthCanvas / imgWidth"
                                        :scaleY="
                                            defaultHeightCanvas / imgHeight
                                        "
                                        @image-loaded="imageLoaded"
                                    >
                                    </fabric-background-image>
                                </fabric-canvas>
                            </div>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-center my_20"
                        >
                            <a
                                href="#"
                                data-dismiss="modal"
                                class="btn btn-outline-primary bg_white mr_20"
                                >OK</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Model for design area end -->

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
                <span class="load-value" v-if="popup_sync_count > 0"
                    >{{ popup_sync_count }} %
                </span>
            </div>
        </div>

        <!-- START DESIGNING POPUP -->
        <div
            class="modal fade h-auto login-form-popup"
            id="design-confirmation-modal"
            tabindex="-1"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered upload-artwork">
                <div class="modal-content">
                    <div class="modal-body">
                        <a
                            href="#"
                            class="popup-close art_poup_close"
                            id="popup-close"
                            data-dismiss="modal"
                        >
                            <img
                                src="/maincss/images/cancel.svg"
                                v-tooltip="'Close'"
                                alt=" "
                            />
                        </a>
                        <div class="login-form">
                            <h5 class="mb_40">
                                Do you want to design more colors?
                            </h5>
                            <div class="upload_design">
                                <div
                                    class="d-flex justify-content-center mb_20 start_design_btn_box"
                                >
                                    <button
                                        class="btn btn_orange bg_primary_orange text_white mx_6"
                                        type="button"
                                        @click="changeTshirtColor()"
                                    >
                                        Continue
                                    </button>
                                    <a
                                        href="javascript:void(0)"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue mx_6"
                                        data-dismiss="modal"
                                        >Cancel</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonData from "@/common/common.data";
import { mapGetters } from "vuex";
import { fabric } from "fabric";
import vueFabricWrapper from "vue-fabric-wrapper";
import ApiService from "@/common/api.service";
import ColourPicker from "@/components/ColourPicker";
import AddText from "@/components/DesignerTool/AddText/AddTextV3";
import ClipSetting from "@/components/DesignerTool/ClipSetting/ClipSettingV3";
import NameAndNumber from "@/components/DesignerTool/NameAndNumber/v3/NameAndNumber";
import DistressImageList from "@/components/DesignerTool/components/DistressImageList.vue";
import LeftMenus from "../V3/DesignStudioLeftMenus.vue";
import ColorOwlCarousel from "@/components/DesignerTool/ColorOwlCarousel";
import Dashboard from "@/components/design_studio/v3/Dashboard";
import MyDesigns from "@/components/design_studio/v3/MyDesignsV3";
import PrintAreaIcons from "@/components/design_studio/v3/PrintAreaIcons";
import ItemDetails from "@/components/design_studio/v3/ItemDetails";

var canvas;

var listLine = [];

fabric.Group.prototype.toObject = (function (toObject) {
    return function () {
        return fabric.util.object.extend(toObject.call(this), {
            ctype: "",
            iextension: "",
            image_name: "",
            image_path: "",
            width_inch: "",
            height_inch: ""
        });
    };
})(fabric.Group.prototype.toObject);
var design_tool = {
    name: "design-studio-build",
    async beforeRouteLeave(to, from, next) {
        let _this = this;

        if (from.name == "DesignStudio" && from.name != "product_details") {
            let designStatus = false;
            let previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if ("front" in previouscanvasList) {
                    JSON.parse(previouscanvasList["front"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
                if ("back" in previouscanvasList) {
                    JSON.parse(previouscanvasList["back"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
                if ("left" in previouscanvasList) {
                    JSON.parse(previouscanvasList["left"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
                if ("right" in previouscanvasList) {
                    JSON.parse(previouscanvasList["right"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
            }
            if (designStatus) {
                if (!_this.skip_leave_confirm_box) {
                    _this.$dialog
                        .confirm(
                            "Leave Design Studio? Changes made may not be saved.",
                            {
                                okText: "Yes",
                                cancelText: "No"
                            }
                        )
                        .then(async function () {
                            next();
                        })
                        .catch(function () {
                            next(false);
                        });

                    _this.skip_leave_confirm_box = false;
                } else {
                    next();
                }
            } else {
                next();
            }
        } else {
            next();
        }
    },
    components: {
        "colour-picker": ColourPicker,
        AddText: AddText,
        ClipSetting: ClipSetting,
        NameAndNumber: NameAndNumber,
        DistressImageList: DistressImageList,
        FabricCanvas: vueFabricWrapper.FabricCanvas,
        FabricImageFromURL: vueFabricWrapper.FabricImageFromURL,
        FabricRectangle: vueFabricWrapper.FabricRectangle,
        FabricGroup: vueFabricWrapper.FabricGroup,
        FabricBackgroundImage: vueFabricWrapper.FabricBackgroundImage,
        LeftMenus: LeftMenus,
        ColorOwlCarousel: ColorOwlCarousel,
        Dashboard: Dashboard,
        MyDesigns: MyDesigns,
        PrintAreaIcons,
        ItemDetails
    },
    emits: ["closeMenu"],
    data() {
        return {
            isLoader: false,
            selectImageProps: { rotation: 0 },
            tshirtImage: "", //frontside image of tshirt
            selected_template_category_show: true, //to show templates category
            selected_template_subcategory_show: false,
            selected_template_subcategory: { template_images: [] },
            selected_custom_template_show: false, //to show custom template
            // saved_template_category: true, //to show saved template
            selected_clipart_category_show: true, //to show clipart category
            category_heading: true, //to show category heading
            edit_template: false, //to enable template edit option
            selected_category_heading: false, //to selected category heading
            selected_template_category: [],
            selected_custom_template: [], //selected template category array
            selected_clipart_category: [], //selected clipart category array
            template_search_query: null, //template search input value
            template_subcategory_search_query: null,
            clipart_search_query: null, //clipart search input value
            design_search_query: null, //saved designs search input value
            template_name: "", //selected template name
            clipart_name: "", //selected clipart name
            active_class: "active", //genders tab active class
            uploadImages: [], //array of images that are going to upload
            image_width: null, //width of cropped image
            image_height: null, //height of cropped image
            image_size: null, //size of cropped image
            uploaded_design_image: null,
            uploadedImages: [], //array of uploaded images from  DB
            savedDesigns: [], //array of saved designs from DB
            step: 1, //step count for name&numbers
            text: "", //text variable for Add text
            genders: [], //selected genders array from product details page
            user_selected_values: [], //values from product details
            active_gender: "", //current active gender tab
            active_gender_key: 0, //current active gender key value
            canvas_elements: [], //canvas objects array
            templates: [], //templates array from DB
            cliparts: [], //clipart array from DB
            shapes: [], //shapes array from DB
            patches: [], //pathces array from DB
            product_items: [], //product details array
            design_name: "", //name of the design
            dataURL: null, //dataurl of design,going to save
            product_title: "", //product title on home page
            product_number: "", //product number on home page
            product_id: "", //product Id
            base_price: "", //base_price on home page
            design_count: 0, //My designs count
            apiurl: ApiService.apiUrl(), //api url
            croppieImage: "", //cropped image
            crop_image_validation: 0, //cropped image validation
            image_size_validation: 0, //uploaded image size validation
            zoom: 1, //zoom level
            zoom_in: 0, //zoom in step
            zoom_out: 1, //zoom out step
            text_shape: false, //enable text shape tab in Add text
            add_text: true, //enable add text tab in Add text
            active_flip: "back", //active T-shirt side
            canvasList: { front: "" },
            textData: {},
            selectedType: "", //
            clipart_category: [], //clipart subcategory
            clipart_subcategory_div: false, //clipart subcategory div flag
            clipart_category_div: false, //clipart category div flag
            clipart_subcategory_search_query: null,
            clipart_category_name: "", //selected clipart category name
            imgHeight: 1,
            imgWidth: 1,
            backCanvas: null,
            saved_design: {
                name: null,
                item_type: "single",
                product_id: "",
                user_id: "",
                canvas_json: [],
                design_json: [],
                status: 1,
                save_canvas_images: "",
                canvas_design_colors: ""
            },
            build_canvas_design_colors: [],
            current_active_flip_colors: [],
            product_all_colors: [],
            activeIndex: undefined,
            activeColorIndex: undefined,
            saved_design_list: [],
            design_tab_active: false,
            saved_Template_design_list: [],
            save_design_button: true,
            add_distress_images: true,
            current_design_id: null,
            current_template_id: null,
            distress_images: { front: "" },
            shareable_link: null,
            copied: false,
            disable_tshirt_canvas: false,
            design_area_data: "",
            front_show: "",
            selectedRushOptionId: null,
            vendorServices: [],
            back_show: "",
            left_show: "",
            right_show: "",
            background_image: "/maincss/design-studio/img/crew_front.png",
            background_image_sleeve:
                "/maincss/design-studio/img/crew_front.png",
            front_canvas_height: 0,
            front_canvas_width: 0,
            front_canvas_top: "",
            front_canvas_left: "",
            front_canvas_angle: 0,
            saved_json_data: null,
            selectedCheckbox: false,
            backSleeveCanvas: null,
            popup_canvas_height: 0,
            popup_canvas_width: 0,
            popup_canvas_top: "",
            popup_canvas_left: "",
            uploaded_image_name: "",
            selectedDistressImage: "",
            show_popular_cliparts: false,
            show_popular_templates: false,
            selected_object_colors: [],
            vendor_colors_list: [],
            design_box: "",
            cart_save_design: false,
            all_templates_images: [],
            all_cliparts_images: [],
            is24Tshirt: false,
            imageCanvas: "",
            cart_status: "",
            undo: [],
            redo: [],
            state: [],
            undoRedoData: null,
            undoObject: 0,
            undoActive: false,
            redoActive: false,
            firstImageActive: 0,
            uploadModuleCanvas: 0,
            imagesSelectedCanvasType: "",
            removeBackCanvas: true,
            front_icon_canvas_type:
                "/maincss/design-studio/img/tshirt_front.png",
            back_icon_canvas_type: "/maincss/design-studio/img/tshirt_back.png",
            left_icon_canvas_type: "/maincss/design-studio/img/lft_sl.png",
            right_icon_canvas_type: "/maincss/design-studio/img/rgt_slv.png",
            save_design_images: "",
            only_save_designs: false,
            active_product_type: "",
            rotationAngle: 0,
            defaultWidthCanvas: 530,
            defaultHeightCanvas: 630,
            sideBarCanvasStatus: true,
            front_canvas_images: [],
            design_current_colors: [],
            popup_sync_count: 0,
            skip_leave_confirm_box: false,
            current_print_area: "",
            front_canvas_width_inch: "",
            front_canvas_height_inch: "",
            canvas_designs_status: false,
            tshirt_color: "",
            design_area_inches: [],
            colors_count: 0,
            colors_validation: "",
            selected_clipart_category_id: "",
            vinyl_color_list: [],
            total_non_standard_colors: [],
            total_non_standard_fees: 0,
            current_standard_colors: [],
            gender_groups_items: [],
            all_decoration_colors: {},
            tshirtSides: ["front", "back", "left", "right"],
            saved_type: "",
            build_id: null,
            build_item_id: null,
            first_build_item_id: null,
            page_loaded: false,
            disabled_styles: {
                "pointer-events": "none !important",
                color: "#bfcbd9 !important",
                cursor: "not-allowed !important",
                "background-image": "none !important",
                "background-color": "#eef1f6 !important",
                "border-color": "#d1dbe5 !important"
            },
            total_build_items: 0,
            showNameNumber: false,
            non_standard_fee_per_color: 0,
            printAreaBond: null
        };
    },
    // computed: {
    //     ...mapGetters([
    //         "isAuthenticatedClient",
    //         "currentUserClient",
    //         "adminOptions"
    //     ]),
    //     tag() {
    //         return this.$route.params.tag;
    //     }
    // },
    // beforeDestroy() {
    //     document.removeEventListener("keydown", this.controlUndoRedoObject);
    // },
    methods: {
        triggerLoader(currentStatus) {
            this.isLoader = currentStatus;
            this.prepareImprintLocations();
        },
        checkObjectCanvas() {
            let designStatus = false;
            let previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if (
                    "front" in previouscanvasList &&
                    JSON.parse(previouscanvasList["front"]).objects
                ) {
                    JSON.parse(previouscanvasList["front"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
                if (
                    "back" in previouscanvasList &&
                    JSON.parse(previouscanvasList["back"]).objects
                ) {
                    JSON.parse(previouscanvasList["back"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
                if (
                    "left" in previouscanvasList &&
                    previouscanvasList["left"]
                ) {
                    JSON.parse(previouscanvasList["left"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
                if (
                    "right" in previouscanvasList &&
                    previouscanvasList["right"]
                ) {
                    JSON.parse(previouscanvasList["right"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                designStatus = true;
                            }
                        }
                    );
                }
            }
            this.canvas_designs_status = designStatus;
            return designStatus;
        },
        getPrintAreaParent(print_area) {
            this.current_print_area = print_area;
            // Object.values(this.current_print_area).forEach((element) => {
            // this.design_area_inches.push({
            //     label:element.label,
            //     widthIn : element.widthIn,
            //     heightIn : element.heightIn
            //   });
            // });
            let currentFlip =
                this.active_flip.charAt(0).toUpperCase() +
                this.active_flip.slice(1);
            let currentData = this.current_print_area.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });
            let productData = this.design_area_data.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });
            this.front_canvas_width_inch =
                productData.length > 0
                    ? parseFloat(productData[0].widthIn)
                    : parseFloat(currentData[0].widthIn);
            this.front_canvas_height_inch =
                productData.length > 0
                    ? parseFloat(productData[0].heightIn)
                    : parseFloat(currentData[0].heightIn);
        },
        siderBarChange(e) {
            let _this = this;
            if (e && _this.sideBarCanvasStatus) {
                if (
                    typeof e == "object" &&
                    ("target" in e || "deselected" in e)
                ) {
                    let selectedObject =
                        "target" in e ? e.target : e.deselected[0];
                    if (selectedObject.type == "text") {
                        document
                            .querySelector("#add-" + selectedObject.type)
                            .classList.remove("active");
                        document
                            .querySelector("#add-" + selectedObject.type)
                            .classList.remove("show");
                        document
                            .querySelector(
                                "#add-" + selectedObject.type + "-tab"
                            )
                            .classList.remove("active");
                    } else if (
                        selectedObject.ctype === "clipart" ||
                        selectedObject.ctype === "templates" ||
                        selectedObject.ctype === "shape" ||
                        selectedObject.ctype === "patch" ||
                        selectedObject.ctype === "upload"
                    ) {
                        if (selectedObject.ctype === "upload") {
                            document
                                .querySelector("#" + selectedObject.ctype)
                                .classList.remove("active");
                        } else {
                            document
                                .querySelector("#add-" + selectedObject.ctype)
                                .classList.remove("active");
                            document
                                .querySelector("#add-" + selectedObject.ctype)
                                .classList.remove("show");
                        }
                        document
                            .querySelector(
                                "#add-" + selectedObject.ctype + "-tab"
                            )
                            .classList.remove("active");
                    }
                }
                if (document.querySelector(".deleteBtn")) {
                    document.querySelector(".deleteBtn").remove();
                    document.querySelector(".rotationBtn").remove();
                    document.querySelector(".rotationBtn").remove();
                }
                document.querySelector("#default1").classList.add("active");
                document.querySelector("#default1").classList.add("show");
            }
            _this.sideBarCanvasStatus = true;
        },
        changeTshirtColor() {
            let _this = this;
            let previousColorIndex =
                localStorage.getItem("colorIndex") != null
                    ? parseInt(localStorage.getItem("colorIndex")) + 1
                    : 0;
            if (
                previousColorIndex ==
                parseInt(_this.user_selected_values.length)
            ) {
                previousColorIndex = 0;
            }
            _this.activeIndex =
                _this.user_selected_values[previousColorIndex].color_id;
            localStorage.setItem("colorIndex", previousColorIndex);
            _this.activeColorIndex = previousColorIndex;
            _this.flipTshirt(_this.active_flip);
            /* eslint-disable */
            $("#design-confirmation-modal").modal("hide");
            /* eslint-enable */
        },
        setUrl(url) {
            if (url.includes("http://") || url.includes("https://")) {
                return url;
            }

            return this.apiurl + url;
        },
        activeFrontType(event) {
            this.disable_tshirt_canvas = event;
        },
        disableResetBtn() {
            let _this = this;
            /* eslint-disable */
            if (_this.backCanvas._objects.length <= 1) {
                $("#newResetbtn").prop("disabled", true);
            } else {
                $("#newResetbtn").prop("disabled", false);
            }
            /* eslint-enable */
        },
        saveCanvasData() {
            var _this = this;
            // clear the redo stack
            /* eslint-disable */
            if (_this.redo.length == 0)
                $("#redoObj").prop("disabled", true).removeClass("active");
            $(".new_arts_color").removeClass("d-none");
            // initial call won't have a state
            if (_this.state.length) {
                // _this.undo.push(_this.state);
                let keys = localStorage.getItem("active_flip");
                var obj = {};
                obj[keys] = _this.state;
                _this.undo.push(obj);
                $("#undoObj").prop("disabled", false).addClass("active");
            }
            /* eslint-enable */
            _this.disableResetBtn();
            _this.state = JSON.stringify(_this.backCanvas);
        },
        replay(playStack, saveStack, buttonsOn, buttonsOff) {
            var _this = this;
            /* eslint-disable */
            var obj = {};
            if (saveStack.length == 0 && this.undoObject == 0) {
                let keys = localStorage.getItem("active_flip");
                obj[keys] = _this.state;
                saveStack.push(obj);
                this.undoObject++;
            } else {
                if (
                    _this.state.hasOwnProperty("front") ||
                    _this.state.hasOwnProperty("back") ||
                    _this.state.hasOwnProperty("left") ||
                    _this.state.hasOwnProperty("right")
                ) {
                    saveStack.push(_this.state);
                } else {
                    let keys = localStorage.getItem("active_flip");
                    obj[keys] = _this.state;
                    saveStack.push(obj);
                }
            }
            _this.state = playStack.pop();
            var on = $(buttonsOn);
            var off = $(buttonsOff);
            /* eslint-enable */
            // turn both buttons off for the moment to prevent rapid clicking
            on.prop("disabled", true).removeClass("active");
            off.prop("disabled", true).removeClass("active");
            let objt = 0;
            if (_this.state) {
                objt = Object.keys(_this.state);
            }

            let k = playStack[playStack.length - 1];
            // here change canvas area for undo
            if (k && _this.undoActive) {
                _this.flipTshirt(Object.keys(k)[0]);
            }
            if (_this.redoActive) {
                // here change canvas area for redo

                let p = saveStack[saveStack.length - 1];
                if (p) {
                    _this.flipTshirt(Object.keys(p)[0]);
                    // return;
                }
            }
            _this.backCanvas.clear();
            //_this.backCanvas.renderAll();
            if (objt[0] == 0 || objt == 0) {
                if (JSON.parse(_this.state).objects.length > 0) {
                    let stateData = JSON.parse(_this.state);
                    stateData.objects.map(function (val, key) {
                        if (val.type == "rect") {
                            stateData.objects[key]["selectable"] = false;
                            stateData.objects[key]["evented"] = false;
                        }
                    });
                    _this.state = JSON.stringify(stateData);
                }

                fabric.util.enlivenObjects(
                    JSON.parse(_this.state).objects,
                    function (objects) {
                        objects.forEach(function (o) {
                            let type1 = o.ctype;
                            let objType1 = o.objType;
                            let extension = o.iextension;
                            let product_id = o.product_id;
                            o.toObject = (function (toObject) {
                                return function () {
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        {
                                            ctype: type1,
                                            objType: objType1,
                                            image_name: o.image_name,
                                            image_path: o.image_path,
                                            width_inch: o.width_inch,
                                            height_inch: o.height_inch,
                                            iextension: extension,
                                            product_id: product_id
                                        }
                                    );
                                };
                            })(o.toObject);
                            _this.backCanvas.add(o);
                        });

                        _this.backCanvas.renderAll();
                        // now turn the buttons back on if applicable
                        on.prop("disabled", false).addClass("active");

                        if (playStack.length) {
                            off.prop("disabled", false).addClass("active");
                        }
                    }
                );
                // EnlivenObjects instead of loadFromJSON in fabric js

                saveStack = [];
                return;
            }
            let overlay_img_status = false;
            if (JSON.parse(_this.state[objt[0]]).objects.length > 0) {
                let stateData = JSON.parse(_this.state[objt[0]]);
                stateData.objects.map(function (val, key) {
                    if (val.type == "rect") {
                        stateData.objects[key]["selectable"] = false;
                        stateData.objects[key]["evented"] = false;
                    }
                });
                if (!("overlayImage" in stateData)) {
                    overlay_img_status = true;
                }
                _this.state[objt[0]] = JSON.stringify(stateData);
            }

            // EnlivenObjects instead of loadFromJSON in fabric js
            fabric.util.enlivenObjects(
                JSON.parse(_this.state[objt[0]]).objects,
                function (objects) {
                    objects.forEach(function (o) {
                        let type1 = o.ctype;
                        let objType1 = o.objType;
                        let extension = o.iextension;
                        let product_id = o.product_id;
                        o.toObject = (function (toObject) {
                            return function () {
                                return fabric.util.object.extend(
                                    toObject.call(this),
                                    {
                                        ctype: type1,
                                        objType: objType1,
                                        image_name: o.image_name,
                                        image_path: o.image_path,
                                        width_inch: o.width_inch,
                                        height_inch: o.height_inch,
                                        iextension: extension,
                                        product_id: product_id
                                    }
                                );
                            };
                        })(o.toObject);
                        _this.backCanvas.add(o);
                    });
                    if (overlay_img_status) {
                        _this.backCanvas.overlayImage = null;
                        _this.distress_images[objt[0]] = "";
                        overlay_img_status = false;
                    }
                    _this.backCanvas.renderAll();
                    // now turn the buttons back on if applicable
                    on.prop("disabled", false).addClass("active");

                    if (playStack.length) {
                        off.prop("disabled", false).addClass("active");
                    }
                }
            );
        },
        controlUndoRedoObject(e) {
            var _this = this;
            if (
                !(
                    (e.keyCode === 90 && e.ctrlKey) ||
                    (e.keyCode === 89 && e.ctrlKey)
                )
            ) {
                return;
            }
            e.preventDefault();
            // Check pressed button is Z - Ctrl+Z.
            if (e.keyCode === 90 && e.ctrlKey && _this.undo.length > 0) {
                _this.undoActive = true;
                _this.redoActive = false;
                _this.replay(_this.undo, _this.redo, "#redoObj", this);
            }
            /* eslint-disable */
            if (_this.undo.length == 0) {
                $("#undoObj").prop("disabled", true);
                $("#undoObj").removeClass("active");
                $("#redoObj").prop("disabled", false);
                $("#redoObj").addClass("active");
                $("#newResetbtn").prop("disabled", true);
                $(".new_arts_color").addClass("d-none");
            }
            // Check pressed button is Y - Ctrl+Y.
            if (e.keyCode === 89 && e.ctrlKey && _this.redo.length > 0) {
                _this.undoActive = false;
                _this.redoActive = true;
                _this.replay(_this.redo, _this.undo, "#undoObj", this);
                $(".new_arts_color").removeClass("d-none");
                $("#newResetbtn").prop("disabled", false);
            }
            if (_this.redo.length == 0) {
                $("#redoObj").prop("disabled", true);
                $("#redoObj").removeClass("active");
                $("#undoObj").prop("disabled", false);
                $("#undoObj").addClass("active");
            }
            /* eslint-enable */
        },
        objectClone(ev) {
            var _this = this;
            // function to check the detection
            ev = ev || window.event; // Event object 'ev'
            // ev.preventDefault();
            var key = ev.which || ev.keyCode; // Detecting keyCode

            // Detecting Ctrl
            var ctrl = ev.ctrlKey ? ev.ctrlKey : key === 17 ? true : false;

            var activeObject = _this.backCanvas.getActiveObject();
            if ((key == 86 && ctrl) || key === 46) {
                if (!activeObject) {
                    _this.$toast.error("Please select object in Canvas", {
                        position: "top-right",
                        queue: true
                    });
                    return;
                }
            }
            // If key pressed is V and if ctrl is true.
            if (key == 86 && ctrl && activeObject) {
                activeObject.clone(function (cobj) {
                    cobj.set("top", cobj.top + 20);
                    cobj.set("left", cobj.left + 20);
                    _this.backCanvas.add(cobj);
                    _this.backCanvas.renderAll();
                });
                _this.$toast.success("Object cloned successfully.", {
                    position: "top-right",
                    queue: true
                });
            }
            if (key === 46) {
                if (activeObject) {
                    _this.delete_object();
                    _this.$toast.success("Object deleted successfully.", {
                        position: "top-right",
                        queue: true
                    });
                }
            }
        },
        resetElements(type = null) {
            var front_select_canvas = document.querySelector("#nn-tab1");
            var isActives = front_select_canvas.classList.contains("active");
            /* eslint-disable */
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            $(".front").removeClass("active");
            $(".left").removeClass("active");
            $(".right").removeClass("active");
            $(".back").removeClass("active");
            $(".nav-link.active").removeClass("active");
            $(".main_panel_check.show.active")
                .removeClass("show")
                .removeClass("active");
            $("#default1").addClass("active").addClass("show");
            if (isActives && (type == "front" || type == "back")) {
                $("#default1").removeClass("active").removeClass("show");
                document.querySelector("#nn-tab").classList.add("active");
                document.querySelector("#nn-tab").classList.add("show");
                document.querySelector("#nn-tab1").classList.add("active");
                this.selectedCheckbox = false;
                this.$refs.nameAndNumberRef.removeSelections();
                this.$refs.nameAndNumberRef.enableName();
                if (type == "front") {
                    this.$refs.nameAndNumberRef.disableName();
                }
                // this.$refs.nameAndNumberRef.enableNameAndNumber();
            } else {
                // this.$refs.nameAndNumberRef.disableNameAndNumber();
                document.querySelector("#nn-tab").classList.remove("active");
                document.querySelector("#nn-tab").classList.remove("show");
            }
            /* eslint-enable */
        },
        addDesignArea() {
            let _this = this;
            if (
                (_this.active_flip == "front" || _this.active_flip == "back") &&
                !this.cart_save_design
            ) {
                let square = new fabric.Rect({
                    width: _this.front_canvas_width,
                    height: _this.front_canvas_height,
                    left: _this.front_canvas_left,
                    top: _this.front_canvas_top,
                    angle: _this.front_canvas_angle,
                    //fill: 'rgba(0,0,0,0)',
                    fill: "transparent",
                    //fill: '#ff0000',
                    // opacity: 0.1,
                    absolutePositioned: true,
                    stroke: "black",
                    strokeDashArray: [5, 5],
                    //borderDashArray: [5],
                    strokeWidth: 3,
                    selectable: false,
                    evented: false
                });
                let square_light = new fabric.Rect({
                    width: _this.front_canvas_width,
                    height: _this.front_canvas_height,
                    left: _this.front_canvas_left,
                    top: _this.front_canvas_top,
                    angle: _this.front_canvas_angle,
                    //fill: 'rgba(0,0,0,0)',
                    fill: "transparent",
                    //fill: '#ff0000',
                    // opacity: 0.1,
                    absolutePositioned: true,
                    stroke: "white",
                    strokeDashArray: [5, 5],
                    //borderDashArray: [5],
                    strokeWidth: 1,
                    selectable: false,
                    evented: false
                });
                _this.design_box = square;

                if (_this.backCanvas._objects.length > 0) {
                    _this.backCanvas._objects.forEach((canvas_obj) => {
                        if (canvas_obj.type != "rect") {
                            _this.backCanvas.add(square);
                            _this.backCanvas.add(square_light);
                        } else {
                            _this.backCanvas.add(canvas_obj);
                        }
                    });
                } else {
                    _this.backCanvas.add(square);
                    _this.backCanvas.add(square_light);
                }
                _this.backCanvas.renderAll();
            }
        },
        showDesignSleeve() {
            let _this = this;
            let rectangle = new fabric.Rect({
                width: parseFloat(_this.popup_canvas_width),
                height: parseFloat(_this.popup_canvas_height),
                top: parseFloat(_this.popup_canvas_top),
                left: parseFloat(_this.popup_canvas_left),
                fill: "",
                stroke: "black",
                strokeDashArray: [5, 5],
                strokeWidth: 1,
                selectable: false
            });
            _this.backSleeveCanvas.clear();
            _this.backSleeveCanvas.renderAll();
            fabric.Image.fromURL(_this.background_image_sleeve, (imgObj) => {
                _this.backSleeveCanvas.setBackgroundImage(
                    imgObj,
                    _this.backSleeveCanvas.renderAll.bind(
                        _this.backSleeveCanvas
                    ),
                    {
                        backgroundColor:
                            _this.user_selected_values[_this.active_gender_key]
                                .color_hash,
                        scaleX: _this.defaultWidthCanvas / imgObj.width,
                        scaleY: _this.defaultHeightCanvas / imgObj.height
                    }
                );
                _this.imgHeight = imgObj.height;
                _this.imgWidth = imgObj.width;
            });
            _this.backSleeveCanvas.add(rectangle);
            _this.backSleeveCanvas.renderAll();
            /* eslint-disable */
            $(`#show_sleeve`).modal("show");
            /* eslint-enable */
            this.$forceUpdate();
        },

        validateData(genders) {
            let minimum_quantity;

            let total_qty = 0;
            let quantity_error = false;
            let color_names = [];
            // Validation minimum quantity
            genders.forEach((gender) => {
                if (gender.colors) {
                    gender.colors.forEach((color) => {
                        if (!color.total_qty_gender_wise) {
                            color_names.push(color.color_name);
                            quantity_error = true;
                        }
                    });
                }

                total_qty = total_qty + gender.total_qty_gender_wise;
            });

            let decoration_type = genders[0]["item"].decoration_type;
            let price_decoration_bulk = JSON.parse(
                genders[0]["item"].price_decoration_bulk
            );

            if (decoration_type == 1) {
                minimum_quantity =
                    price_decoration_bulk["print_location1"][0].quantity;
            } else if (decoration_type == 2) {
                minimum_quantity = price_decoration_bulk[0].quantity1;
            }

            if (quantity_error) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )} atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return false;
            }

            if (total_qty == 0) {
                this.$toast.error(
                    "Please select color and quantity to design",
                    { position: "top-right", queue: true }
                );
                return false;
            } else if (parseInt(total_qty) < parseInt(minimum_quantity)) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return false;
            }

            // Validating name & numbers
            let empty_name_numbers_color_names = [];
            let name_and_number_enabled = false;
            const imprintLocations =
                this.gender_groups_items[this.active_gender_key]
                    .imprint_locations;
            this.gender_groups_items[this.active_gender_key].colors.forEach(
                (color) => {
                    imprintLocations.forEach((location) => {
                        let is_name_and_number_enabled =
                            color.selected_name_number[
                                location.location.toLowerCase().trim()
                            ];
                        if (
                            is_name_and_number_enabled &&
                            is_name_and_number_enabled["name"]
                        ) {
                            let notEmpty = color.name_and_number_json.find(
                                (nn) => nn.name != ""
                            );
                            if (!notEmpty) {
                                empty_name_numbers_color_names.push(
                                    color.color_name
                                );
                            }
                            name_and_number_enabled = true;
                        }

                        if (
                            is_name_and_number_enabled &&
                            is_name_and_number_enabled["number"]
                        ) {
                            let notEmpty = color.name_and_number_json.find(
                                (nn) => nn.number != ""
                            );
                            if (!notEmpty) {
                                empty_name_numbers_color_names.push(
                                    color.color_name
                                );
                            }
                            name_and_number_enabled = true;
                        }
                    });
                }
            );

            empty_name_numbers_color_names = [
                ...new Set(empty_name_numbers_color_names)
            ];
            if (empty_name_numbers_color_names.length > 0) {
                this.$toast.error(
                    `Atleast one name or number is required for selected name & numbers.`,
                    { position: "top-right", queue: true }
                );
                return false;
            }

            if (!name_and_number_enabled) {
                // Validating ink/thread colors
                let is_locations_selected = false;
                let is_area_colors_empty = false;
                let is_colors_empty = false;
                for (let gender of genders) {
                    if (gender.colors) {
                        gender.colors.forEach((color) => {
                            for (let location of color.imprint_locations) {
                                if (location.is_selected) {
                                    is_locations_selected = true;
                                    if (location.colors.length == 0) {
                                        is_area_colors_empty = true;
                                        return;
                                    } else {
                                        let is_selected = location.colors.find(
                                            (color) => color.color == null
                                        );
                                        if (is_selected) {
                                            is_colors_empty = true;
                                            return;
                                        }
                                    }
                                }
                            }
                        });
                    }
                }

                let errorText = "";
                if (decoration_type == 1) {
                    errorText = "imprint";
                } else if (decoration_type == 2) {
                    errorText = "embroidery";
                }

                if (!is_locations_selected) {
                    this.$toast.error(`Please select ${errorText} locations.`, {
                        position: "top-right",
                        queue: true
                    });
                    return false;
                } else if (is_colors_empty) {
                    this.$toast.error(
                        `Please select all imprint colors for selected ${errorText} locations.`,
                        { position: "top-right", queue: true }
                    );
                    return false;
                } else if (is_area_colors_empty) {
                    this.$toast.error(
                        `Please select colors for selected ${errorText} locations.`,
                        { position: "top-right", queue: true }
                    );
                    return false;
                }
            }
            return true;
        },
        async addToCart() {
            let _this = this;
            if (!this.isAuthenticatedClient) {
                /* eslint-disable */
                $("#login").modal("show");
                return;
                /* eslint-enable */
            }
            let designStatus = this.checkObjectCanvas();
            if (!designStatus && _this.colors_validation == "") {
                _this.$toast.clear();
                _this.$toast.error(
                    "Please add some design ( Text, Clipart or ArtWork ) to this product",
                    {
                        duration: 2000,
                        position: "top-right",
                        queue: false
                    }
                );
                return;
            }
            //   let design_items = JSON.parse(localStorage.getItem("design"));
            let design_items = JSON.parse(
                JSON.stringify(this.gender_groups_items)
            );
            if (design_items.length == 0) {
                return;
            }

            if (design_items[0]["item"]["price_decoration_bulk"]) {
                let decoration_pricing = "";
                if (
                    typeof design_items[0]["item"]["price_decoration_bulk"] ===
                    "string"
                ) {
                    decoration_pricing = JSON.parse(
                        design_items[0]["item"]["price_decoration_bulk"]
                    );
                } else {
                    decoration_pricing =
                        design_items[0]["item"]["price_decoration_bulk"];
                }
                let total_cart_quantity = parseInt(design_items[0].total_qty);
                if (decoration_pricing) {
                    if (design_items[0]["item"].decoration_type == 1) {
                        let minimum_quantity =
                            decoration_pricing["print_location1"][0][
                                "quantity"
                            ];
                        if (minimum_quantity > total_cart_quantity) {
                            this.$toast.error(
                                "Quantity should be greater than " +
                                    minimum_quantity,
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            return;
                        }
                    } else if (design_items[0]["item"].decoration_type == 2) {
                        let minimum_quantity =
                            decoration_pricing[0]["quantity1"];
                        if (minimum_quantity > total_cart_quantity) {
                            this.$toast.error(
                                "Quantity should be greater than " +
                                    minimum_quantity,
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            return;
                        }
                    } else if (design_items[0]["item"].decoration_type == 3) {
                        let minimum_quantity =
                            decoration_pricing[0]["quantity"];
                        if (minimum_quantity > total_cart_quantity) {
                            this.$toast.error(
                                "Quantity should be greater than " +
                                    minimum_quantity,
                                {
                                    position: "top-right",
                                    queue: true
                                }
                            );
                            return;
                        }
                    }
                }
            }

            let allColorAndSizesname = "";
            let allColorAndSizesnumber = "";
            let nameAndNumbers = [];

            if (this.$refs.nameAndNumberRef.addInputName) {
                nameAndNumbers =
                    this.$refs.nameAndNumberRef.addInputName.filter(
                        (nn) => nn.name != "" || nn.number
                    );
            }
            if (nameAndNumbers.length > 0) {
                allColorAndSizesname =
                    this.$refs.nameAndNumberRef.colorSizesForName;
                allColorAndSizesnumber =
                    this.$refs.nameAndNumberRef.colorSizesForNumber;
            }

            designStatus = this.checkObjectCanvas();
            let new_canvas_elements = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (!designStatus) {
                this.$toast.error("Please add design on the Product !", {
                    position: "top-right"
                });
                this.isLoader = false;
                return false;
            }
            let parsedJson = new_canvas_elements ? new_canvas_elements : null;
            _this.active_flip = localStorage.getItem("active_flip");
            parsedJson[_this.active_flip] = JSON.stringify(_this.backCanvas);
            if (parsedJson && this.build_id) {
                this.saved_design.build_id = this.build_id;
            }
            if (parsedJson && this.build_item_id) {
                this.saved_design.build_item_id = this.build_item_id;
            }
            let flips = [];
            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
            if (!this.front_show) {
                delete parsedJson.front;
                delete get_canvas_colors.front;
            } else {
                flips.push("front");
            }
            if (!this.back_show) {
                delete parsedJson.back;
                delete get_canvas_colors.back;
            } else {
                flips.push("back");
            }
            if (!this.left_show) {
                delete parsedJson.left;
                delete get_canvas_colors.left;
            } else {
                flips.push("left");
            }
            if (!this.right_show) {
                delete parsedJson.right;
                delete get_canvas_colors.right;
            } else {
                flips.push("right");
            }
            this.saved_design.canvas_json = JSON.stringify(parsedJson);
            localStorage.setItem(
                "new_canvas_elements",
                JSON.stringify(parsedJson)
            );
            new_canvas_elements = parsedJson;
            let get_product = JSON.parse(JSON.stringify(this.product_items));
            if (typeof JSON.parse(get_product.design_areas) == "string") {
                get_product = JSON.parse(get_product.design_areas);
            }
            let image_response = [];

            this.cart_save_design = false;
            // if only save design
            if (this.only_save_designs) {
                this.save_design_images = image_response;
                return;
            }

            let { non_standard_fees, non_standard_colors, decoration_colors } =
                this.calcAdditionalFees();

            this.isLoader = true;
            //setTimeout(async () => {
            let allitems = [];
            /* eslint-disable */
            let user_product_id = "";
            for (const [genderIndex, design_item] of Object.entries(
                design_items
            )) {
                let total_quantity = 0;
                let total_price = 0;
                user_product_id = "Mydesign_cart" + "_" + Date.now();
                this.save_design_images = image_response;

                for (let [colorIndex, color] of Object.entries(
                    design_item["colors"]
                )) {
                    let items = [];
                    let image_response_back = [];
                    let selected_design_images = [];
                    design_items[0]["item"]["NewProductImages"].forEach(
                        (colors) => {
                            if (
                                colors.color_id == color.id &&
                                colors.type == "front"
                            ) {
                                selected_design_images.push({
                                    front: colors.url
                                });
                            }
                            if (
                                colors.color_id == color.id &&
                                colors.type == "back"
                            ) {
                                selected_design_images.push({
                                    back: colors.url
                                });
                            }
                        }
                    );
                    //console.log(selected_design_images);
                    let selected_flip = flips;
                    if (image_response_back.length == 0) {
                        let front_designs = {};
                        for (let flip1 of selected_flip) {
                            // await selected_flip.forEach(async (flip1) => {
                            let objects = new_canvas_elements[flip1]
                                ? JSON.parse(new_canvas_elements[flip1]).objects
                                : [];
                            if (objects.length == 0) {
                                continue;
                            }
                            let tempCanvas = new fabric.Canvas();
                            let rectHeight = 0;
                            let rectWidth = 0;
                            let rectTop = 0;
                            let rectLeft = 0;
                            for (let canvas_obj of objects) {
                                if (
                                    "clipPath" in canvas_obj &&
                                    canvas_obj.clipPath.type == "rect"
                                ) {
                                    rectHeight = canvas_obj.clipPath.height;
                                    rectWidth = canvas_obj.clipPath.width;
                                    rectTop = canvas_obj.clipPath.top;
                                    rectLeft = canvas_obj.clipPath.left;
                                }
                            }
                            tempCanvas.setWidth(this.defaultWidthCanvas);
                            tempCanvas.setHeight(this.defaultHeightCanvas);
                            let localCanvasJson = JSON.parse(
                                new_canvas_elements[flip1]
                            );
                            let canvas_images = [];
                            if (localCanvasJson.objects.length > 0) {
                                localCanvasJson.objects =
                                    localCanvasJson.objects.filter(function (
                                        val
                                    ) {
                                        return val.type != "rect";
                                    });
                                if (localCanvasJson.objects.length == 0)
                                    continue;
                                localCanvasJson.objects.forEach(
                                    (canvas_obj) => {
                                        if (canvas_obj.image_name) {
                                            canvas_images.push({
                                                image_name:
                                                    canvas_obj.image_name,
                                                image_path:
                                                    canvas_obj.image_path,
                                                height_inch:
                                                    canvas_obj.height_inch,
                                                width_inch:
                                                    canvas_obj.width_inch
                                            });
                                        }
                                    }
                                );
                            }
                            await tempCanvas.loadFromJSON(
                                JSON.stringify(localCanvasJson),
                                function () {
                                    tempCanvas.renderAll();
                                    if (rectHeight > 0 && rectTop > 0) {
                                        front_designs[flip1] =
                                            tempCanvas.toDataURL({
                                                left: rectLeft,
                                                top: rectTop,
                                                width: rectWidth,
                                                height: rectHeight
                                            });
                                    } else {
                                        front_designs[flip1] =
                                            tempCanvas.toDataURL({
                                                multiplier: 0.3
                                            });
                                    }
                                }
                            );
                            if (flip1 == "front" || flip1 == "back") {
                                let canvasImgUrlArr =
                                    selected_design_images.filter(function (
                                        currentImage
                                    ) {
                                        return currentImage[flip1];
                                    });
                                let canvasImgUrl = canvasImgUrlArr[0][flip1];
                                // console.log('canvasImgUrl =====>', canvasImgUrl);
                                let imgObj = await _this.loadImageAsync(
                                    canvasImgUrl
                                );
                                //console.log(imgObj);
                                await tempCanvas.setBackgroundImage(
                                    imgObj,
                                    tempCanvas.renderAll.bind(tempCanvas),
                                    {
                                        scaleX:
                                            _this.defaultWidthCanvas /
                                            imgObj.width,
                                        scaleY:
                                            _this.defaultHeightCanvas /
                                            imgObj.height,
                                        crossOrigin: "anonymous"
                                    }
                                );
                                _this.imgHeight = imgObj.height;
                                _this.imgWidth = imgObj.width;
                                //_this.isLoader = false;
                                if (imgObj._element === null) {
                                    _this.$toast.error(
                                        "Something went wrong while loading the design area images, please refresh the page and try again.",
                                        {
                                            position: "top-right",
                                            queue: true,
                                            duration: 10000,
                                            pauseOnHover: true
                                        }
                                    );
                                } else {
                                    console.log(
                                        "Canvas Image Loaded... Image " + imgObj
                                    );
                                    image_response_back.push({
                                        label: flip1,
                                        url: tempCanvas.toDataURL({
                                            multiplier: 0.6
                                        }),
                                        design_image: front_designs[flip1],
                                        canvas_images: canvas_images
                                    });
                                }
                            } else {
                                //tempCanvas.setBackgroundColor(
                                //  color.hex,
                                //  tempCanvas.renderAll.bind(tempCanvas)
                                //);
                                image_response_back.push({
                                    label: flip1,
                                    url: tempCanvas.toDataURL({
                                        multiplier: 0.3
                                    }),
                                    design_image: front_designs[flip1],
                                    canvas_images: canvas_images
                                });
                            }
                        }
                    }

                    color["unique_sizes"].forEach((size) => {
                        total_quantity =
                            total_quantity + parseInt(size.quantity || 0);
                        total_price =
                            total_price + parseFloat(size.total_cost || 0);
                        items.push({
                            sub_product_id: size.sub_product_id,
                            user_id: _this.currentUserClient.id,
                            case_price: size.price_base || 0,
                            markup_price: size.markup_price || 0,
                            markup_percentage:
                                design_item.markup_percentage || 0,
                            ink_price: size.ink_price || 0,
                            single_location_price:
                                size.single_location_price || 0,
                            quantity: size.quantity || 0,
                            discount: size.discount ? size.discount : 0.0,
                            unit_price: size.cost || 0,
                            total_price: size.total_cost || 0
                        });
                    });
                    color.non_standard_fees =
                        parseFloat(non_standard_fees) *
                        parseInt(color.total_qty_gender_wise);
                    /* eslint-disable */
                    color.name_number_fees = parseFloat(name_number_fees);
                    /* eslint-enable */
                    color.non_standard_colors = non_standard_colors;
                    color.decoration_colors = decoration_colors;
                    color.total_cost_gender_wise =
                        parseFloat(color.total_cost_gender_wise) +
                        parseFloat(color.non_standard_fees) +
                        parseFloat(color.name_number_fees);

                    if (!color.name_and_number_json) {
                        color.name_and_number_json = [];
                    }

                    let isNameNumberExists = color.name_and_number_json.filter(
                        (nn) => nn.name != "" || nn.number
                    );

                    let imprint_locations = JSON.parse(
                        JSON.stringify(design_item.imprint_locations)
                    );
                    imprint_locations.forEach((location) => {
                        location.colors = location.colors.filter(
                            (lcolor) => lcolor.color
                        );
                    });

                    allitems.push({
                        user_id: _this.currentUserClient.id,
                        item_id: design_item.item.id,
                        gender_size_id: design_item.gender_id,
                        color_id: color.id,
                        decoration_type: design_item.item.decoration_type,
                        price_decoration_bulk:
                            design_item.item.price_decoration_bulk,
                        more_decorations: design_item.item.more_decoration,
                        items: items,
                        imprint_locations:
                            colorIndex == 0 ? imprint_locations : null,
                        imprint_locations_price:
                            colorIndex == 0 ? design_item.total_color_fee : 0,
                        total_design_fee: color.total_design_fee,
                        total_quantity: color.total_qty_gender_wise,
                        total_price: color.total_cost_gender_wise,
                        setup_fee:
                            colorIndex == 0 ? design_item.total_setup_fee : 0.0,
                        subtotal_price: color.total_cost_gender_wise,
                        artwork: design_item.item_artwork,
                        design_image: image_response_back,
                        design_area_inches: JSON.stringify(
                            _this.design_area_inches
                        ),
                        name_number_fees: color.name_number_fees,
                        non_standard_fees: color.non_standard_fees,
                        non_standard_colors: color.non_standard_colors,
                        decoration_colors: color.decoration_colors,
                        name_and_number_json:
                            isNameNumberExists.length > 0
                                ? color.name_and_number_json
                                : null,
                        font_color_sizes_name: allColorAndSizesname,
                        font_color_sizes_number: allColorAndSizesnumber,
                        t_shirt_24_hour: this.is24Tshirt
                    });
                }
            }
            /* eslint-enable */
            await ApiService.post("/add-to-cart", allitems)
                .then(async () => {
                    this.$root.$emit("update-cart", { type: "success" });
                    this.flipTshirt("front");
                    //this.cart_status = user_product_id;
                    //this.delay(200);
                    //await this.save_all_design();
                    this.isLoader = false;
                    let colorIdArr =
                        localStorage.getItem("colorIdArr") != null
                            ? localStorage.getItem("colorIdArr").split(",")
                            : [];
                    colorIdArr.push(this.activeIndex);
                    if (colorIdArr.length > 0)
                        localStorage.setItem(
                            "colorIdArr",
                            colorIdArr.join(",")
                        );
                    this.skip_leave_confirm_box = true;
                    this.$router.push({
                        name: "cartV3"
                    });
                })
                .catch(({ response }) => {
                    if (response.data.error) {
                        this.$toast.error(
                            "Access denied, images not uploading to server",
                            {
                                position: "top-right"
                            }
                        );
                    }
                    this.isLoader = false;
                });
            this.isLoader = false;
        },
        shareDesign() {
            this.copied = false;
            let local_data = {};
            let keys = [
                "design",
                "canvas_elements",
                "new_canvas_elements",
                "product_id",
                "product_items",
                "active_tshirt_color",
                "active_gender",
                "active_gender_key"
            ];
            keys.forEach((key) => {
                local_data[key] = localStorage.getItem(key);
            });
            let params = {
                design_data: local_data
            };

            this.isLoader = true;
            ApiService.post("/share-design", params)
                .then(({ data }) => {
                    this.shareable_link =
                        window.location.origin +
                        "/design-studio/design/" +
                        data.share_design.id;
                    /* eslint-disable */
                    $("#share_design_modal").modal("show");
                    /* eslint-enable */
                    this.isLoader = false;
                })
                .then((response) => {
                    this.isLoader = false;
                    console.log(response);
                });
        },
        getShareDesign(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/get-share-design/${id}`)
                    .then(({ data }) => {
                        let design_data = JSON.parse(
                            data.share_design.design_data
                        );
                        for (const [key, value] of Object.entries(
                            design_data
                        )) {
                            // if (localStorage.getItem(key)==null) {
                            localStorage.setItem(key, value);
                            // }
                        }
                        localStorage.setItem(
                            "share_design_id",
                            data.share_design.id
                        );
                        this.isLoader = false;
                        resolve(data);
                    })
                    .then((response) => {
                        this.isLoader = false;
                        console.log(response);
                        reject(response);
                    });
            });
        },
        copyClipboard() {
            // Get the text field
            var copyText = document.getElementById("share_link_input");

            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices

            // Copy the text inside the text field
            navigator.clipboard.writeText(copyText.value);

            this.copied = true;
        },
        delay(delayInms) {
            return new Promise((resolve) => setTimeout(resolve, delayInms));
        },
        objSelected(e) {
            let _this = this;
            //console.log(e);
            _this.onObjectSelected(e);
        },
        objRotating(e) {
            if (!e) {
                return;
            }
            let _this = this;
            // console.log(e.target);
            this.rotationAngle = parseInt(e.target.angle);
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        objSkewing(e) {
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        objModified(e) {
            let _this = this;
            _this.isLoader = true;
            _this.saveCanvasData();
            _this.getStoreDesign();

            var obj = e.target;
            obj.setCoords();
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
            _this.isLoader = false;
        },
        objRemoved(e) {
            let obj = e.target;
            let _this = this;
            var colors = [];
            // Get all the unique colors of the deleted objects on the canvas
            /* eslint-disable */
            if ("_objects" in obj) {
                colors = obj._objects.reduce(function (
                    accumulator,
                    currentObject
                ) {
                    if (
                        currentObject.get("fill") &&
                        !accumulator.includes(currentObject.get("fill"))
                    ) {
                        accumulator.push(currentObject.get("fill"));
                    } else if (
                        currentObject.ctype == "shape" ||
                        "text" in currentObject
                    ) {
                        if (
                            currentObject.get("fill") &&
                            !accumulator.includes(currentObject.get("fill"))
                        ) {
                            accumulator.push(currentObject.get("fill"));
                        }
                    }
                    return accumulator;
                },
                []);
            } else if (
                currentObject.ctype == "clipart" ||
                currentObject.ctype == "patch" ||
                obj.ctype == "shape" ||
                "text" in obj
            ) {
                if (obj.get("fill") && !colors.includes(obj.get("fill"))) {
                    colors.push(obj.get("fill"));
                }
                if (
                    "text" in obj &&
                    obj.get("stroke") &&
                    !accumulator.includes(obj.get("stroke"))
                ) {
                    accumulator.push(obj.get("stroke"));
                }
                if (
                    "text" in obj &&
                    obj.get("shadow") &&
                    !accumulator.includes(obj.get("shadow"))
                ) {
                    accumulator.push(obj.get("shadow").color);
                }
            }
            /* eslint-enable */
            colors.forEach(function (currentValue) {
                let currentIndex =
                    _this.design_current_colors.indexOf(currentValue);
                if (currentIndex > -1)
                    _this.design_current_colors.splice(currentIndex);
            });

            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );

            _this.checkObjectCanvas();
            _this.updateAdditionalFeesInDashboard();
        },
        objResizing(e) {
            var obj = e.target;
            obj.setCoords();
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        objSelectionCleared(e) {
            let _this = this;
            _this.siderBarChange(e);
        },
        objMoved(e) {
            var obj = e.target;
            obj.setCoords();
        },
        objMoving(e) {
            if (!e) {
                return;
            }
            var obj = e.target;

            obj.setCoords();
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );

            if (
                obj.height > obj.canvas.height ||
                obj.width > obj.canvas.width
            ) {
                obj.scaleY = obj._stateProperties.scaleY;
                obj.scaleX = obj._stateProperties.scaleX;
            }

            if (
                obj.getBoundingRect().top - obj.cornerSize / 2 < 0 ||
                obj.getBoundingRect().left - obj.cornerSize / 2 < 0
            ) {
                obj.top = Math.max(
                    obj.top,
                    obj.top - obj.getBoundingRect().top + obj.cornerSize / 2
                );
                obj.left = Math.max(
                    obj.left,
                    obj.left - obj.getBoundingRect().left + obj.cornerSize / 2
                );
            }
            if (
                obj.getBoundingRect().top +
                    obj.getBoundingRect().height +
                    obj.cornerSize >
                    obj.canvas.height ||
                obj.getBoundingRect().left +
                    obj.getBoundingRect().width +
                    obj.cornerSize >
                    obj.canvas.width
            ) {
                obj.top = Math.min(
                    obj.top,
                    obj.canvas.height -
                        obj.getBoundingRect().height +
                        obj.top -
                        obj.getBoundingRect().top -
                        obj.cornerSize / 2
                );
                obj.left = Math.min(
                    obj.left,
                    obj.canvas.width -
                        obj.getBoundingRect().width +
                        obj.left -
                        obj.getBoundingRect().left -
                        obj.cornerSize / 2
                );
            }
        },
        objScaling(e) {
            if (!e) {
                return;
            }
            let _this = this;
            _this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
        },
        overImageLoaded(img) {
            this.overImgHeight = img.height;
            this.overImgWidth = img.width;
        },
        objDropped() {
            // eslint-disable-next-line no-console
        },
        dragStart(e) {
            // eslint-disable-next-line no-console

            e.dataTransfer.setData("text/plain", "mmmmmeeeee");
        },
        afterRender() {
            this.getStoreDesign();

            if (this.backCanvas._objects.length > 0) {
                this.save_design_button = false;
            } else {
                this.save_design_button = true;
            }
        },
        canvasUpdated() {
            // Write some code
        },
        canvasImageUpdated(c) {
            this.imageCanvas = c;
        },
        canvasBackUpdated(c) {
            this.backCanvas = c;
            let _this = this;
            let matchRgbaColor =
                /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
            _this.design_current_colors = [];
            // Get all the unique colors of the objects on the canvas
            var colors = [];
            this.backCanvas._objects.forEach(function (currentObject) {
                let accumulator = [];
                if ("_objects" in currentObject) {
                    accumulator = currentObject._objects.reduce(function (
                        accumulator1,
                        currentObject1
                    ) {
                        if (
                            currentObject1.get("fill") &&
                            !accumulator1.includes(currentObject1.get("fill"))
                        ) {
                            accumulator1.push(currentObject1.get("fill"));
                        }
                        return accumulator1;
                    },
                    []);
                } else if (
                    currentObject.ctype == "clipart" ||
                    currentObject.ctype == "patch" ||
                    currentObject.ctype == "shape" ||
                    "text" in currentObject
                ) {
                    if (
                        currentObject.get("fill") &&
                        !accumulator.includes(currentObject.get("fill"))
                    ) {
                        accumulator.push(currentObject.get("fill"));
                    }
                    if (
                        "text" in currentObject &&
                        currentObject.get("stroke") &&
                        !accumulator.includes(currentObject.get("stroke"))
                    ) {
                        accumulator.push(currentObject.get("stroke"));
                    }
                    if (
                        "text" in currentObject &&
                        currentObject.get("shadow") &&
                        !accumulator.includes(currentObject.get("shadow"))
                    ) {
                        accumulator.push(currentObject.get("shadow").color);
                    }
                }
                if(  currentObject.name === 'printArea' ||
                    currentObject.id === 'printArea' ||
                    currentObject.type === 'rect' && currentObject.strokeDashArray ||
                    currentObject.stroke === 'dashed' ||
                    currentObject.selectable === false ||
                    (currentObject.stroke && currentObject.fill === 'transparent')
                ){
                    _this.printAreaBond  = currentObject.getBoundingRect();
                }
                if (accumulator.length > 0)
                    colors = [...colors, ...accumulator];
            });

            let vinylColorHexCodes = this.vinyl_color_list.map(
                (color) => color.hex
            );
            const rgba2hex = (rgba) =>
                `#${rgba
                    .match(
                        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
                    )
                    .slice(1)
                    .map((n, i) =>
                        (i === 3
                            ? Math.round(parseFloat(n) * 255)
                            : parseFloat(n)
                        )
                            .toString(16)
                            .padStart(2, "0")
                            .replace("NaN", "")
                    )
                    .join("")}`;
            let activeTshirtColor = localStorage.getItem("active_tshirt_color");
            colors.forEach(function (currentValue, key) {
                if (matchRgbaColor.exec(currentValue) != null) {
                    let newHexColor = rgba2hex(currentValue);
                    colors[key] = newHexColor;
                    currentValue = newHexColor;
                }
                if (
                    !_this.design_current_colors.includes(currentValue) &&
                    !vinylColorHexCodes.includes(currentValue) &&
                    !matchRgbaColor.exec(currentValue) &&
                    activeTshirtColor.toUpperCase() !=
                        currentValue.toUpperCase()
                ) {
                    _this.design_current_colors.push(currentValue);
                }
            });

            this.current_active_flip_colors = [];
            if (!this.build_item_id) {
                this.current_active_flip_colors = this.design_current_colors;
            }
            for (const [buildItemId] of Object.entries(
                this.build_canvas_design_colors
            )) {
                if (this.build_item_id == buildItemId) {
                    this.build_canvas_design_colors[buildItemId][
                        _this.active_flip
                    ] = _this.design_current_colors;
                }
                this.current_active_flip_colors = [
                    ...this.current_active_flip_colors,
                    ...this.build_canvas_design_colors[buildItemId][
                        _this.active_flip
                    ]
                ];
            }

            this.current_active_flip_colors = [
                ...new Set(this.current_active_flip_colors)
            ];

            if (this.current_active_flip_colors.length > _this.colors_count) {
                _this.colors_validation =
                    "A maximum of " +
                    _this.colors_count +
                    " colors can be used on each side location for this overall build.";
            } else {
                _this.colors_validation = "";
            }
            //console.log('Colors of objects on the canvas:', _this.design_current_colors);

            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            this.all_decoration_colors = get_canvas_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );

            if (_this.design_box == "") {
                _this.addDesignArea();
            }

            _this.checkObjectCanvas();
            _this.updateAdditionalFeesInDashboard();
        },

        prepareImprintLocations(
            disableColors = true,
            current_active_flip = null
        ) {
            let local_flip = current_active_flip
                ? current_active_flip
                : this.active_flip;
            let decoration_colors =
                this.all_decoration_colors[local_flip] || [];

            let non_standard_fees_obj = null;
            if (
                this.gender_groups_items[this.active_gender_key].item
                    .decoration_type == 1
            ) {
                non_standard_fees_obj = this.adminOptions.find(
                    (option) => option.option_key == "non_standard_color_fees"
                );
            } else if (
                this.gender_groups_items[this.active_gender_key].item
                    .decoration_type == 2
            ) {
                non_standard_fees_obj = this.adminOptions.find(
                    (option) =>
                        option.option_key == "non_standard_color_fees_emb"
                );
            }

            let non_standard_fees = 0;
            if (non_standard_fees_obj && non_standard_fees_obj.option_value) {
                non_standard_fees =
                    parseFloat(non_standard_fees_obj.option_value) || 0;
            }

            let imprint_locations =
                this.gender_groups_items[0].imprint_locations;

            if (this.all_decoration_colors[local_flip]) {
                let locationIndex = imprint_locations.findIndex(
                    (location) =>
                        location.location.toLowerCase().trim() == local_flip
                );
                if (locationIndex >= 0 && decoration_colors) {
                    imprint_locations[locationIndex].colors = [];
                    decoration_colors.forEach((colorHex) => {
                        let vendorColor = this.vendor_colors_list.find(
                            (vendorColor) =>
                                vendorColor.color_value.toLowerCase() ==
                                colorHex.toLowerCase()
                        );
                        let nonStandardColor = {
                            color_id: 0,
                            color_name: "Mix Color",
                            color_pms: "Non Standard",
                            non_standard_fee: non_standard_fees,
                            decor_upcharge: 0,
                            color_value: "#GGGGGG",
                            swatches: "",
                            category: "Non Standard",
                            shades: []
                        };
                        if (
                            imprint_locations[locationIndex].colors.length <
                            this.colors_count
                        ) {
                            imprint_locations[locationIndex].colors.push({
                                color: vendorColor || nonStandardColor,
                                color_cost: 0.0,
                                cost_cost: 0,
                                cost_sum_added: false
                            });
                        }
                    });
                    if (
                        imprint_locations[locationIndex].colors.length <
                        this.colors_count
                    ) {
                        imprint_locations[locationIndex].no_of_color =
                            decoration_colors.length > 0
                                ? decoration_colors.length
                                : null;
                    } else {
                        imprint_locations[locationIndex].no_of_color =
                            this.colors_count;
                    }
                }
            }

            this.gender_groups_items[0].imprint_locations = JSON.parse(
                JSON.stringify(imprint_locations)
            );
            this.gender_groups_items[0].colors.forEach((color) => {
                color.imprint_locations = JSON.parse(
                    JSON.stringify(imprint_locations)
                );
            });
            this.$refs.ItemDetails.calculatePricing(this.active_gender_key);
            this.$refs.ItemDetails.disableImprintLocations(disableColors);
        },

        updatePrintAreas() {
            let active_areas = {
                front: false,
                back: false,
                left: false,
                right: false
            };
            let imprint_locations =
                this.gender_groups_items[0].imprint_locations;
            imprint_locations.forEach((location) => {
                active_areas[location.location.toLowerCase()] =
                    location.is_selected;
                this[`${location.location.toLowerCase().trim()}_show`] =
                    location.is_selected;
            });
            // this.design_area_data.forEach(area => {
            //     area.selected = active_areas[area.label.toLowerCase()];
            //     this[`${area.label.toLowerCase()}_show`] = area.selected;
            // });
            if (this.$refs.printAreaIcons) {
                this.$refs.printAreaIcons.$forceUpdate();
            }
        },

        canvasBackSleeveUpdated(c) {
            this.backSleeveCanvas = c;
        },

        objMouseDown(option) {
            /* eslint-disable */
            if (typeof option.target != "undefined") {
                return;
            } else {
                var startY = option.e.offsetY,
                    startX = option.e.offsetX;
            }
            /* eslint-enable */
        },
        objMouseUp() {
            this.canvas.off("mouse:move");
        },
        imageLoaded(img) {
            this.imgHeight = img.height;
            this.imgWidth = img.width;
        },
        showImageList() {
            this.add_distress_images = true;
        },
        closeImageList() {
            this.active_class = "active";
            document
                .querySelector("#distress-effects-tab")
                .classList.remove("active");
            document
                .querySelector("#distress-effects")
                .classList.remove("active");
            document
                .querySelector("#distress-effects")
                .classList.remove("show");
            document.querySelector("#default1").classList.add("active");
            document.querySelector("#default1").classList.add("show");
            this.$forceUpdate();
        },
        async updateDistressImage(url) {
            let _this = this;
            _this.isLoader = true;
            if (!_this.backCanvas) {
                return;
            }
            if (_this.uploadModuleCanvas == 0) {
                _this.uploadModuleCanvas++;
                _this.saveCanvasData();
            }

            _this.distress_images[_this.active_flip] = url;
            _this.selectedDistressImage = url;

            try {
                let activeColor = localStorage.getItem("active_tshirt_color");
                let img = "";
                await fabric.loadSVGFromURL(
                    url,
                    async function (objects, options) {
                        objects.forEach((element) => {
                            element.fill = activeColor;
                        });
                        img = await fabric.util.groupSVGElements(
                            objects,
                            options
                        );

                        console.log(img);
                        if (
                            _this.active_flip == "front" ||
                            _this.active_flip == "back"
                        ) {
                            img.set({
                                scaleX: _this.front_canvas_width / img.width,
                                scaleY: _this.front_canvas_height / img.height,
                                objectCaching: false,
                                left: _this.front_canvas_left,
                                top: _this.front_canvas_top,
                                originX: "left",
                                originY: "top",
                                // opacity:0.8,
                                globalCompositeOperation: "source-atop"
                            });
                        } else {
                            img.set({
                                scaleX: _this.backCanvas.getWidth() / img.width,
                                scaleY:
                                    _this.backCanvas.getHeight() / img.height,
                                objectCaching: false,
                                originX: "left",
                                originY: "top",
                                //opacity:0.2,
                                globalCompositeOperation: "source-atop"
                            });
                        }
                        _this.backCanvas.setOverlayImage(
                            img,
                            _this.backCanvas.renderAll.bind(_this.backCanvas)
                        );

                        _this.isLoader = false;
                        _this = "";
                    },
                    null,
                    { crossOrigin: "Anonymous" }
                );
            } catch (isError) {
                if (isError) {
                    _this.$toast.error(
                        "something went wrong, please choose other effect",
                        {
                            position: "top-right"
                        }
                    );
                }
                _this.isLoader = false;
            }
        },
        getLocalDesign(get_saved_design = null) {
            let _this = this;
            _this.active_flip = localStorage.getItem("active_flip");

            _this.canvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );

            if (
                _this.canvasList &&
                _this.canvasList.products_id != undefined &&
                "distress_images" in _this.canvasList
            ) {
                _this.distress_images = _this.canvasList.distress_images;
                if (_this.distress_images[_this.active_flip]) {
                    this.updateDistressImage(
                        _this.distress_images[_this.active_flip]
                    );
                    this.add_distress_images = true;
                } else {
                    _this.selectedDistressImage = null;
                }
            }

            if (
                _this.canvasList &&
                _this.canvasList.products_id != undefined &&
                "build_id" in _this.canvasList
            ) {
                _this.build_id = _this.canvasList.build_id;
            }
            if (
                _this.canvasList &&
                _this.canvasList.products_id != undefined &&
                "build_item_id" in _this.canvasList
            ) {
                _this.build_item_id = _this.canvasList.build_item_id;
                _this.first_build_item_id =
                    _this.canvasList.first_build_item_id;
            }

            let new_product_id = localStorage.getItem("product_id");

            if (
                _this.canvasList &&
                _this.canvasList.products_id != undefined &&
                _this.canvasList.products_id != new_product_id &&
                get_saved_design == null
            ) {
                _this.canvasList = { front: "", back: "" };
                localStorage.setItem(
                    "new_canvas_elements",
                    JSON.stringify(_this.canvasList)
                );
                return false;
            }

            if (_this.canvasList == null) {
                _this.canvasList = { front: "", back: "" };
            }

            if (_this.canvasList[_this.active_flip]) {
                fabric.util.enlivenObjects(
                    JSON.parse(this.canvasList[this.active_flip]).objects,
                    function (objects) {
                        var origRenderOnAddRemove =
                            _this.backCanvas.renderOnAddRemove;
                        _this.backCanvas.renderOnAddRemove = false;
                        objects.forEach(function (o) {
                            let type1 = o.ctype;
                            let objType1 = o.objType;
                            let extension = o.iextension;
                            let product_id = o.product_id;
                            o.toObject = (function (toObject) {
                                return function () {
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        {
                                            ctype: type1,
                                            objType: objType1,
                                            image_name: o.image_name,
                                            image_path: o.image_path,
                                            width_inch: o.width_inch,
                                            height_inch: o.height_inch,
                                            iextension: extension,
                                            product_id: product_id
                                        }
                                    );
                                };
                            })(o.toObject);
                            if (o.type !== "rect") {
                                _this.backCanvas.add(o);
                            }
                        });
                        _this.backCanvas.renderOnAddRemove =
                            origRenderOnAddRemove;
                        _this.backCanvas.preserveObjectStacking = true;
                        _this.backCanvas.renderAll();
                    }
                ); //end enlivenObjects
                _this.addDesignArea();
            }
        },
        getStoreDesign() {
            let _this = this;
            _this.active_flip = localStorage.getItem("active_flip");

            let canvasObject = JSON.stringify(_this.backCanvas);
            let canvasList1 = {};

            let previouscanvasList = {};
            previouscanvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (previouscanvasList != null) {
                if (
                    previouscanvasList["front"] != null &&
                    _this.active_flip != "front"
                ) {
                    canvasList1["front"] = previouscanvasList["front"];
                }
                if (
                    previouscanvasList["back"] != null &&
                    _this.active_flip != "back"
                ) {
                    canvasList1["back"] = previouscanvasList["back"];
                }
                if (
                    previouscanvasList["left"] != null &&
                    _this.active_flip != "left"
                ) {
                    canvasList1["left"] = previouscanvasList["left"];
                }
                if (
                    previouscanvasList["right"] != null &&
                    _this.active_flip != "right"
                ) {
                    canvasList1["right"] = previouscanvasList["right"];
                }
                if ("build_id" in previouscanvasList) {
                    canvasList1["build_id"] = previouscanvasList["build_id"];
                }
                if ("build_item_id" in previouscanvasList) {
                    canvasList1["build_item_id"] =
                        previouscanvasList["build_item_id"];
                }
            }
            canvasList1[_this.active_flip] = canvasObject;
            canvasList1["products_id"] = localStorage.getItem("product_id");
            canvasList1["distress_images"] = _this.distress_images;
            if (canvasList1["distress_images"][_this.active_flip]) {
                _this.add_distress_images = true;
            }
        },
        getClipartCliparts(category_id, clipart_category_name) {
            var _this = this;
            _this.isLoader = true;
            new Promise(() => {
                ApiService.post("/all-designStudioCliparts/" + category_id)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        (_this.cliparts = data.clipart_list.rows),
                            (_this.clipart_subcategory_div = true);
                        _this.clipart_category_div = false;
                        _this.selected_clipart_category_id = category_id;
                        _this.clipart_category_name = clipart_category_name;
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },
        auto_grow(element) {
            element.style.height = "5px";
            element.style.height = element.scrollHeight + "px";
        },

        //add_text tab
        signalChange(e) {
            document.querySelector("#rotationValue").value = Number(
                e.target.value
            );
            document.querySelector("#rotationValueInput").value = Number(
                e.target.value
            );
        },
        open_text_tab(tab) {
            if (tab == "add_text") {
                this.add_text = true;
                this.text_shape = false;
            } else if (tab == "text_shape") {
                this.add_text = false;
                this.text_shape = true;
            }
        },
        zoomin() {
            this.zoom_in = 1;
            this.zoom_out = 0;
            /* eslint-disable */
            if (this.zoom >= 1.15) {
                return false;
            } else {
                this.zoom += 0.05;
                $("#shirtDiv").css("transform", "scale(" + this.zoom + ")");
                $(".images-barr").slider({ value: this.zoom });
            }
            /* eslint-enable */
        },
        resize() {
            setTimeout(function () {
                if (window.canvas) window.canvas.calcOffset();
            }, 200);
        },
        zoomout() {
            this.zoom_out = 1;
            this.zoom_in = 0;
            /* eslint-disable */
            if (this.zoom <= 0.8) {
                return false;
            } else {
                this.zoom -= 0.05;
                $("#shirtDiv").css("transform", "scale(" + this.zoom + ")");
                $(".images-barr").slider({ value: this.zoom });
            }
            /* eslint-enable */
        },
        //ZOOM end
        //croppie function start
        bind() {
            /* eslint-disable */
            // Randomize cat photos, nothing special here.
            let url = this.images[Math.floor(Math.random() * 4)];
            this.$refs.croppieRef.bind({
                url: "/maincss/design-studio/img/design-st-upload.jpg"
            });
            fabricImageFromUrl;
            /* eslint-enable */
        },
        rotate(rotationAngle) {
            // Rotates the image
            this.$refs.croppieRef.rotate(rotationAngle);
        },
        croppie(e) {
            var _this = this;
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            /* eslint-enable */
            var files = e.target.files || e.dataTransfer.files;
            if (files && !files.length) return;
            this.image_size = files[0].size / (1024 * 1024);
            if (parseInt(this.image_size) > 5) {
                this.$toast.error(
                    "Size exceeded. Please upload image upto 5MB size."
                );
                return;
            }

            if (
                ![
                    "image/svg+xml",
                    "image/jpeg",
                    "image/png",
                    "image/jpg"
                ].includes(files[0]["type"])
            ) {
                this.$toast.error("Please upload jpeg, png, jpg only.", {
                    position: "top-right"
                });
            } else {
                this.crop_image_validation = 0;
                var reader = new FileReader();
                reader.onload = (e) => {
                    var image = new Image();
                    image.src = e.target.result;
                    image.onload = () => {
                        _this.uploaded_design_image = e.target.result;
                        _this.image_size_validation = 0;

                        this.image_uploaded = {
                            image: e.target.result,
                            size: _this.image_size.toFixed(2) + "MB",
                            dimension: image.width + "x" + image.height,
                            image_name: this.uploaded_image_name
                        };
                        _this.ImageUpload();
                    };
                };
            }

            reader.readAsDataURL(files[0]);
        },
        crop() {
            this.image_width = 200;
            this.image_height = 200;
            let options = {
                type: "base64",
                size: { width: this.image_width, height: this.image_height },
                format: "svg"
            };
            this.$refs.croppieRef.result(options, (output) => {
                this.croppieImage = output;
                // this.uploadImages.push({ image: this.croppieImage });
                this.image_uploaded = {
                    image: this.croppieImage,
                    size: this.image_size.toFixed(2) + "MB",
                    dimension: this.image_width + "x" + this.image_height
                };
            });
            this.ImageUpload();
        },
        //croppie function end

        //api method
        getTemplateData() {
            //get all template data
            /* eslint-disable */
            let product_type_temp_id = 0;
            product_type_temp_id = this.active_product_type;
            let productId = product_type_temp_id ? product_type_temp_id : 0;
            /* eslint-enable */
            //ApiService.get("/all-data-template/" + productId)
            ApiService.get("/all-data-template")
                .then(({ data }) => {
                    this.templates = data.all_data.templates;
                    let filtered_templates = [];
                    this.templates.forEach((template) => {
                        let subCategories = [];
                        template.DesignStudioTemplateSubCategories.forEach(
                            (subCat) => {
                                subCat.DesignStudioSaveTemplateModels =
                                    subCat.DesignStudioSaveTemplateModels.filter(
                                        (image) =>
                                            image.product_type_id ==
                                            this.active_product_type
                                    );
                                if (
                                    subCat.DesignStudioSaveTemplateModels
                                        .length > 0
                                ) {
                                    subCategories.push(subCat);
                                }
                            }
                        );
                        if (subCategories.length > 0) {
                            template.DesignStudioTemplateSubCategories =
                                subCategories;
                            filtered_templates.push(template);
                        }
                    });
                    this.templates = filtered_templates;
                })
                .catch(({ response }) => {
                    console.log(response);
                });
            //get saved designs
            if (this.isAuthenticatedClient) {
                ApiService.post("/saved-designs")
                    .then(({ data }) => {
                        this.savedDesigns = data.savedDesigns;
                        this.design_count = this.savedDesigns
                            ? this.savedDesigns.length
                            : 0;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            }
        },
        getData() {
            //get all
            ApiService.get("/all-data")
                .then(({ data }) => {
                    this.clipart_category = data.all_data.cliparts;
                    this.shapes = data.all_data.shapes;
                    this.patches = data.all_data.patches;
                })
                .catch(({ response }) => {
                    console.log(response);
                });
            //get saved designs
            if (this.isAuthenticatedClient) {
                ApiService.post("/saved-designs")
                    .then(({ data }) => {
                        this.savedDesigns = data.savedDesigns;
                        this.design_count = this.savedDesigns
                            ? this.savedDesigns.length
                            : 0;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            }
        },
        setNewDesign(id) {
            if (this.uploadModuleCanvas == 0) {
                this.uploadModuleCanvas++;
                this.saveCanvasData();
            }
            ApiService.get("/get-single-design/" + id)
                .then(({ data }) => {
                    let saved_json = data.design.canvas_json;
                    this.current_design_id = data.design.id;
                    let local_front_color = [];
                    let local_back_color = [];
                    let local_left_color = [];
                    let local_right_color = [];
                    console.log(data.design);
                    if (data.design.front_color != null) {
                        JSON.parse(data.design.front_color).forEach((color) => {
                            local_front_color.push(color.hex);
                        });
                    } else {
                        local_front_color = null;
                    }
                    if (data.design.back_color != null) {
                        JSON.parse(data.design.back_color).forEach((color) => {
                            local_back_color.push(color.hex);
                        });
                    } else {
                        local_back_color = null;
                    }
                    if (data.design.left_color != null) {
                        JSON.parse(data.design.left_color).forEach((color) => {
                            local_left_color.push(color.hex);
                        });
                    } else {
                        local_left_color = null;
                    }
                    if (data.design.right_color != null) {
                        JSON.parse(data.design.right_color).forEach((color) => {
                            local_right_color.push(color.hex);
                        });
                    } else {
                        local_right_color = null;
                    }
                    let color_obj = {
                        front: local_front_color,
                        back: local_back_color,
                        left: local_left_color,
                        right: local_right_color
                    };
                    localStorage.setItem(
                        "canvas_design_colors",
                        JSON.stringify(color_obj)
                    );

                    this.getClearCanvas(saved_json);
                    setTimeout(() => {
                        if (data.design.front_color != null)
                            this.prepareImprintLocations(true, "front");
                        if (data.design.back_color != null)
                            this.prepareImprintLocations(true, "back");
                        if (data.design.left_color != null)
                            this.prepareImprintLocations(true, "left");
                        if (data.design.right_color != null)
                            this.prepareImprintLocations(true, "right");
                    }, 1000);
                })
                .catch((response) => {
                    console.log(response);
                });
        },
        setNewTemplateDesign(template) {
            var _this = this;
            _this.saveCanvasData();
            let saved_json = template.canvas_json;
            this.current_design_id = template.id;
            this.getCopyClearCanvas(saved_json);
        },
        getCopyClearCanvas(saved_json) {
            let _this = this;

            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            _this.backCanvas.renderAll();

            let type = localStorage.getItem("active_flip");
            /* eslint-disable */
            $("." + type).addClass("active");
            /* eslint-enable */
            this.tshirtImage = this.background_image;
            let elem = document.querySelector("#tcanvas").parentNode;
            if (type == "front" || type == "back") {
                _this.updateImageToBackCanvas();
            } else {
                let square = new fabric.Rect({
                    width: 630,
                    height: 540,

                    fill: _this.user_selected_values[_this.active_gender_key]
                        .color_hash
                });
                if (_this.backCanvas._objects.length > 0) {
                    _this.backCanvas._objects.forEach((canvas_obj) => {
                        if (canvas_obj.type != "rect") {
                            _this.backCanvas.add(square);
                        }
                    });
                } else {
                    _this.backCanvas.add(square);
                }

                elem.classList.add("left_right_sleeve_canvas");
            }

            let json = JSON.parse(saved_json);
            if (this.saved_json_data == null) {
                this.saved_json_data = json;
                if (this.active_flip != "front") {
                    this.saved_json_data[this.active_flip] = json["front"];
                    delete this.saved_json_data["front"];
                }
            } else {
                this.saved_json_data[this.active_flip] = json["front"];
            }
            let front_flips = JSON.parse(
                this.saved_json_data[this.active_flip]
            );
            if (type == "left" || type == "right") {
                for (let obj of front_flips.objects) {
                    obj.left = obj.left + 180;
                    obj.top = obj.top + 62;
                }
                this.saved_json_data[this.active_flip] =
                    JSON.stringify(front_flips);
            }
            saved_json = JSON.stringify(this.saved_json_data);
            localStorage.setItem("new_canvas_elements", saved_json);
            this.getLocalDesign(type);
            _this.saveCanvasData();
        },
        getClearCanvas(saved_json) {
            let _this = this;
            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            _this.backCanvas.renderAll();
            /* eslint-disable */
            let type = "front";
            $("." + type).addClass("active");
            /* eslint-enable */
            if (this.active_flip == "front" || this.active_flip == "back")
                _this.updateImageToBackCanvas();
            localStorage.setItem("new_canvas_elements", saved_json);
            this.getLocalDesign(type);
            _this.saveCanvasData();
            this.active_gender_key = 0;
            localStorage.setItem("active_gender", this.active_gender);
            localStorage.setItem("active_gender_key", 0);
            localStorage.setItem(
                "active_tshirt_color",
                this.user_selected_values[this.active_gender_key].color_hash
            );
            this.tshirt_color =
                this.user_selected_values[this.active_gender_key].color_hash;
            if (
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ] &&
                this.canvas_elements[this.active_gender_key][this.active_gender]
                    .length > 0
            ) {
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true,
                                        originX: "center",
                                        originY: "center",
                                        centeredRotation: true
                                    });
                                    image.scaleToHeight(100);
                                    image.scaleToWidth(100);
                                    canvas.add(image);
                                },
                                null,
                                { crossOrigin: "Anonymous" }
                            );
                        }
                    }
                });
            }
        },
        // prev() {
        //     this.step--;
        // },
        // next() {
        //     this.step++;
        // },

        setDesign(saved_design) {
            var canvas = new fabric.Canvas("tcanvas", {
                hoverCursor: "pointer",
                selection: true,
                selectionBorderColor: "orange"
            });
            //set canvas objects while selecting design
            this.canvas_elements = "";
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            let product_details = saved_design.product_details;
            let values = [];
            this.user_selected_values = [];
            this.product_title = saved_design["product_title"];
            this.product_number = saved_design["product_number"];
            this.product_id = saved_design.id;
            this.design_name = saved_design.design_name;
            this.base_price = saved_design.retail_base_price;
            this.base_price = this.base_price.toFixed(2);
            let gender = product_details[0].gender;
            product_details.forEach((element) => {
                values.push({
                    [element.gender]: JSON.parse(element.canvas_objects)
                });
                this.genders.push(element.gender);
            });

            this.canvas_elements = values;
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            this.active_gender = gender;
            this.active_gender_key = 0;
            localStorage.setItem("active_gender", gender);
            localStorage.setItem("active_gender_key", 0);
            document.querySelector("#tshirtFacing").style.background =
                this.user_selected_values[0].color_hash;
            localStorage.setItem(
                "active_tshirt_color",
                this.user_selected_values[0].color_hash
            );
            this.tshirt_color = this.user_selected_values[0].color_hash;
            if (
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ] &&
                this.canvas_elements[this.active_gender_key][this.active_gender]
                    .length > 0
            ) {
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true,
                                        originX: "center",
                                        originY: "center",
                                        centeredRotation: true
                                    });
                                    image.scaleToHeight(100);
                                    image.scaleToWidth(100);
                                    canvas.add(image);
                                },
                                null,
                                { crossOrigin: "Anonymous" }
                            );
                        }
                    }
                });
            }
        },
        prev() {
            this.step--;
        },
        next() {
            this.step++;
        },

        flipTshirt(type) {
            var _this = this;
            if (_this.colors_validation) {
                this.$toast.error(this.colors_validation, {
                    position: "top-right",
                    queue: true
                });
                return true;
            }
            _this.resetElements(type);
            let selected_design_images = [];
            /* eslint-disable */
            if (type == "front") {
                $("#back_flipbtn").prop("disabled", true);
                $("#front_flipbtn").prop("disabled", false);
                $("#left_flipbtn").prop("disabled", false);
                $("#right_flipbtn").prop("disabled", false);
            }
            if (type == "back") {
                $("#back_flipbtn").prop("disabled", false);
                $("#front_flipbtn").prop("disabled", true);
                $("#left_flipbtn").prop("disabled", false);
                $("#right_flipbtn").prop("disabled", false);
            }
            if (type == "left") {
                $("#back_flipbtn").prop("disabled", false);
                $("#front_flipbtn").prop("disabled", false);
                $("#left_flipbtn").prop("disabled", true);
                $("#right_flipbtn").prop("disabled", false);
            }
            if (type == "right") {
                $("#back_flipbtn").prop("disabled", false);
                $("#front_flipbtn").prop("disabled", false);
                $("#left_flipbtn").prop("disabled", false);
                $("#right_flipbtn").prop("disabled", true);
            }
            /* eslint-enable */
            //   let design_items = JSON.parse(localStorage.getItem("design"));
            // USE gender_groups_items local variable
            let design_items = this.gender_groups_items;

            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
            _this.design_current_colors = [];
            let design_images = JSON.parse(
                design_items[0]["colors"][this.activeColorIndex].id
            );
            let ele_img_front;
            let ele_img_back;
            // if (JSON.parse(get_product).product_type_id == 0) {
            design_items[0]["item"]["NewProductImages"].forEach((colors) => {
                if (
                    colors.color_id == design_images &&
                    colors.type == "front"
                ) {
                    selected_design_images.push({
                        front: colors.url
                    });
                }
                if (colors.color_id == design_images && colors.type == "back") {
                    // selected_design_images['back'] = colors.url
                    selected_design_images.push({
                        back: colors.url
                    });
                }
            });

            var front_img_required;
            var back_img_required;
            var default_color_img;
            if (selected_design_images.length > 0) {
                let filter_img = selected_design_images.filter(
                    (img) => "front" in img
                );
                if (filter_img.length > 0) {
                    ele_img_front = filter_img[0]["front"];
                } else {
                    front_img_required = true;
                }
                if (selected_design_images.length > 0) {
                    let filter_img = selected_design_images.filter(
                        (img) => "back" in img
                    );

                    if (filter_img.length > 0) {
                        ele_img_back = filter_img[0]["back"];
                    } else {
                        back_img_required = true;
                    }
                }
            } else {
                ele_img_front = "";
                ele_img_back = "";
            }
            // }
            Object.values(_this.design_area_data).forEach((element) => {
                if (element.label == "Front" && type == "front") {
                    // if (JSON.parse(get_product).product_type_id == 0) {
                    let def_color = design_items[0]["item"][
                        "NewProductImages"
                    ].filter(
                        (color) =>
                            color.color_id == design_images &&
                            color.type != "front" &&
                            color.type != "back"
                    );
                    if (def_color.length > 0) {
                        default_color_img = def_color[0].url;
                    }
                    _this.background_image = ele_img_front
                        ? ele_img_front
                        : default_color_img;
                    if (front_img_required) {
                        _this.$toast.error(
                            "please add front image for selected color",
                            {
                                position: "top-right",
                                queue: true
                            }
                        );
                    }
                    // } else {
                    //   _this.background_image = _this.apiurl + element.thumbnail;
                    // }
                    // _this.background_image = ele_img_front ? ele_img_front : element.thumbnail;

                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
                if (element.label == "Back" && type == "back") {
                    let def_color = design_items[0]["item"][
                        "NewProductImages"
                    ].filter(
                        (color) =>
                            color.color_id == design_images &&
                            color.type != "front" &&
                            color.type != "back"
                    );
                    if (def_color.length > 0) {
                        default_color_img = def_color[0].url;
                    }
                    _this.background_image = ele_img_back
                        ? ele_img_back
                        : default_color_img;
                    if (back_img_required) {
                        _this.$toast.error(
                            "please add back image for selected color",
                            {
                                position: "top-right",
                                queue: true
                            }
                        );
                    }

                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
                if (element.label == "Left" && type == "left") {
                    _this.background_image_sleeve =
                        _this.apiurl + element.thumbnail;
                    _this.popup_canvas_height = element.height;
                    _this.popup_canvas_width = element.width;
                    _this.popup_canvas_top = element.top;
                    _this.popup_canvas_left = element.left;
                    _this.front_canvas_top = 0;
                    _this.front_canvas_left = 0;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
                if (element.label == "Right" && type == "right") {
                    _this.background_image = _this.apiurl + element.thumbnail;
                    _this.popup_canvas_height = element.height;
                    _this.popup_canvas_width = element.width;
                    _this.popup_canvas_top = element.top;
                    _this.popup_canvas_left = element.left;
                    _this.front_canvas_top = 0;
                    _this.front_canvas_left = 0;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
            });

            let canvasObject = JSON.stringify(_this.backCanvas);

            if (_this.canvasList == null) {
                _this.canvasList = { front: "", back: "", left: "", right: "" };
            }
            this.canvasList[_this.active_flip] = canvasObject;
            // localStorage.setItem(
            //     "new_canvas_elements",
            //     JSON.stringify(this.canvasList)
            // );
            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            //_this.backCanvas.renderAll();
            _this.canvasList = { front: "", back: "", left: "", right: "" };

            localStorage.setItem("active_flip", type);
            this.active_flip = type;

            let currentFlip =
                this.active_flip.charAt(0).toUpperCase() +
                this.active_flip.slice(1);
            let currentData = this.current_print_area.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });
            let productData = this.design_area_data.filter(function (
                printData
            ) {
                if (printData.label.includes(currentFlip)) return printData;
            });
            this.front_canvas_width_inch =
                productData.length > 0
                    ? parseFloat(productData[0].widthIn)
                    : parseFloat(currentData[0].widthIn);
            this.front_canvas_height_inch =
                productData.length > 0
                    ? parseFloat(productData[0].heightIn)
                    : parseFloat(currentData[0].heightIn);

            this.canvasList = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (this.canvasList[this.active_flip]) {
                fabric.util.enlivenObjects(
                    JSON.parse(this.canvasList[this.active_flip]).objects,
                    function (objects) {
                        var origRenderOnAddRemove =
                            _this.backCanvas.renderOnAddRemove;
                        _this.backCanvas.renderOnAddRemove = false;
                        objects.forEach(function (o) {
                            let type1 = o.ctype;
                            let onjType1 = o.objType;
                            let extension = o.iextension;
                            let product_id = o.product_id;
                            o.toObject = (function (toObject) {
                                return function () {
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        {
                                            ctype: type1,
                                            iextension: extension,
                                            image_name: o.image_name,
                                            image_path: o.image_path,
                                            width_inch: o.width_inch,
                                            height_inch: o.height_inch,
                                            objType: onjType1,
                                            product_id: product_id
                                        }
                                    );
                                };
                            })(o.toObject);
                            if (o.type !== "rect") {
                                _this.backCanvas.add(o);
                            }
                        });
                        _this.backCanvas.renderOnAddRemove =
                            origRenderOnAddRemove;
                        _this.backCanvas.renderAll();
                    }
                ); //end enlivenObjects
            }
            /* eslint-disable */
            $("." + type).addClass("active");
            /* eslint-enable */
            this.tshirtImage = _this.background_image;
            fabric.Object.prototype.objectCaching = false;
            let elem = document.querySelector("#tcanvas").parentNode;
            let elem_image = document.querySelector("#bcanvas").parentNode;
            if (type == "front" || type == "back") {
                _this.imageCanvas.setBackgroundColor(
                    "",
                    _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                );
                _this.imageCanvas.renderAll();
                _this.updateImageToBackCanvas(_this.background_image);
                _this.addDesignArea();
                elem.classList.remove("left_right_sleeve_canvas");
                elem_image.classList.remove("left-right-tshirt");
            } else {
                let activeColor = localStorage.getItem("active_tshirt_color");
                fabric.Object.prototype.objectCaching = false;
                _this.imageCanvas.clear();
                _this.imageCanvas.renderAll();
                _this.background_image = "";
                _this.imageCanvas.backgroundImage = 0;
                _this.imageCanvas.setBackgroundColor(
                    activeColor == "null" ||
                        activeColor == "#null" ||
                        activeColor == ""
                        ? "#FFFFFF"
                        : activeColor,
                    _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                );
                _this.imageCanvas.renderAll();

                elem.classList.add("left_right_sleeve_canvas");
                elem_image.classList.add("left-right-tshirt");
            }
            if (_this.distress_images[_this.active_flip]) {
                _this.updateDistressImage(
                    _this.distress_images[_this.active_flip]
                );
            } else {
                _this.selectedDistressImage = null;
            }

            if (this.showNameNumber) {
                const selected_name_number =
                    design_items[this.active_gender_key]["colors"][
                        this.activeColorIndex
                    ].selected_name_number;
                console.log(selected_name_number, selected_name_number[type]);
                const isNameNumberExist =
                    selected_name_number[type] &&
                    (selected_name_number[type].name ||
                        selected_name_number[type].number);
                if (["front", "back"].includes(type) && !isNameNumberExist) {
                    this.$toast.error(
                        `For this build, there is no selection of the ${type} location`,
                        { position: "top-right", queue: true }
                    );
                }
                console.log("isNameNumberExist", isNameNumberExist);
                const dashboardPanel = document.getElementById("default1");
                const nameNumberPanel = document.getElementById("nn-tab");
                if (type == "back" && isNameNumberExist) {
                    this.$refs.nameAndNumberRef.enableName();
                    nameNumberPanel.classList.add("active", "show");
                    dashboardPanel.classList.remove("active", "show");
                } else if (type == "front" && isNameNumberExist) {
                    this.$refs.nameAndNumberRef.disableName();
                    nameNumberPanel.classList.add("active", "show");
                    dashboardPanel.classList.remove("active", "show");
                } else {
                    nameNumberPanel.classList.remove("active", "show");
                    dashboardPanel.classList.add("active", "show");
                }
            }

            this.$refs.nameAndNumberRef.loadNameAndNumber(
                design_items[this.active_gender_key]["colors"][
                    this.activeColorIndex
                ],
                2
            );
            let imprint_locations =
                this.gender_groups_items[this.active_gender_key]
                    .imprint_locations;
            if (imprint_locations.length > 0) {
                let imprint_location_index = imprint_locations.findIndex(
                    (location) =>
                        location.location.toLowerCase().trim() ==
                        this.active_flip
                );
                if (imprint_location_index != -1) {
                    this.gender_groups_items[
                        this.active_gender_key
                    ].imprint_locations.forEach((location, key) => {
                        if (key != imprint_location_index) {
                            this.gender_groups_items[
                                this.active_gender_key
                            ].imprint_locations[key].collapse = false;
                        }
                    });
                    this.$refs.ItemDetails.updateAccordianFlip(
                        imprint_location_index
                    );
                }
            }
        },
        check_tshirt_position(array, id, flip) {
            var r = false;
            var prev_id = "";
            if (array)
                for (var i = 0; i < array.length; i++) {
                    if (prev_id != id) {
                        if (flip === array[i].flip && array[i].id === id) {
                            r = array[i].id === id;
                        }
                        if (r == true) {
                            prev_id = id;
                        }
                    }
                }

            return r;
        },
        delete_object() {
            let _this = this;

            var activeObject = _this.backCanvas.getActiveObject();
            let activeGroup = _this.backCanvas.getActiveObject();
            /* eslint-disable */
            if (activeObject) {
                _this.backCanvas.remove(activeObject);
                $("#text-string").val("");
                _this.backCanvas.discardActiveObject().renderAll();
            } else if (activeGroup) {
                var objectsInGroup = activeGroup.getObjects();
                _this.backCanvas.discardActiveGroup();
                objectsInGroup.forEach(function (object) {
                    _this.backCanvas.remove(object);
                });
            }
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            _this.onSelectedCleared();
            setTimeout(() => {
                this.prepareImprintLocations();
            }, 1000);
        },
        closeEdit(type) {
            let _this = this;
            /* eslint-disable */
            _this.sideBarCanvasStatus = false;
            if (type == "templates") {
                _this.selected_category_heading = false;
                _this.selected_template_category_show = false;
                _this.category_heading = true;
                this.edit_template = false;
                var category_object = JSON.parse(
                    localStorage.getItem("category_object")
                );

                _this.selected_template_category = category_object;
                _this.template_name = category_object.name;
                let canvasele =
                    this.canvas_elements[this.active_gender_key][
                        this.active_gender
                    ];
                category_object["template_images"].some(function (item, indx) {
                    if (
                        _this.check_tshirt_position(
                            canvasele,
                            item.category_id + "" + indx,
                            _this.active_flip
                        )
                    ) {
                        category_object["template_images"][
                            indx
                        ].selected_images = true;
                    } else {
                        category_object["template_images"][
                            indx
                        ].selected_images = false;
                        _this.showMenu();
                    }
                });
            } else if (type == "clipart") {
                this.category_heading = true;
                this.edit_template = false;
                this.selected_clipart_category_show = false;
                var category_object = JSON.parse(
                    localStorage.getItem("category_object")
                );
                let activeObject = _this.backCanvas.getActiveObject();
                let clipart_image_data = this.all_cliparts_images.filter(
                    (item) => {
                        return activeObject.image_name
                            .toLowerCase()
                            .split(" ")
                            .every((v) =>
                                item.image_name.toLowerCase().includes(v)
                            );
                    }
                );
                let clipart_sub_category_id =
                    clipart_image_data[0].des_std_clipart_id;
                let clipart_sub_category_data = "";
                this.clipart_category.map((item) => {
                    let image_category = item.DesignStudioClipartModels.filter(
                        (item1) => {
                            return item1.id == clipart_sub_category_id;
                        }
                    );
                    if (image_category.length > 0) {
                        clipart_sub_category_data = item;
                    }
                });
                _this.getClipartCliparts(
                    clipart_sub_category_data.id,
                    clipart_sub_category_data.category_name
                );
            } else if (type == "patch") {
                this.category_heading = true;
                this.edit_template = false;
                this.selected_clipart_category_show = false;
                this.selected_clipart_category = "";
                this.clipart_name = "";
            }
            if (type == "shape" || type == "upload") {
                this.category_heading = true;
                this.edit_template = false;
                this.selected_clipart_category_show = false;
                this.selected_clipart_category = "";
                this.clipart_name = "";
            }
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            _this.rotationAngle = 0;
            this.backCanvas.discardActiveObject().renderAll();
            _this.showMenu();
        },
        getImages(category_object, type, index) {
            let _this = this;
            localStorage.setItem("type", type);
            localStorage.setItem("index", index);
            localStorage.setItem(
                "category_object",
                JSON.stringify(category_object)
            );
            this.selected_category_heading = true;
            if (type == "templates") {
                this.getCategoryTemplates(category_object.id).then((data) => {
                    category_object.template_images = data.template_designs;
                    let canvasele =
                        this.canvas_elements[this.active_gender_key][
                            this.active_gender
                        ];

                    category_object["template_images"].some(function (
                        item,
                        indx
                    ) {
                        if (
                            _this.check_tshirt_position(
                                canvasele,
                                item.category_id + "" + indx,
                                _this.active_flip
                            )
                        ) {
                            category_object["template_images"][
                                indx
                            ].selected_images = true;
                        } else {
                            category_object["template_images"][
                                indx
                            ].selected_images = false;
                        }
                    });
                    this.selected_template_category_show = true;
                    this.category_heading = false;
                    this.edit_template = false;
                    this.template_name = category_object.name;
                    this.selected_template_category = category_object;
                    this.$forceUpdate();
                });
            } else if (type == "clipart") {
                this.category_heading = false;
                this.edit_template = false;
                this.selected_clipart_category_show = true;
                this.selected_clipart_category = category_object;
                this.clipart_name = category_object.name;
            }
        },
        getPopularCliparts(loader = true) {
            return new Promise((resolve, reject) => {
                this.isLoader = loader;
                ApiService.get("/popular-cliparts")
                    .then(({ data }) => {
                        this.isLoader = false;
                        this.show_popular_cliparts = data.cliparts.length > 0;
                        this.all_cliparts_images = data.all_cliparts_images;
                        resolve(data);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        console.log(response);
                        reject(response);
                    });
            });
        },
        showPopularCliparts() {
            this.getPopularCliparts().then((data) => {
                this.selected_category_heading = true;
                this.category_heading = false;
                this.edit_template = false;
                this.selected_clipart_category_show = true;
                this.selected_clipart_category = {
                    id: "PopularC",
                    DesignStudioClipartImagesModels: data.cliparts
                };
                this.clipart_name = "Popular";
                this.clipart_category_div = false;
                this.clipart_subcategory_div = true;
            });
        },
        getCategoryTemplates(sub_category_id) {
            this.isLoader = true;
            return new Promise((resolve, reject) => {
                ApiService.get(`/template-designs/${sub_category_id}`)
                    .then(({ data }) => {
                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        reject(response);
                    });
            });
        },
        getPopularTemplates(loader = true) {
            return new Promise((resolve, reject) => {
                this.isLoader = loader;
                ApiService.get("/popular-templates")
                    .then(({ data }) => {
                        this.isLoader = false;
                        let same_product_popular = [];
                        same_product_popular = data.templates;

                        this.show_popular_templates =
                            same_product_popular.length > 0;
                        this.all_templates_images = data.all_templates_images;

                        resolve(data);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        console.log(response);
                        reject(response);
                    });
            });
        },
        showPopularTemplates() {
            this.getPopularTemplates().then((data) => {
                let same_product_temp = [];
                same_product_temp = data.templates.filter(
                    (new_template) =>
                        new_template.product_type_id == this.active_product_type
                );

                this.selected_template_subcategory = {
                    id: "PopularT",
                    template_images: same_product_temp
                };
                this.selected_category_heading = true;
                this.selected_template_category_show = false;
                this.selected_template_subcategory_show = true;
                this.category_heading = false;
                this.edit_template = false;
                this.template_name = "Popular";
                this.$forceUpdate();
            });
        },
        selectTemplateCategory(category) {
            this.selected_category_heading = true;
            this.selected_template_category_show = true;
            this.category_heading = false;
            this.edit_template = false;
            this.template_name = category.name;
            this.selected_template_category = category;
            this.$forceUpdate();
        },
        getCustomImages(sub_category) {
            this.getCategoryTemplates(sub_category.id).then((data) => {
                sub_category.template_images = [];
                data.template_designs.forEach((template_design) => {
                    if (
                        (template_design.product_category_id == null ||
                            parseInt(template_design.product_category_id) ==
                                parseInt(this.product_items.category_id)) &&
                        template_design.product_type_id ==
                            this.active_product_type
                    ) {
                        sub_category.template_images.push(template_design);
                    }
                });
                this.selected_category_heading = true;
                this.selected_template_category_show = false;
                this.selected_template_subcategory_show = true;
                this.category_heading = false;
                this.edit_template = false;
                this.template_name = sub_category.name;
                this.selected_template_subcategory = sub_category;
                this.$forceUpdate();
            });
        },
        EditImages(type) {
            //debugger;
            this.selected_category_heading = false;
            if (type == "templates") {
                this.selectedType = "templates";
            } else if (type == "clipart") {
                this.selectedType = "clipart";
            } else if (type == "patch") {
                this.selectedType = "patch";
            } else if (type == "shape") {
                this.selectedType = "shape";
            } else if (type == "upload") {
                this.selectedType = "upload";
            }
            this.selected_template_category_show = false;
            this.selected_clipart_category_show = false;

            this.category_heading = false;
            this.edit_template = true;
        },
        placeImage(
            event,
            selected_image,
            template_category_id,
            selected_image_index,
            type,
            image_data
        ) {
            let _this = this;
            if (_this.uploadModuleCanvas == 0) {
                _this.uploadModuleCanvas++;
                _this.saveCanvasData();
            }
            if (event.target.checked) {
                var offset = 50;
                var left = 0;
                var top = 0;
                if (
                    _this.active_flip == "front" ||
                    _this.active_flip == "back"
                ) {
                    var w =
                        (_this.front_canvas_width ||
                            fabric.util.getRandomInt(
                                0 + offset,
                                200 - offset
                            )) / 2;
                    var h = _this.front_canvas_height / 2;
                    left = _this.front_canvas_left + w;
                    top = _this.front_canvas_top + h;
                } else {
                    left = _this.defaultWidthCanvas / 2;
                    top = _this.defaultHeightCanvas / 2;
                }
                var angle = fabric.util.getRandomInt(-20, 40);
                var padding = 10;
                var cornersize = 10;
                this.isLoader = true;

                selected_image = this.loadImageFromCrossOrigin(selected_image);

                if (selected_image.indexOf(".svg") == -1) {
                    fabric.Image.fromURL(
                        selected_image,
                        function (image) {
                            image.set({
                                id:
                                    template_category_id +
                                    "" +
                                    selected_image_index,
                                ctype: type,
                                asas: "ssd",
                                image_name: image_data.image_name,
                                image_path: image_data.image_path,
                                height_inch: "",
                                width_inch: "",
                                left: left,
                                top: top,
                                angle: angle,
                                padding: padding,
                                cornersize: cornersize,
                                hasRotatingPoint: true,
                                originX: "center",
                                originY: "center",
                                centeredRotation: true
                            });
                            image.scaleToHeight(100);
                            image.scaleToWidth(100);
                            if (
                                _this.active_flip == "front" ||
                                _this.active_flip == "back"
                            ) {
                                image.set("clipPath", _this.design_box);
                            }
                            _this.backCanvas.add(image);
                            _this.selectImageProps = { rotation: 0 };
                            _this.backCanvas.setActiveObject(image);
                            _this.saveCanvasData();
                            _this.EditImages(type);
                            _this.isLoader = false;
                        },
                        { crossOrigin: "Anonymous" }
                    );
                } else {
                    fabric.loadSVGFromURL(
                        selected_image,
                        function (objects, options) {
                            // here I load SVG image
                            var shape = fabric.util.groupSVGElements(
                                objects,
                                options
                            );

                            var originalColors = [];
                            shape.set({
                                id:
                                    "'" +
                                    template_category_id +
                                    "" +
                                    selected_image_index +
                                    "'",
                                ctype: type,
                                iextension: "svg",
                                asas: "ssd",
                                image_name: image_data.image_name,
                                image_path: image_data.image_path,
                                height_inch: "",
                                width_inch: "",
                                left: left,
                                top: top,
                                originalColors,
                                angle: angle,
                                padding: 0,
                                cornersize: 0,
                                hasRotatingPoint: true,
                                originX: "center",
                                originY: "center",
                                centeredRotation: true,
                                clipPath: null
                            });

                            shape.scaleToWidth(100);

                            shape.toObject = (function (toObject) {
                                return function () {
                                    return fabric.util.object.extend(
                                        toObject.call(this),
                                        {
                                            ctype: type,
                                            image_name: image_data.image_name,
                                            image_path: image_data.image_path,
                                            width_inch: "",
                                            height_inch: "",
                                            iextension: "svg",
                                            products_id:
                                                localStorage.getItem(
                                                    "product_id"
                                                )
                                        }
                                    );
                                };
                            })(shape.toObject);
                            if (
                                _this.active_flip == "front" ||
                                _this.active_flip == "back"
                            ) {
                                shape.set("clipPath", _this.design_box);
                                shape.set("controlsAboveOverlay", true);
                            }
                            shape.scaleToHeight(100);
                            _this.selectImageProps = { rotation: 0 };
                            _this.backCanvas.add(shape);
                            _this.backCanvas.setActiveObject(shape);

                            // here we just save object in localstorage
                            _this.saveCanvasData();
                            _this.active_flip =
                                localStorage.getItem("active_flip");
                            _this.imagesSelectedCanvasType = _this.active_flip;
                            _this.EditImages(type);
                            _this.isLoader = false;
                            // here we just save object in localstorage
                            _this.active_flip =
                                localStorage.getItem("active_flip");
                            let canvasObject = JSON.stringify(_this.backCanvas);
                            let canvasList1 = {};
                            let previouscanvasList = {};
                            previouscanvasList = JSON.parse(
                                localStorage.getItem("new_canvas_elements")
                            );
                            if (previouscanvasList != null) {
                                if (
                                    previouscanvasList["front"] != null &&
                                    _this.active_flip != "front"
                                ) {
                                    canvasList1["front"] =
                                        previouscanvasList["front"];
                                }
                                if (
                                    previouscanvasList["back"] != null &&
                                    _this.active_flip != "back"
                                ) {
                                    canvasList1["back"] =
                                        previouscanvasList["back"];
                                }
                                if (
                                    previouscanvasList["left"] != null &&
                                    _this.active_flip != "left"
                                ) {
                                    canvasList1["left"] =
                                        previouscanvasList["left"];
                                }
                                if (
                                    previouscanvasList["right"] != null &&
                                    _this.active_flip != "right"
                                ) {
                                    canvasList1["right"] =
                                        previouscanvasList["right"];
                                }
                            }
                            canvasList1[_this.active_flip] = canvasObject;
                            (canvasList1["products_id"] =
                                localStorage.getItem("product_id")),
                                localStorage.setItem(
                                    "new_canvas_elements",
                                    JSON.stringify(canvasList1)
                                );
                        },
                        null,
                        { crossOrigin: "Anonymous" }
                    );
                }
                if (
                    _this.canvas_elements[_this.active_gender_key] &&
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ] &&
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ].length == 0
                ) {
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ].push({
                        id: template_category_id + "" + selected_image_index,
                        url: selected_image,
                        ctype: type,
                        left: left,
                        top: top,
                        padding: padding,
                        cornersize: cornersize,
                        angle: angle,
                        flip: localStorage.getItem("active_flip")
                    });
                } else {
                    _this.canvas_elements[_this.active_gender_key][
                        _this.active_gender
                    ].push({
                        id: template_category_id + "" + selected_image_index,
                        url: selected_image,
                        ctype: type,
                        left: left,
                        top: top,
                        padding: padding,
                        cornersize: cornersize,
                        angle: angle,
                        flip: localStorage.getItem("active_flip")
                    });
                }
                localStorage.setItem(
                    "canvas_elements",
                    JSON.stringify(_this.canvas_elements)
                );
                _this.rotationAngle = 0;
                if (
                    _this.imagesSelectedCanvasType !=
                    localStorage.getItem("active_flip")
                ) {
                    _this.saveCanvasData();
                }
                if (_this.redo.length > 0 && _this.undo.length == 0) {
                    _this.saveCanvasData();
                }
            }
        },
        bindUploadedDesignImage(selected_image, image_data) {
            let _this = this;
            var offset = 50;
            var left = 0;
            var top = 0;
            if (_this.active_flip == "front" || _this.active_flip == "back") {
                var w =
                    (_this.front_canvas_width ||
                        fabric.util.getRandomInt(0 + offset, 200 - offset)) / 2;
                var h = _this.front_canvas_height / 2;
                left = _this.front_canvas_left + w;
                top = _this.front_canvas_top + h;
            } else {
                left = _this.defaultWidthCanvas / 2;
                top = _this.defaultHeightCanvas / 2;
                //var top = 542 / 2;
            }
            if (_this.uploadModuleCanvas == 0) {
                _this.uploadModuleCanvas++;
                _this.saveCanvasData();
            }
            var angle = fabric.util.getRandomInt(-20, 40);
            var padding = 10;
            var cornersize = 10;
            if (selected_image.indexOf(".svg") == -1) {
                fabric.Image.fromURL(
                    selected_image,
                    function (image) {
                        image.set({
                            id: 0,
                            ctype: "upload",
                            iextension: "png",
                            asas: "ssd",
                            width_inch: "",
                            height_inch: "",
                            left: left,
                            top: top,
                            angle: angle,
                            padding: padding,
                            cornersize: cornersize,
                            hasRotatingPoint: true,
                            originX: "center",
                            originY: "center",
                            centeredRotation: true
                        });
                        image.scaleToHeight(100);
                        image.scaleToWidth(100);
                        image.toObject = (function (toObject) {
                            return function () {
                                return fabric.util.object.extend(
                                    toObject.call(this),
                                    {
                                        ctype: "upload",
                                        iextension: "png",
                                        image_name: image_data.image_name,
                                        image_path: image_data.image,
                                        width_inch: "",
                                        height_inch: "",
                                        products_id:
                                            localStorage.getItem("product_id")
                                    }
                                );
                            };
                        })(image.toObject);
                        if (
                            _this.active_flip == "front" ||
                            _this.active_flip == "back"
                        ) {
                            image.set("clipPath", _this.design_box);
                        }
                        _this.backCanvas.add(image);
                        _this.selectImageProps = { rotation: 0 };
                        _this.backCanvas.setActiveObject(image);
                        _this.saveCanvasData();
                    },
                    null,
                    { crossOrigin: "anonymous" }
                );
            } else {
                fabric.loadSVGFromURL(
                    selected_image,
                    function (objects, options) {
                        // here I load SVG image
                        var shape = fabric.util.groupSVGElements(
                            objects,
                            options
                        );

                        var originalColors = [];
                        shape.set({
                            id: 0,
                            ctype: "upload",
                            iextension: "svg",
                            asas: "ssd",
                            width_inch: "",
                            height_inch: "",
                            left: left,
                            top: top,
                            originalColors,
                            angle: angle,
                            padding: 0,
                            cornersize: 0,
                            hasRotatingPoint: true,
                            originX: "center",
                            originY: "center",
                            centeredRotation: true
                        });

                        shape.scaleToWidth(100);
                        shape.toObject = (function (toObject) {
                            return function () {
                                return fabric.util.object.extend(
                                    toObject.call(this),
                                    {
                                        ctype: "upload",
                                        iextension: "svg",
                                        image_name: image_data.image_name,
                                        image_path: image_data.image,
                                        width_inch: "",
                                        height_inch: "",
                                        products_id:
                                            localStorage.getItem("product_id")
                                    }
                                );
                            };
                        })(shape.toObject);
                        shape.scaleToHeight(100);
                        _this.selectImageProps = { rotation: 0 };
                        if (
                            _this.active_flip == "front" ||
                            _this.active_flip == "back"
                        ) {
                            shape.set("clipPath", _this.design_box);
                        }
                        _this.backCanvas.add(shape);
                        _this.backCanvas.setActiveObject(shape);
                        _this.saveCanvasData();

                        _this.active_flip = localStorage.getItem("active_flip");
                        _this.imagesSelectedCanvasType = _this.active_flip;
                        let canvasObject = JSON.stringify(_this.backCanvas);
                        let canvasList1 = {};
                        let previouscanvasList = {};
                        previouscanvasList = JSON.parse(
                            localStorage.getItem("new_canvas_elements")
                        );
                        if (previouscanvasList != null) {
                            if (
                                previouscanvasList["front"] != null &&
                                _this.active_flip != "front"
                            ) {
                                canvasList1["front"] =
                                    previouscanvasList["front"];
                            }
                            if (
                                previouscanvasList["back"] != null &&
                                _this.active_flip != "back"
                            ) {
                                canvasList1["back"] =
                                    previouscanvasList["back"];
                            }
                            if (
                                previouscanvasList["left"] != null &&
                                _this.active_flip != "left"
                            ) {
                                canvasList1["left"] =
                                    previouscanvasList["left"];
                            }
                            if (
                                previouscanvasList["right"] != null &&
                                _this.active_flip != "right"
                            ) {
                                canvasList1["right"] =
                                    previouscanvasList["right"];
                            }
                        }
                        canvasList1[_this.active_flip] = canvasObject;
                        (canvasList1["products_id"] =
                            localStorage.getItem("product_id")),
                            localStorage.setItem(
                                "new_canvas_elements",
                                JSON.stringify(canvasList1)
                            );
                    },
                    null,
                    { crossOrigin: "anonymous" }
                );
            }
            if (
                _this.canvas_elements[_this.active_gender_key] &&
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ] &&
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ].length == 0
            ) {
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ].push({
                    id: 0,
                    url: selected_image,
                    ctype: "upload",
                    left: left,
                    top: top,
                    padding: padding,
                    cornersize: cornersize,
                    angle: angle,
                    flip: localStorage.getItem("active_flip")
                });
            } else {
                _this.canvas_elements[_this.active_gender_key][
                    _this.active_gender
                ].push({
                    id: 0,
                    url: selected_image,
                    ctype: "upload",
                    left: left,
                    top: top,
                    padding: padding,
                    cornersize: cornersize,
                    angle: angle,
                    flip: localStorage.getItem("active_flip")
                });
            }
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(_this.canvas_elements)
            );

            if (
                _this.imagesSelectedCanvasType !=
                localStorage.getItem("active_flip")
            ) {
                _this.saveCanvasData();
            }
        },
        showMenu(resetActiveObject, id) {
            /* eslint-disable */
            let active = $(".main_panel_check.show.active");
            /* eslint-enable */
            if (
                active.length == 1 &&
                (active[0].getAttribute("aria-labelledby") == id ||
                    typeof id === "undefined")
            ) {
                //active.removeClass("show").removeClass("active");
                //return false;
            } else {
                active.removeClass("show").removeClass("active");
            }
            this.disable_tshirt_canvas = false;

            this.active_class = "";
            this.selected_category_heading = false;
            this.category_heading = true;
            this.selected_template_category_show = false;
            this.selected_template_subcategory_show = false;
            this.selected_clipart_category_show = false;
            this.edit_template = false;
            if (resetActiveObject && this.backCanvas) {
                var activeObject = this.backCanvas.getActiveObjects();

                if (Object.entries(activeObject).length > 0) {
                    activeObject[0].canvas.discardActiveObject().renderAll();
                }
                this.onSelectedCleared();
            }
            if (id == "nn-tab1") {
                const selected_name_number =
                    this.gender_groups_items[this.active_gender_key]["colors"][
                        this.activeColorIndex
                    ].selected_name_number;
                const frontNameNumberSelected =
                    selected_name_number["front"] &&
                    (selected_name_number["front"].name ||
                        selected_name_number["front"].number);
                const backNameNumberSelected =
                    selected_name_number["back"] &&
                    (selected_name_number["back"].name ||
                        selected_name_number["back"].number);
                if (this.back_show && backNameNumberSelected) {
                    this.$refs.nameAndNumberRef.enableName();
                    this.flipTshirt("back");
                } else if (this.front_show && frontNameNumberSelected) {
                    this.flipTshirt("front");
                    this.$refs.nameAndNumberRef.disableName();
                }

                this.selectedCheckbox = false;

                // USE gender_groups_items local variable
                this.$refs.nameAndNumberRef.loadNameAndNumber(
                    this.gender_groups_items[0].colors[this.activeColorIndex],
                    2
                );
            }
            if (id == "add-clipart-tab") {
                this.clipart_category_div = true;
                this.clipart_subcategory_div = false;
                this.clipart_search_query = null;
                this.clipart_subcategory_search_query = null;
                this.active_class = "";
            }
            if (id == "designs-tab") {
                this.design_tab_active = true;
            }
            if (id == "add-upload-tab") {
                this.uploaded_image_name = null;
            }
        },
        getAllTempateDesign() {
            let _this = this;
            if (!_this.isAuthenticatedClient) {
                return;
            }

            ApiService.get("/get-template-design-image")
                .then(({ data }) => {
                    _this.saved_Template_design_list = data.template;
                })
                .catch(({ response }) => {
                    console.log(response);
                });
        },
        closeMenu(menu_id) {
            if (menu_id === "add-text") {
                this.onSelectedCleared(menu_id);
            }
            /* eslint-disable */
            $("#default1-tab").click();
            /* eslint-enable */
            this.active_class = "active";
            var menu = document.querySelector("#" + menu_id);
            if (menu) {
                menu.classList.remove("active");
                menu.classList.remove("show");
                document.querySelector("#default1").classList.add("active");
                document.querySelector("#default1").classList.add("show");
            }
            var menu_nav = document.querySelector("#" + menu_id + "-tab");
            if (menu_id === "nn-tab") {
                menu_nav = document.querySelector("#" + menu_id);
                document.getElementById("nn-tab1").classList.remove("active");
            }
            if (menu_id === "templates") {
                menu_nav = document.querySelector("#add-" + menu_id + "-tab");
            }
            if (menu_id === "upload") {
                menu_nav = document.querySelector("#add-" + menu_id + "-tab");
            }

            if (menu_nav) {
                menu_nav.classList.remove("active");
            }
            this.selected_category_heading = false;
            this.category_heading = true;
            this.edit_template = false;
            this.selected_template_category_show = false;
            this.selected_clipart_category_show = false;
        },
        closeSelectedCategory(type) {
            if (type == "templates") {
                if (this.template_name == "Popular") {
                    this.selected_category_heading = false;
                    this.category_heading = true;
                    this.template_name = "";
                    this.selected_template_category_show = false;
                } else {
                    this.selected_category_heading =
                        this.selected_template_subcategory_show;
                    this.category_heading =
                        !this.selected_template_subcategory_show;
                    if (this.selected_template_subcategory_show) {
                        this.template_name =
                            this.selected_template_category.name;
                    }
                    this.selected_template_category_show =
                        this.selected_template_subcategory_show;
                }

                this.selected_template_subcategory_show = false;
            } else if (type == "clipart") {
                this.clipart_subcategory_div = false;
                this.clipart_category_div = true;
                this.category_heading = true;
                this.selected_category_heading = false;
                this.selected_clipart_category_show = false;
                this.clipart_name = "";
            } else if (type == "clipart_image") {
                if (this.clipart_name == "Popular") {
                    this.clipart_subcategory_div = false;
                    this.clipart_category_div = true;
                    this.category_heading = true;
                    this.selected_category_heading = false;
                    this.selected_clipart_category_show = false;
                } else {
                    this.category_heading = true;
                    this.edit_template = false;
                    this.selected_clipart_category_show = false;
                    this.clipart_category_div = false;
                    this.selected_category_heading = false;
                    this.getClipartCliparts(
                        this.selected_clipart_category_id,
                        this.clipart_category_name
                    );
                }
                this.clipart_name = "";
            }
            this.$forceUpdate();
        },
        selectImage() {
            this.$refs.fileInput.click();
        },

        //upload image
        ImageUpload() {
            if (!this.isAuthenticatedClient) {
                this.$toast.error("Please login", { position: "top-right" });
                return;
            }
            if (this.uploadModuleCanvas == 0) {
                this.uploadModuleCanvas++;
                this.saveCanvasData();
            }

            this.isLoader = true;
            new Promise(() => {
                ApiService.post("/design-studio-upload", this.image_uploaded)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.isLoader = false;
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.uploadedImages.unshift(data.upload_data);
                        this.bindUploadedDesignImage(
                            data.image_file_path,
                            data.upload_data
                        );
                        setTimeout(() => {
                            this.isLoader = false;
                            this.$toast.success("Image uploaded successfully", {
                                position: "top-right"
                            });
                            this.image_uploaded = {};
                            this.image_width = "";
                            this.image_height = "";
                            this.image_size = "";
                            this.uploaded_design_image = null;
                            this.uploaded_image_name = null;
                        }, 2000);
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        getUploadedImages() {
            return new Promise(() => {
                ApiService.get("/get-design-studio-upload")
                    .then(({ data }) => {
                        this.uploadedImages = data.images_list;
                    })
                    .catch((response) => {
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        deleteUploadedImage(id) {
            if (!confirm("Do you really want to delete?")) {
                return;
            }
            this.isLoader = true;
            ApiService.delete(`/delete-upload-image/${id}`)
                .then(() => {
                    this.isLoader = false;
                    this.getUploadedImages();
                })
                .catch(() => {
                    this.isLoader = false;
                });
        },

        setActiveGender(gender, key) {
            let _this = this;
            this.active_gender = gender;
            this.active_gender_key = key;
            localStorage.setItem("active_gender", gender);
            localStorage.setItem("active_gender_key", key);

            _this.imageCanvas.setBackgroundImage(
                _this.tshirtImage,
                canvas.renderAll.bind(canvas),
                {
                    backgroundColor: _this.user_selected_values[key].color_hash
                }
            );
            localStorage.setItem(
                "active_tshirt_color",
                this.user_selected_values[key].color_hash
            );
            this.canvas_elements = JSON.parse(
                localStorage.getItem("canvas_elements")
            );
            if (
                this.canvas_elements[key] &&
                this.canvas_elements[key][gender] &&
                this.canvas_elements[key][gender].length > 0
            ) {
                this.canvas_elements[key][gender].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true,
                                        originX: "center",
                                        originY: "center",
                                        centeredRotation: true
                                    });
                                    image.scaleToHeight(100);
                                    image.scaleToWidth(100);
                                    canvas.add(image);
                                }.bind(this),
                                {
                                    crossOrigin: "Anonymous"
                                }
                            );
                        }
                    }
                });
            }
        },
        clearDesigns() {
            let _this = this;
            _this.backCanvas.discardActiveObject();
            _this.onSelectedCleared();
            _this.backCanvas.clear();
            _this.$refs.nameAndNumberRef.addInputName = [];

            this.canvasList = { front: "", back: "" };

            localStorage.removeItem("new_canvas_elements");
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify({ front: "" })
            );

            _this.resetElements();

            let type = localStorage.getItem("active_flip");
            /* eslint-disable */
            $("." + type).addClass("active");
            this.tshirtImage = this.background_image;
            fabric.Object.prototype.objectCaching = false;
            if (type == "front" || type == "back") {
                _this.updateImageToBackCanvas();
            } else {
                let square = new fabric.Rect({
                    width: 630,
                    height: 540,
                    fill: _this.user_selected_values[_this.active_gender_key]
                        .color_hash
                });
                if (_this.backCanvas._objects.length > 0) {
                    _this.backCanvas._objects.forEach((canvas_obj) => {
                        if (canvas_obj.type != "rect") {
                            _this.backCanvas.add(square);
                        }
                    });
                } else {
                    _this.backCanvas.add(square);
                }
                _this.imagesSelectedCanvasType = "";
            }

            this.saved_json_data = null;
            _this.addDesignArea();
            _this.backCanvas.renderAll();
            $("#reset_popup").modal("hide");
            _this.undo = [];
            _this.redo = [];

            $("#redoObj").prop("disabled", true).removeClass("active");
            $("#undoObj").prop("disabled", true).removeClass("active");
            _this.firstImageActive = 0;
            _this.undoObject = 0;
            _this.state = [];
            _this.uploadModuleCanvas = 0;
            _this.selectedDistressImage = null;
            $("#newResetbtn").prop("disabled", true);
            _this.imagesSelectedCanvasType = "";
            _this.updateAdditionalFeesInDashboard();
            /* eslint-enable */
        },
        saveNewDesigns(saved_flag) {
            let _this = this;
            this.saved_type = saved_flag;
            let designStatus = this.checkObjectCanvas();
            if (!designStatus && _this.colors_validation == "") {
                _this.$toast.clear();
                _this.$toast.error(
                    "Please add some design ( Text, Clipart or ArtWork ) to this product",
                    { duration: 2000, position: "top-right", queue: false }
                );
                return;
            }
            let design_items = JSON.parse(
                JSON.stringify(this.gender_groups_items)
            );

            if (design_items.length == 0) {
                return;
            }
            if (this.saved_type == "cart") {
                if (design_items[0]["item"]["price_decoration_bulk"]) {
                    let decoration_pricing = "";
                    if (
                        typeof design_items[0]["item"][
                            "price_decoration_bulk"
                        ] === "string"
                    ) {
                        decoration_pricing = JSON.parse(
                            design_items[0]["item"]["price_decoration_bulk"]
                        );
                    } else {
                        decoration_pricing =
                            design_items[0]["item"]["price_decoration_bulk"];
                    }
                    let total_cart_quantity = parseInt(
                        design_items[0].total_qty
                    );
                    if (decoration_pricing) {
                        if (design_items[0]["item"].decoration_type == 1) {
                            let minimum_quantity =
                                decoration_pricing["print_location1"][0][
                                    "quantity"
                                ];
                            if (minimum_quantity > total_cart_quantity) {
                                this.$toast.error(
                                    "Quantity should be greater than " +
                                        minimum_quantity,
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                return;
                            }
                        } else if (
                            design_items[0]["item"].decoration_type == 2
                        ) {
                            let minimum_quantity =
                                decoration_pricing[0]["quantity1"];
                            if (minimum_quantity > total_cart_quantity) {
                                this.$toast.error(
                                    "Quantity should be greater than " +
                                        minimum_quantity,
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                return;
                            }
                        } else if (
                            design_items[0]["item"].decoration_type == 3
                        ) {
                            let minimum_quantity =
                                decoration_pricing[0]["quantity"];
                            if (minimum_quantity > total_cart_quantity) {
                                this.$toast.error(
                                    "Quantity should be greater than " +
                                        minimum_quantity,
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                return;
                            }
                        }
                    }
                }
            }
            this.saved_design.item_type = "single";
            this.saved_design.name = "";
            /* eslint-disable */
            if (this.isAuthenticatedClient) {
                $("#save_design_modal").modal("show");
            } else {
                $("#login").modal("show");
                $("#save_design_modal").modal("hide");
                return true;
            }
            /* eslint-enable */
        },
        async loadImageAsync(url) {
            return new Promise((resolve) => {
                let d = new Date();

                let time = d.getHours();
                let corsImage = new Image();
                corsImage.crossOrigin = "Anonymous";
                corsImage.src = url + "?no-cache&" + time;
                fabric.Image.fromURL(
                    corsImage.src,
                    function (img) {
                        resolve(img);
                    },
                    { crossOrigin: "anonymous" }
                );
            });
        },

        updateNameNumberColorDecorUpCharge() {
            const vinylColorsList = this.prepareVendorColorsList("vinyl");

            const nameVinylColorObj =
                this.$refs.nameAndNumberRef.colorSizesForName;
            const nameColorObj = vinylColorsList.find(
                (color) => color.color_id == nameVinylColorObj.color_id
            );
            this.$refs.nameAndNumberRef.colorSizesForName.decor_upcharge =
                parseFloat(nameColorObj.decor_upcharge || 0);

            const numberVinylColorObj =
                this.$refs.nameAndNumberRef.colorSizesForNumber;
            const numberColorObj = vinylColorsList.find(
                (color) => color.color_id == numberVinylColorObj.color_id
            );
            this.$refs.nameAndNumberRef.colorSizesForNumber.decor_upcharge =
                parseFloat(numberColorObj.decor_upcharge || 0);
        },

        calcNameNumberFees(color) {
            let name_fee_obj = this.adminOptions.find(
                (option) => option.option_key == "name_fees"
            );
            let number_fee_obj = this.adminOptions.find(
                (option) => option.option_key == "number_fees"
            );

            let name_fees = 0;
            if (name_fee_obj) {
                name_fees = parseFloat(name_fee_obj.option_value || 0);
            }

            let number_fees = 0;
            if (number_fee_obj) {
                number_fees = parseFloat(number_fee_obj.option_value || 0);
            }

            let nameAndNumbers = color.name_and_number_json.filter(
                (nn) => nn.name != "" || nn.number
            );

            const name_decor_up_charge =
                this.$refs.nameAndNumberRef.colorSizesForName.decor_upcharge;
            const number_decor_up_charge =
                this.$refs.nameAndNumberRef.colorSizesForNumber.decor_upcharge;

            let front_number_fees = 0;
            let back_name_fees = 0;
            let back_number_fees = 0;
            let front_number_decor_up_fees = 0;
            let back_name_decor_up_fees = 0;
            let back_number_decor_up_fees = 0;
            nameAndNumbers.forEach((nameNumber) => {
                if (nameNumber.name) {
                    if (color.selected_name_number["back"]["name"]) {
                        back_name_fees += parseFloat(name_fees);
                        back_name_decor_up_fees +=
                            parseFloat(name_decor_up_charge);
                    }
                }
                if (nameNumber.number) {
                    if (color.selected_name_number["front"]["number"]) {
                        front_number_fees += parseFloat(number_fees);
                        front_number_decor_up_fees += parseFloat(
                            number_decor_up_charge
                        );
                    }
                    if (color.selected_name_number["back"]["number"]) {
                        back_number_fees += parseFloat(number_fees);
                        back_number_decor_up_fees += parseFloat(
                            number_decor_up_charge
                        );
                    }
                }
            });

            return {
                front_number_fees,
                back_name_fees,
                back_number_fees,
                front_number_decor_up_fees,
                back_name_decor_up_fees,
                back_number_decor_up_fees
            };
        },

        updateNameNumberFees() {
            this.updateNameNumberColorDecorUpCharge();
            this.gender_groups_items[this.active_gender_key].colors.forEach(
                (color) => {
                    const {
                        front_number_fees,
                        back_name_fees,
                        back_number_fees,
                        front_number_decor_up_fees,
                        back_name_decor_up_fees,
                        back_number_decor_up_fees
                    } = this.calcNameNumberFees(color);

                    color.front_number_fees = front_number_fees;
                    color.back_name_fees = back_name_fees;
                    color.back_number_fees = back_number_fees;
                    color.front_number_decor_up_fees =
                        front_number_decor_up_fees;
                    color.back_name_decor_up_fees = back_name_decor_up_fees;
                    color.back_number_decor_up_fees = back_number_decor_up_fees;
                }
            );

            this.$refs.ItemDetails.calculatePricing(this.active_gender_key);
        },

        getAllCanvasDesignColors(activeFlip = null) {
            let flips = ["front", "back", "left", "right"];

            let canvas_design_colors = localStorage.getItem(
                "canvas_design_colors"
            );
            if (canvas_design_colors) {
                canvas_design_colors = JSON.parse(canvas_design_colors);
            } else {
                canvas_design_colors = {};
            }

            let all_obj_colors = [];
            for (let flip of flips) {
                if (activeFlip && activeFlip != flip) {
                    continue;
                }
                let obj_colors = canvas_design_colors[flip]
                    ? canvas_design_colors[flip]
                    : [];
                if (obj_colors.length == 0) {
                    continue;
                }

                var matchColors =
                    /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                obj_colors.forEach((color) => {
                    if (matchColors.exec(color)) {
                        color = this.rgbToHex(color);
                    }
                });
                all_obj_colors = all_obj_colors.concat(obj_colors);
            }

            return [...new Set(all_obj_colors)];
        },

        updateAdditionalFeesInDashboard() {
            let {
                non_standard_colors,
                standard_colors,
                decoration_colors,
                current_active_flip_standard_colors
            } = this.calcAdditionalFees();

            this.total_non_standard_colors = [];
            this.current_standard_colors = current_active_flip_standard_colors;
            this.gender_groups_items.forEach((gender, g_i) => {
                gender.colors.forEach((color) => {
                    if (this.active_gender_key == g_i) {
                        this.total_non_standard_colors =
                            this.total_non_standard_colors.concat(
                                non_standard_colors
                            );
                        color.non_standard_colors = non_standard_colors;
                        color.standard_colors = standard_colors;
                        color.decoration_colors = decoration_colors;
                    }
                });
            });

            this.total_non_standard_colors = [
                ...new Set(this.total_non_standard_colors)
            ];

            let non_standard_fees_obj = null;
            if (
                this.gender_groups_items[this.active_gender_key].item
                    .decoration_type == 1
            ) {
                non_standard_fees_obj = this.adminOptions.find(
                    (option) => option.option_key == "non_standard_color_fees"
                );
            } else if (
                this.gender_groups_items[this.active_gender_key].item
                    .decoration_type == 2
            ) {
                non_standard_fees_obj = this.adminOptions.find(
                    (option) =>
                        option.option_key == "non_standard_color_fees_emb"
                );
            }

            if (non_standard_fees_obj && non_standard_fees_obj.option_value) {
                let non_standard_fees =
                    parseFloat(non_standard_fees_obj.option_value) || 0;
                this.non_standard_fee_per_color = parseFloat(non_standard_fees);
                this.total_non_standard_fees =
                    this.total_non_standard_colors.length *
                    parseFloat(non_standard_fees);
            }

            // this.$refs.dashBoardComp.$forceUpdate();
        },

        calcAdditionalFees() {
            let all_obj_colors = this.getAllCanvasDesignColors();
            let current_active_flip_obj_colors = this.getAllCanvasDesignColors(
                this.active_flip
            );
            let non_standard_colors =
                this.prepareNonStandardColors(all_obj_colors);
            let decoration_colors =
                this.prepareDecorationColors(all_obj_colors);
            let standard_colors = this.prepareStandardColors(all_obj_colors);
            let current_active_flip_standard_colors =
                this.prepareStandardColors(current_active_flip_obj_colors);

            return {
                non_standard_colors,
                decoration_colors,
                standard_colors,
                current_active_flip_standard_colors
            };
        },

        async save_all_design() {
            let _this = this;
            let canvas_designs = _this.checkObjectCanvas();
            if (!canvas_designs && _this.colors_validation == "") {
                _this.$toast.clear();
                _this.$toast.error(
                    "Please add some design ( Text, Clipart or ArtWork ) to this product",
                    { duration: 2000, position: "top-right", queue: false }
                );
                return;
            }
            _this.isLoader = true;
            _this.popup_sync_count = 5;
            // setTimeout(async () => {
            this.cart_save_design = true;
            let new_canvas_elements = localStorage.getItem(
                "new_canvas_elements"
            );
            let parsedJson = new_canvas_elements
                ? JSON.parse(new_canvas_elements)
                : null;
            if (parsedJson && this.build_id) {
                this.saved_design.build_id = this.build_id;
            }
            if (parsedJson && this.build_item_id) {
                this.saved_design.build_item_id = this.build_item_id;
            }
            _this.active_flip = localStorage.getItem("active_flip");
            parsedJson[_this.active_flip] = JSON.stringify(_this.backCanvas);
            if (parsedJson && this.build_id) {
                this.saved_design.build_id = this.build_id;
            }
            if (parsedJson && this.build_item_id) {
                this.saved_design.build_item_id = this.build_item_id;
            }
            let flips = [];
            let get_canvas_colors = JSON.parse(
                localStorage.getItem("canvas_design_colors")
            );
            get_canvas_colors[_this.active_flip] = _this.design_current_colors;
            localStorage.setItem(
                "canvas_design_colors",
                JSON.stringify(get_canvas_colors)
            );
            if (!this.front_show) {
                delete parsedJson.front;
                delete get_canvas_colors.front;
            } else {
                flips.push("front");
            }
            if (!this.back_show) {
                delete parsedJson.back;
                delete get_canvas_colors.back;
            } else {
                flips.push("back");
            }
            if (!this.left_show) {
                delete parsedJson.left;
                delete get_canvas_colors.left;
            } else {
                flips.push("left");
            }
            if (!this.right_show) {
                delete parsedJson.right;
                delete get_canvas_colors.right;
            } else {
                flips.push("right");
            }
            this.saved_design.canvas_json = JSON.stringify(parsedJson);
            this.saved_design.product_id = localStorage.getItem("product_id");
            this.saved_design.user_id = this.currentUserClient.id;
            this.backCanvas._objects = this.backCanvas._objects.filter(
                function (val) {
                    return val.type != "rect";
                }
            );
            this.saved_design.image = this.backCanvas.toDataURL();
            this.saved_design.name =
                this.saved_design.name != null
                    ? this.saved_design.name
                    : _this.cart_status != ""
                    ? _this.cart_status
                    : Date.now();

            let designStatus = this.checkObjectCanvas();
            let no_of_locations = 0;
            new_canvas_elements = JSON.parse(
                localStorage.getItem("new_canvas_elements")
            );
            if (new_canvas_elements != null) {
                new_canvas_elements[_this.active_flip] = JSON.stringify(
                    _this.backCanvas
                );
                if ("front" in new_canvas_elements) {
                    JSON.parse(new_canvas_elements["front"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                no_of_locations++;
                            }
                        }
                    );
                }
                if ("back" in new_canvas_elements) {
                    JSON.parse(new_canvas_elements["back"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                no_of_locations++;
                            }
                        }
                    );
                }
                if ("left" in new_canvas_elements) {
                    JSON.parse(new_canvas_elements["left"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                no_of_locations++;
                            }
                        }
                    );
                }
                if ("right" in new_canvas_elements) {
                    JSON.parse(new_canvas_elements["right"]).objects.forEach(
                        (canvas_obj) => {
                            if (canvas_obj.type != "rect") {
                                no_of_locations++;
                            }
                        }
                    );
                }
            }
            if (!designStatus) {
                this.$toast.error("Please add design on the Product !", {
                    position: "top-right"
                });
                this.isLoader = false;
                return true;
            }
            let image_response = [];
            for (let flip of flips) {
                let objects = new_canvas_elements[flip]
                    ? JSON.parse(new_canvas_elements[flip]).objects
                    : [];
                if (objects.length == 0) {
                    continue;
                }
                let tempCanvas = new fabric.Canvas();
                let rectHeight = 0;
                let rectWidth = 0;
                let rectTop = 0;
                let rectLeft = 0;
                objects.forEach((canvas_obj) => {
                    if (
                        "clipPath" in canvas_obj &&
                        canvas_obj.clipPath.type == "rect"
                    ) {
                        rectHeight = canvas_obj.clipPath.height;
                        rectWidth = canvas_obj.clipPath.width;
                        rectTop = canvas_obj.clipPath.top;
                        rectLeft = canvas_obj.clipPath.left;
                    }
                });
                tempCanvas.setWidth(this.defaultWidthCanvas);
                tempCanvas.setHeight(this.defaultHeightCanvas);
                let localCanvasJson = JSON.parse(new_canvas_elements[flip]);
                if (localCanvasJson.objects.length > 0) {
                    localCanvasJson.objects = localCanvasJson.objects.filter(
                        function (val) {
                            return val.type != "rect";
                        }
                    );
                }
                tempCanvas.loadFromJSON(
                    JSON.stringify(localCanvasJson),
                    function () {
                        tempCanvas.renderAll();
                        if (rectHeight > 0 && rectTop > 0) {
                            image_response.push({
                                label: flip,
                                url: tempCanvas.toDataURL({
                                    left: rectLeft,
                                    top: rectTop,
                                    width: rectWidth,
                                    height: rectHeight
                                })
                            });
                        } else {
                            image_response.push({
                                label: flip,
                                url: tempCanvas.toDataURL({ multiplier: 0.3 })
                            });
                        }
                    }
                );
            }
            let allitems = [];

            let allColorAndSizesname = "";
            let allColorAndSizesnumber = "";
            let nameAndNumbers = [];
            if (this.$refs.nameAndNumberRef.addInputName) {
                nameAndNumbers =
                    this.$refs.nameAndNumberRef.addInputName.filter(
                        (nn) => nn.name != "" || nn.number
                    );
            }
            if (nameAndNumbers.length > 0) {
                allColorAndSizesname =
                    this.$refs.nameAndNumberRef.colorSizesForName;
                allColorAndSizesnumber =
                    this.$refs.nameAndNumberRef.colorSizesForNumber;
            }
            // USE gender_groups_items local variable
            let design_items = this.gender_groups_items;
            for (let design_item of design_items) {
                /* eslint-disable */
                let total_quantity = 0;
                let total_price = 0;
                /* eslint-enable */
                //Get selected colors and sizes
                for (let [colorIndex, color] of Object.entries(
                    design_item["colors"]
                )) {
                    let items = [];
                    let image_response_back = [];
                    let selected_design_images = [];
                    design_items[0]["item"]["NewProductImages"].forEach(
                        (colors) => {
                            if (
                                colors.color_id == color.id &&
                                colors.type == "front"
                            ) {
                                selected_design_images.push({
                                    front: colors.url
                                });
                            }
                            if (
                                colors.color_id == color.id &&
                                colors.type == "back"
                            ) {
                                selected_design_images.push({
                                    back: colors.url
                                });
                            }
                        }
                    );

                    let selected_flip = ["front", "back"];
                    if (image_response_back.length == 0) {
                        for (let flip1 of selected_flip) {
                            let objects = new_canvas_elements[flip1]
                                ? JSON.parse(new_canvas_elements[flip1]).objects
                                : [];
                            if (objects.length == 0) {
                                continue;
                            }
                            let tempCanvas = new fabric.Canvas();
                            /* eslint-disable */
                            let rectHeight = 0;
                            let rectWidth = 0;
                            let rectTop = 0;
                            let rectLeft = 0;
                            for (let canvas_obj of objects) {
                                if (
                                    "clipPath" in canvas_obj &&
                                    canvas_obj.clipPath.type == "rect"
                                ) {
                                    rectHeight = canvas_obj.clipPath.height;
                                    rectWidth = canvas_obj.clipPath.width;
                                    rectTop = canvas_obj.clipPath.top;
                                    rectLeft = canvas_obj.clipPath.left;
                                }
                            }
                            /* eslint-enable */
                            tempCanvas.setWidth(this.defaultWidthCanvas);
                            tempCanvas.setHeight(this.defaultHeightCanvas);
                            let localCanvasJson = JSON.parse(
                                new_canvas_elements[flip1]
                            );
                            if (localCanvasJson.objects.length > 0) {
                                localCanvasJson.objects =
                                    localCanvasJson.objects.filter(function (
                                        val
                                    ) {
                                        return val.type != "rect";
                                    });
                            }
                            if (localCanvasJson.objects.length == 0) {
                                continue;
                            }
                            await tempCanvas.loadFromJSON(
                                JSON.stringify(localCanvasJson),
                                function () {
                                    tempCanvas.renderAll();
                                }
                            );
                            let canvasImgUrlArr = selected_design_images.filter(
                                function (currentImage) {
                                    return currentImage[flip1];
                                }
                            );
                            let canvasImgUrl = canvasImgUrlArr[0][flip1];
                            let imgObj = await _this.loadImageAsync(
                                canvasImgUrl
                            );
                            await tempCanvas.setBackgroundImage(
                                imgObj,
                                tempCanvas.renderAll.bind(tempCanvas),
                                {
                                    scaleX:
                                        _this.defaultWidthCanvas / imgObj.width,
                                    scaleY:
                                        _this.defaultHeightCanvas /
                                        imgObj.height,
                                    crossOrigin: "anonymous"
                                }
                            );
                            _this.imgHeight = imgObj.height;
                            _this.imgWidth = imgObj.width;
                            if (imgObj._element === null) {
                                _this.$toast.error(
                                    "Something went wrong while loading the design area images, please refresh the page and try again.",
                                    {
                                        position: "top-right",
                                        queue: true,
                                        duration: 10000,
                                        pauseOnHover: true
                                    }
                                );
                            } else {
                                console.log(
                                    "Canvas Image Loaded... Image " + imgObj
                                );
                                image_response_back.push({
                                    label: flip1,
                                    url: tempCanvas.toDataURL({
                                        multiplier: 0.6
                                    })
                                });
                            }
                        } // flip close
                    }

                    for (let size of color["unique_sizes"]) {
                        // Get all the background images of selected colors
                        items.push({
                            sub_product_id: size.sub_product_id,
                            Size: size.Size,
                            user_id: _this.currentUserClient.id,
                            case_price: size.price_base,
                            markup_price: size.markup_price,
                            markup_percentage: design_item.markup_percentage,
                            ink_price: size.ink_price,
                            decoration_discount_percentage:
                                size.decoration_discount_percentage || 0,
                            decoration_discount_value:
                                size.decoration_discount_value || 0,
                            single_location_price: size.single_location_price,
                            quantity: size.quantity,
                            discount: size.discount ? size.discount : 0.0,
                            unit_price: size.cost,
                            total_price: size.total_cost
                        });
                    }

                    let isNameNumberExists = color.name_and_number_json.filter(
                        (nn) => nn.name != "" || nn.number
                    );

                    let imprint_locations = JSON.parse(
                        JSON.stringify(design_item.imprint_locations)
                    );
                    imprint_locations.forEach((location) => {
                        location.colors = location.colors.filter(
                            (lcolor) => lcolor.color
                        );
                    });

                    color.name_and_number_json =
                        color.name_and_number_json.filter(
                            (nn) => nn.name != "" || nn.number
                        );

                    allitems.push({
                        user_id: _this.currentUserClient.id,
                        item_id: design_item.item.id,
                        decoration_type: design_item.item.decoration_type,
                        decoration_price_template:
                            design_item.item.decoration_price_template,
                        price_decoration_bulk:
                            design_item.item.price_decoration_bulk,
                        more_decorations: design_item.item.more_decoration,
                        gender_size_id: design_item.gender_id,
                        color_id: color.id,
                        color_hash: color.hash,
                        items: items,
                        total_dark_category_fee: color.total_dark_category_fee,
                        total_light_category_fee:
                            color.total_light_category_fee,
                        total_design_fee: color.total_design_fee,
                        total_discount_value: color.total_discount_value || 0,
                        total_quantity: color.total_qty_gender_wise,
                        total_price: color.total_cost_gender_wise,
                        imprint_locations: imprint_locations,
                        imprint_locations_price: design_item.total_color_fee,
                        setup_fee: colorIndex == 0 ? color.total_setup_fee : 0,
                        t_shirt_24_hour: this.is24Tshirt,
                        design_image: image_response_back,
                        front_number_fees: color.front_number_fees || 0,
                        back_name_fees: color.back_name_fees || 0,
                        back_number_fees: color.back_number_fees || 0,
                        front_number_decor_up_fees:
                            color.front_number_decor_up_fees || 0,
                        back_name_decor_up_fees:
                            color.back_name_decor_up_fees || 0,
                        back_number_decor_up_fees:
                            color.back_number_decor_up_fees || 0,
                        non_standard_fees: color.non_standard_fees,
                        non_standard_colors: color.non_standard_colors,
                        standard_colors: color.standard_colors,
                        decoration_colors: color.decoration_colors,
                        name_and_number_json: isNameNumberExists.length
                            ? color.name_and_number_json
                            : null,
                        font_color_sizes_name: allColorAndSizesname,
                        font_color_sizes_number: allColorAndSizesnumber,
                        selected_name_number: color.selected_name_number
                    });
                }
            }
            this.saved_design.allitems = allitems;
            this.saved_design.product_items = design_items;

            for (const [location, locationColors] of Object.entries(
                get_canvas_colors
            )) {
                get_canvas_colors[location] =
                    this.prepareDecorationColors(locationColors);
            }
            this.saved_design.canvas_design_image = image_response;
            this.saved_design.canvas_design_colors = get_canvas_colors;
            this.saved_design.no_of_locations = no_of_locations;
            this.saved_design.active_index = this.activeColorIndex;
            this.saved_design.design_area_inches = this.design_area_inches;
            this.saved_design.build_item_id = this.build_item_id;

            _this.popup_sync_count = 50;
            _this.$validator
                .validateAll("addshapeform")
                .then(async (isValid) => {
                    if (isValid) {
                        this.design_tab_active = false;
                        ApiService.post("/add-build-item", this.saved_design)
                            .then(async ({ data }) => {
                                $('#itemDetailsModal').modal('hide');
                                if (data.success == false) {
                                    this.$toast.error(data.error, {
                                        position: "top-right"
                                    });
                                    this.isLoader = false;
                                    return false;
                                }

                                this.popup_sync_count = 100;
                                this.cart_save_design = false;

                                this.saved_type == "";
                                this.isLoader = false;
                                this.only_save_designs = false;
                                // Refresh design listing
                                this.design_tab_active = true;
                                this.$toast.success(data.message, {
                                    position: "top-right"
                                });

                                _this.cart_status = "";
                                _this.saved_design.save_canvas_images = "";
                                _this.save_design_images = "";
                                _this.popup_sync_count = 0;
                                _this.skip_leave_confirm_box = true;
                                this.$router.push({
                                    name: "BuildDetailsV3",
                                    params: { id: this.saved_design.build_id }
                                });
                                return false;
                            })
                            .catch((response) => {
                                this.popup_sync_count = 0;
                                this.cart_save_design = false;
                                this.only_save_designs = false;
                                this.isLoader = false;
                                console.log(response);
                                this.$toast.error(response.error, {
                                    position: "top-right"
                                });
                            });
                    }
                });
        },

        change_product() {
            localStorage.removeItem("canvas_elements");
            localStorage.removeItem("active_gender");
            localStorage.removeItem("active_gender_key");
            localStorage.removeItem("active_flip");
            localStorage.removeItem("category_object");
            localStorage.removeItem("type");
            localStorage.removeItem("index");
            localStorage.removeItem("design");
            localStorage.removeItem("colorIndex");
            localStorage.removeItem("colorIdArr");
            this.$route.push({ path: "/category/apparel" });
        },
        async addDeleteBtn(x, y, z, e) {
            /* eslint-disable */
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            /* eslint-enable */
            if (e === undefined) {
                return;
            }
            let noOfColors = [];
            if (e._objects && e._objects.length) {
                const rgba2hex = (rgba) =>
                    `#${rgba
                        .match(
                            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
                        )
                        .slice(1)
                        .map((n, i) =>
                            (i === 3
                                ? Math.round(parseFloat(n) * 255)
                                : parseFloat(n)
                            )
                                .toString(16)
                                .padStart(2, "0")
                                .replace("NaN", "")
                        )
                        .join("")}`;
                fabric.Object.prototype.objectCaching = false;
                var reg = /^#([0-9a-f]{3}){1,2}$/i;
                var matchColors =
                    /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                e._objects.forEach((e) => {
                    let hexColor = "";
                    if (matchColors.exec(e.fill)) {
                        hexColor = rgba2hex(e.fill);
                    }
                    if (reg.test(e.fill) || hexColor) {
                        noOfColors.push(e.fill);
                    }
                });
                // console.log(noOfColors);
            }
            var btnLeft = e.left;
            var btnTop = e.top;
            /* eslint-disable */
            var btnToRight = e.left;
            /* eslint-enable */
            Object.values(e.oCoords).forEach(function (a) {
                if (a.x < btnLeft) {
                    btnLeft = a.x;
                } else if (a.x > btnLeft) {
                    btnToRight = a.x;
                }
                if (a.y < btnTop) {
                    btnTop = a.y;
                }
            });
            let DbtnLeft = btnLeft - 10;
            let DbtnTop = btnTop - this.front_canvas_height / 8;
            let HwbtnTop = btnTop + e.getScaledHeight() + 40;

            let RbtnToRight = btnLeft + e.getScaledWidth();

            let heightInch =
                this.active_flip == "front" || this.active_flip == "back"
                    ? this.front_canvas_height
                    : this.defaultHeightCanvas;
            let widthInch =
                this.active_flip == "front" || this.active_flip == "back"
                    ? this.front_canvas_width
                    : this.defaultWidthCanvas;

            this.rotationAngle = e.angle ? parseInt(e.angle) : 0;
            heightInch = parseFloat(
                ((e.height * e.scaleY) / heightInch) *
                    parseInt(this.front_canvas_height_inch)
            ).toFixed(2);
            widthInch = parseFloat(
                ((e.width * e.scaleX) / widthInch) *
                    parseInt(this.front_canvas_width_inch)
            ).toFixed(2);
            e.height_inch = heightInch;
            e.width_inch = widthInch;
            let currentActiveObject = this.backCanvas.getActiveObject();
            currentActiveObject.toObject = (function (toObject) {
                return function () {
                    return fabric.util.object.extend(toObject.call(this), {
                        width_inch: widthInch,
                        height_inch: heightInch
                    });
                };
            })(currentActiveObject.toObject);
            var deleteBtn =
                '<img src="/maincss/images/close-round.svg" class="deleteBtn" style="position:absolute;top:' +
                DbtnTop +
                "px !important;left:" +
                DbtnLeft +
                'px !important;cursor:pointer;width:20px;height:20px;"/>';
            /* eslint-disable */
            let hastcanvas = $(".canvas-container").find("#tcanvas");
            /* eslint-enable */
            var rBtn =
                '<label  class="rotationBtn" style="position:absolute;top:' +
                DbtnTop +
                "px !important;left:" +
                RbtnToRight +
                'px !important;cursor:pointer;background:#44484f;color: #ffffff;border-radius: 8px;padding: 2px;line-height: 17px;max-width: 35px;text-align: center;">' +
                Math.round(e.angle) +
                "<span>&#176;</span></label>";
            var hwBtn =
                '<label  class="rotationBtn" style="position:absolute;top:' +
                HwbtnTop +
                "px !important;left:" +
                RbtnToRight +
                'px !important;cursor:pointer;background:#44484f;color: #ffffff;border-radius: 8px;padding: 5px;line-height: 17px;max-width: 120px;margin-top: 12px;">' +
                heightInch +
                " <span>&#8243;</span> <b>&#215;</b> " +
                widthInch +
                " <span>&#8243;</span></label>";
            if (hastcanvas.length) {
                hastcanvas.closest(".canvas-container").append(deleteBtn);
                hastcanvas.closest(".canvas-container").append(rBtn);
                hastcanvas.closest(".canvas-container").append(hwBtn);
            }
            setTimeout(() => {
                this.prepareImprintLocations();
            }, 1000);
        },
        onObjectSelected(e) {
            if (!e) {
                return;
            }
            var selectedObject = e.target;
            selectedObject.set({
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true,
                lockScalingX: true,
                lockScalingY: true
            });
            if (
                selectedObject.objType == "name" ||
                selectedObject.objType == "number"
            ) {
                selectedObject.set({
                    selectable: false
                });

                return false;
            }

            selectedObject.set({
                borderColor: "#44484f",
                cornerColor: "#44484f",
                transparentCorners: false,
                cornerStyle: "square",
                uniScaleTransform: true,
                cornersize: 12,
                cornerStrokeColor: "#ffffff"
            });
            // square.opacity=1
            listLine.forEach(function (obj) {
                obj.opacity = 1;
            });
            this.addDeleteBtn(
                e.target.oCoords.mtr.x,
                e.target.oCoords.mtr.y,
                e.target.width,
                e.target
            );
            selectedObject.hasRotatingPoint = true;
            /* eslint-disable */
            if (selectedObject && selectedObject.type === "text") {
                $("#add-text-tab").click();
                let {
                    text,
                    fontFamily,
                    fontStyle,
                    fontSize,
                    textAlign,
                    fontWeight,
                    underline,
                    linethrough,
                    id,
                    fill,
                    angle,
                    textDecoration,
                    shadow,
                    paintFirst,
                    strokeWidth,
                    stroke
                } = selectedObject;

                let embossX = 0;
                let embossY = 0
                let embossColour = "#000000";
                let embossBlur = 0;
                if (shadow != null && shadow.blur > 0) {
                    embossX = shadow.offsetX;
                    embossY = shadow.offsetY;
                    embossColour = shadow.color;
                    embossBlur = shadow.blur;
                }
                this.textData = {
                    id,
                    text,
                    fontFamily: fontFamily,
                    fontStyle: fontStyle,
                    fontWeight: fontWeight,
                    fontSize: fontSize,
                    color: fill ? fill : "#D3D3D3",
                    rotation: angle,
                    textAlign,
                    textDecoration,
                    underline: underline,
                    layer: "",
                    flip: "",
                    embossX: embossX,
                    embossY: embossY,
                    embossColour: embossColour,
                    embossBlur: embossBlur,
                    paintFirst: paintFirst,
                    strokeWidth: strokeWidth,
                    stroke: stroke,
                    linethrough: linethrough
                };

                setTimeout(function () {
                    let textArea = $("#text_area_box")[0];
                    textArea.scrollTop = textArea.scrollHeight;
                }, 200);
            } else if (
                selectedObject &&
                (selectedObject.ctype === "clipart" ||
                    selectedObject.ctype === "templates" ||
                    selectedObject.ctype === "shape" ||
                    selectedObject.ctype === "patch" ||
                    selectedObject.ctype === "upload")
            ) {
                this.selectImageProps = { rotation: selectedObject.angle };
                this.EditImages(selectedObject.ctype);

                if (selectedObject.ctype == "upload") {
                    if (selectedObject.iextension == "svg") {
                        $("#add-" + selectedObject.ctype + "-tab").click();
                    } else {
                        $("#add-" + selectedObject.ctype + "-tab").click();
                        this.category_heading = true;
                        this.edit_template = false;
                    }
                } else {
                    $("#add-" + selectedObject.ctype + "-tab").click();
                }
            } else {
                this.$forceUpdate();
            }
            /* eslint-enable */
            this.selected_object_colors =
                this.getSelectedObjectColors(selectedObject);
        },
        getSelectedObjectColors(activeObject) {
            const rgba2hex = (rgba) =>
                `#${rgba
                    .match(
                        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/
                    )
                    .slice(1)
                    .map((n, i) =>
                        (i === 3
                            ? Math.round(parseFloat(n) * 255)
                            : parseFloat(n)
                        )
                            .toString(16)
                            .padStart(2, "0")
                            .replace("NaN", "")
                    )
                    .join("")}`;
            var colorListValue = [];
            if (activeObject) {
                if (activeObject._objects && activeObject._objects.length) {
                    fabric.Object.prototype.objectCaching = false;
                    var reg = /^#([0-9a-f]{3}){1,2}$/i;
                    var matchColors =
                        /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    activeObject._objects.forEach((e) => {
                        let hexColor = "";
                        if (matchColors.exec(e.fill)) {
                            hexColor = rgba2hex(e.fill);
                        }
                        if (reg.test(e.fill) || hexColor) {
                            colorListValue.push(e.fill);
                        }
                    });
                } else {
                    colorListValue = [];
                }
            }
            if (activeObject.paths && activeObject.paths.length) {
                colorListValue.push(activeObject.fill);
            }
            if (activeObject.fill && colorListValue.length == 0) {
                colorListValue.push(activeObject.fill);
            }

            return [...new Set(colorListValue)];
        },
        onSelectedCleared() {
            /* eslint-disable */
            $(".deleteBtn").remove();
            $(".rotationBtn").remove();
            let color_code = "";

            if (this.vendor_colors_list.length > 0) {
                let color_list = this.vendor_colors_list;
                if (color_list.length > 0) {
                    color_code =
                        color_list[0].color_value != null &&
                        color_list[0].color_value != ""
                            ? color_list[0].color_value
                            : "#D3D3D3";
                }
            }
            this.textData = {
                text: "",
                fontFamily: "Arial",
                fontStyle: "",
                fontSize: 50,
                color: color_code,
                rotation: 0,
                textAlign: "left",
                layer: "",
                flip: "",
                center: "",
                textDecoration: "",
                textUDecoration: "",
                fontWeight: 100,
                embossX: 0,
                embossY: 0,
                embossColour: "#53565A",
                embossBlur: 0,
                paintFirst: null,
                strokeWidth: 0,
                stroke: "",
                underline: "",
                linethrough: ""
            };
            this.edit_template = false;

            listLine.forEach(function (obj) {
                obj.opacity = 0;
            });
            this.backCanvas.discardActiveObject();

            $("#text-string").val("");
            $("#text_area_box").val("");
            $("#texteditor").css("display", "none");
            $("#imageeditor").css("display", "none");
            this.active_class = "active";
            this.$forceUpdate();
            /* eslint-enable */
        },
        groupArrayOfObjects(list, key) {
            return list.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        wow() {
            alert();
        },
        SetColorCanvas(val, colorId) {
            if (colorId) {
                let default_color_img = "";
                this.activeIndex = colorId;
                let _this = this;

                let get_product = JSON.stringify(this.product_items);
                let unique_colors = JSON.parse(get_product).NewSubProducts;
                let main_colors = [];
                _this.groupedSizesByColors = _this.groupArrayOfObjects(
                    unique_colors,
                    "color_id"
                );

                Object.values(_this.groupedSizesByColors).forEach((element) => {
                    main_colors.push(element[0].Color);
                });
                var newArray = main_colors.filter(function (el) {
                    if (el.id == colorId) {
                        return true;
                    }
                });

                let design = this.gender_groups_items;

                design[0].color.id = newArray[0].id;
                design[0].color.color_name = newArray[0].name;
                design[0].color.hash = newArray[0].hex;
                design[0].color.category = newArray[0].category;
                design[0].color.shades = newArray[0].shades;
                design[0].color.swatches = newArray[0].swatches;
                design[0].colors.forEach((col, ind) => {
                    if (parseInt(col.id) === parseInt(colorId)) {
                        _this.activeColorIndex = ind;
                    }
                });
                localStorage.setItem("colorIndex", _this.activeColorIndex);
                localStorage.setItem("active_tshirt_color", newArray[0].hex);

                this.tshirt_color = newArray[0].hex;
                let selected_design_images = [];
                design[0]["item"]["NewProductImages"].forEach((colors) => {
                    if (
                        colors.color_id == design[0].color.id &&
                        colors.type == "front"
                    ) {
                        selected_design_images.push({
                            front: colors.url
                        });
                    }
                    if (
                        colors.color_id == design[0].color.id &&
                        colors.type == "back"
                    ) {
                        selected_design_images.push({
                            back: colors.url
                        });
                    }
                });
                let def_color = design[0]["item"]["NewProductImages"].filter(
                    (color) =>
                        color.color_id == colorId &&
                        color.type != "front" &&
                        color.type != "back"
                );
                if (def_color.length > 0) {
                    default_color_img = def_color[0].url;
                }
                let ele_img_front = "";
                let ele_img_back = "";
                let front_img_required;
                let back_img_required;
                if (selected_design_images.length > 0) {
                    let filter_img = selected_design_images.filter(
                        (img) => "front" in img
                    );

                    if (filter_img.length > 0) {
                        ele_img_front = filter_img[0]["front"];
                    } else {
                        front_img_required = true;
                    }
                    if (selected_design_images.length > 0) {
                        let filter_img = selected_design_images.filter(
                            (img) => "back" in img
                        );
                        /* eslint-disable */
                        if (filter_img.length > 0) {
                            ele_img_back = filter_img[0]["back"];
                        } else {
                            back_img_required = true;
                        }
                        /* eslint-enable */
                    }
                } else {
                    ele_img_front = "";
                    ele_img_back = "";
                }

                if (_this.active_flip == "front") {
                    _this.background_image = ele_img_front
                        ? ele_img_front
                        : default_color_img;
                    if (front_img_required) {
                        _this.$toast.error(
                            "please add front image for selected color",
                            {
                                position: "top-right",
                                queue: true
                            }
                        );
                    }
                }

                if (_this.active_flip == "back") {
                    _this.background_image = ele_img_back
                        ? ele_img_back
                        : default_color_img;
                }
                // remove back canvas if images not found in back
                if (ele_img_back) {
                    default_color_img = ele_img_back;
                }
                if (
                    default_color_img == "" &&
                    ele_img_back == "" &&
                    ele_img_front
                ) {
                    _this.back_show = false;
                    _this.removeBackCanvas = false;
                    _this.flipTshirt("front");
                } else {
                    _this.back_show = true;
                    _this.removeBackCanvas = true;
                }

                if (
                    _this.active_flip == "front" ||
                    _this.active_flip == "back"
                ) {
                    _this.imageCanvas.setBackgroundColor(
                        "",
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                    );
                    _this.imageCanvas.renderAll();
                    _this.updateImageToBackCanvas(_this.background_image, val);
                } else {
                    _this.imageCanvas.setBackgroundColor(
                        val == "null" || val == "#null" || val == ""
                            ? "#FFFFFF"
                            : val,
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas)
                    );
                    _this.imageCanvas.renderAll();
                }

                this.$refs.nameAndNumberRef.loadNameAndNumber(
                    design[0].colors[this.activeColorIndex],
                    2
                );
                this.updateAdditionalFeesInDashboard();
                this.$refs.dashBoardComp.$forceUpdate();
            }
        },

        loadImageFromCrossOrigin(imageUrl) {
            if (!imageUrl) return "Image URL is required";

            const date = new Date();
            let getHours = date.getHours();
            const attrImg = new Image();
            attrImg.crossOrigin = "Anonymous";
            attrImg.src = imageUrl + "?no-cache&" + getHours;

            return attrImg.src;
        },
        updateImageToBackCanvas(imgUrl = false, color = false) {
            let _this = this;
            _this.isLoader = true;

            let canvasImgUrl = imgUrl ? imgUrl : _this.background_image;
            let canvasColor = color
                ? color
                : _this.user_selected_values[_this.active_gender_key]
                      .color_hash;

            const d = new Date();

            let time = d.getHours();
            const corsImage = new Image();
            corsImage.crossOrigin = "Anonymous";
            corsImage.src = canvasImgUrl + "?no-cache&" + time;

            // Check image Domains
            if (
                typeof canvasImgUrl !== "undefined" &&
                canvasImgUrl.search("sanmar.com") >= 0
            ) {
                _this.isLoader = false;
                _this.$toast.error(
                    "There is a issue with loading cross domain images",
                    {
                        position: "top-right",
                        queue: true,
                        duration: 10000,
                        pauseOnHover: true
                    }
                );
            }
            // Update canvas Image

            fabric.Image.fromURL(
                corsImage.src,
                (imgObj) => {
                    _this.imageCanvas.setBackgroundImage(
                        imgObj,
                        _this.imageCanvas.renderAll.bind(_this.imageCanvas),
                        {
                            backgroundColor: canvasColor,
                            scaleX: _this.defaultWidthCanvas / imgObj.width,
                            scaleY: _this.defaultHeightCanvas / imgObj.height,
                            crossOrigin: "anonymous"
                        }
                    );
                    _this.imgHeight = imgObj.height;
                    _this.imgWidth = imgObj.width;
                    _this.isLoader = false;
                    if (imgObj._element === null) {
                        _this.$toast.error(
                            "Something went wrong while loading the design area images, please refresh the page and try again.",
                            {
                                position: "top-right",
                                queue: true,
                                duration: 10000,
                                pauseOnHover: true
                            }
                        );
                    } else {
                        console.log(
                            "Canvas Image Loaded... Image " + corsImage.src
                        );
                    }
                },
                {
                    crossOrigin: "anonymous"
                }
            );
        },
        cancelLogin: function () {
            localStorage.setItem("login_cancelled", true);
        },
        designColorsHtml(colors) {
            let output = "";
            if (colors == null) return false;
            if (colors !== null && colors !== "null" && this.isJSON(colors)) {
                let colorsParse = JSON.parse(colors).length
                    ? JSON.parse(colors)
                    : [];

                let limitColorsArr =
                    colorsParse.length > 4
                        ? colorsParse.slice(0, 4)
                        : colorsParse;
                output += `<ul class="select_colors">`;
                limitColorsArr.forEach((element) => {
                    output += `<li style="background-color: ${element};"></li>`;
                });
                if (colorsParse.length > 4) {
                    output += `<li class="more_color_link"><a href="javascript:;">+${
                        colorsParse.slice(4).length
                    }</a></li>`;
                }
                output += `</ul>`;
            }
            return output;
        },
        isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (error) {
                return false;
            }
        },
        prepareStandardColors(objColors) {
            let colors = [];
            objColors.forEach((colorHex) => {
                let vendorColor = this.vendor_colors_list.find(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (vendorColor) {
                    colors.push({
                        name: vendorColor.color_name,
                        hex: vendorColor.color_value
                    });
                }
            });
            return colors;
        },
        prepareNonStandardColors(objColors) {
            let unmatchedColors = [];
            let vinylHexCodes = this.vinyl_color_list.map((color) => color.hex);
            objColors.forEach((colorHex) => {
                if (!vinylHexCodes.includes(colorHex)) {
                    let colorMatch = this.vendor_colors_list.findIndex(
                        (col) =>
                            col.color_value.toLowerCase() ==
                            colorHex.toLowerCase()
                    );
                    if (colorMatch == -1) {
                        unmatchedColors.push(colorHex);
                    }
                }
            });
            return unmatchedColors;
        },
        prepareDecorationColors(objColors = []) {
            let colors = [];
            objColors.forEach((colorHex) => {
                let vendorColor = this.vendor_colors_list.find(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (vendorColor) {
                    colors.push({
                        name: vendorColor.color_name,
                        hex: vendorColor.color_value
                    });
                } else {
                    colors.push({
                        hex: colorHex
                    });
                }
            });
            return colors;
        },
        prepareColors(colors) {
            let allColors = [];
            commonData.colorShades.forEach((shade) => {
                colors.forEach((color) => {
                    if (color.color_value && color.shades) {
                        if (color.shades.includes(shade)) {
                            let alreadyExisted = allColors.find(
                                (col) => col.color_id == color.color_id
                            );
                            if (!alreadyExisted) {
                                allColors.push(color);
                            }
                        }
                    }
                });
            });
            colors.forEach((color) => {
                if (color.color_value) {
                    if (!color.shades || color.shades.length == 0) {
                        allColors.push(color);
                    }
                }
            });
            return allColors;
        },
        getVinylColors() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-vinyl-colors")
                    .then(({ data }) => {
                        this.vinyl_color_list = data.color;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        prepareVendorColorsList(colorType) {
            const product =
                this.gender_groups_items[this.active_gender_key].item;

            let list = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(
                        (decorator) =>
                            decorator.id == product.default_decorator_id
                    );
                    vendorColors = default_decorator.VendorColors;
                } else {
                    vendorColors = product.Decorators[0].VendorColors;
                }

                list = vendorColors.filter(
                    (color) => color.Color.type == colorType
                );
            }

            return list;
        },
        prepareNameAndNumbers() {
            const genders = this.gender_groups_items;
            genders.forEach((gender) => {
                gender.colors.forEach((color) => {
                    color.name_and_number_json = [];
                    color.unique_sizes.forEach((size) => {
                        for (let i = 0; i < size.quantity; i++) {
                            color.name_and_number_json.push({
                                name: "",
                                number: "",
                                size: size.Size.size
                            });
                        }
                    });
                });
            });
        },
        changeNameAndNumbersAfterQtyUpdate() {
            // Get name and number from local variable and manage according to size quantity
            this.gender_groups_items.forEach((gender) => {
                gender.colors.forEach((color) => {
                    let totalQty = 0;
                    color.unique_sizes.forEach((size) => {
                        let currentSizeLength = parseInt(
                            color.name_and_number_json.filter((item) => {
                                return item.size == size.Size.size;
                            }).length
                        );
                        if (size.quantity > 0) {
                            if (size.quantity == currentSizeLength) {
                                currentSizeLength -= parseInt(size.quantity);
                                totalQty += parseInt(size.quantity);
                            } else if (size.quantity > currentSizeLength) {
                                let diff = size.quantity - currentSizeLength;
                                for (let i = 0; i < diff; i++) {
                                    color.name_and_number_json.splice(
                                        totalQty + currentSizeLength + i,
                                        0,
                                        {
                                            name: "",
                                            number: "",
                                            size: size.Size.size
                                        }
                                    );
                                }
                                totalQty += parseInt(diff);
                            } else if (currentSizeLength > size.quantity) {
                                console.log(
                                    "currentSizeLength",
                                    currentSizeLength
                                );
                                let diff =
                                    parseInt(currentSizeLength) -
                                    parseInt(size.quantity);
                                color.name_and_number_json.splice(
                                    totalQty,
                                    diff
                                );
                                totalQty -= parseInt(diff);
                            }
                        } else {
                            color.name_and_number_json.splice(
                                totalQty,
                                currentSizeLength
                            );
                            totalQty -= parseInt(currentSizeLength);
                        }
                    });
                });
            });
        }
    },

    async beforeMount() {
        this.isLoader = true;

        this.build_canvas_design_colors = JSON.parse(
            localStorage.getItem("build_canvas_design_colors")
        );
        this.total_build_items = localStorage.getItem("total_build_items");

        var design = JSON.parse(localStorage.getItem("design_build"))
            ? JSON.parse(localStorage.getItem("design_build"))
            : "";
        this.gender_groups_items = design;

        // FIRST AREA SELECTED FROM IMPRINT LOCATIONS
        let imprint_locations =
            this.gender_groups_items[this.active_gender_key].imprint_locations;
        if (imprint_locations.length > 0) {
            let imprint_location = imprint_locations.find(
                (location) => location.is_selected
            );
            if (imprint_location) {
                this.active_flip = imprint_location.location
                    .toLowerCase()
                    .trim();
            }
        }

        this.is24Tshirt = JSON.parse(localStorage.getItem("is24Tshirt"));
        if (design == "") {
            /* eslint-disable */
            $("#design-studio").modal("show");
            /* eslint-enable */
        }
        design.forEach((ele) => {
            this.genders.push(ele.gender_name);
            let gname = ele.gender_name;
            var items = {
                [gname]: []
            };
            this.canvas_elements.push(items);
        });

        this.active_gender = this.genders[0];
        this.active_gender_key = 0;
        localStorage.setItem("active_gender", this.genders[0]);
        localStorage.setItem("active_gender_key", 0);

        localStorage.setItem("active_flip", this.active_flip);
        let new_canvas_elements = JSON.parse(
            localStorage.getItem("new_canvas_elements")
        );
        this.showNameNumber = new_canvas_elements.showNameNumber
            ? JSON.parse(new_canvas_elements.showNameNumber)
            : false;

        this.product_items = design[0].item;

        if (this.product_items && this.product_items.Vendor.vendor_colors) {
            let vendor_colors = this.product_items.Vendor.newVendorColors;
            this.vendor_colors_list = this.prepareColors(vendor_colors);
        }

        if ("PrintTemplate" in this.product_items) {
            this.colors_count = this.product_items.PrintTemplate.no_of_colors;
        } else if ("Embroidery" in this.product_items) {
            this.colors_count = this.product_items.Embroidery.no_of_colors;
        }
        this.product_id = design[0].item["id"];
        this.product_title = design[0].item["name"];
        this.product_number = design[0].item["product_number"];
        this.base_price = design[0].item["retail_base_price"];

        this.base_price = design[0].item["price_base"];

        design.forEach((element, ind) => {
            element["colors"].forEach((color) => {
                this.user_selected_values.push({
                    color_id: color.id,
                    color: color.color_name,
                    swatches: color.swatches,
                    color_hash: color.hash,
                    shades: color.shades,
                    category: color.category,
                    default_selection: color.default_selection,
                    name_number_fees: element.name_number_fees || 0,
                    non_standard_fees: element.non_standard_fees || 0,
                    total_qty_gender_wise: color.total_qty_gender_wise,
                    total_cost_gender_wise: color.total_cost_gender_wise,
                    unit_price: color.unique_sizes[0].cost,
                    unique_sizes: color.unique_sizes,
                    imprint_locations: color.imprint_locations,
                    gender: this.genders[ind]
                });
            });
        });
        if (this.user_selected_values.length > 0) {
            let previousColorIndex =
                localStorage.getItem("colorIndex") != null
                    ? localStorage.getItem("colorIndex")
                    : 0;
            this.activeIndex =
                this.user_selected_values[previousColorIndex].color_id;
            this.activeColorIndex = previousColorIndex;
            localStorage.removeItem("colorIdArr");
        }
        localStorage.setItem(
            "active_tshirt_color",
            this.user_selected_values[0].color_hash
        );
        this.tshirt_color = this.user_selected_values[0].color_hash;
        localStorage.setItem("product_id", this.product_id);
        let get_product = JSON.stringify(this.product_items);
        let _this = this;

        let design_images = JSON.parse(
            design[0]["colors"][this.activeColorIndex].id
        );

        this.active_product_type = JSON.parse(get_product).product_type_id;
        localStorage.setItem("product_type_id", this.active_product_type);
        _this.design_area_data = JSON.parse(
            JSON.parse(get_product).design_areas
        );
        if (typeof _this.design_area_data == "string") {
            _this.design_area_data = JSON.parse(_this.design_area_data);
        }
        _this.design_area_inches = [];
        Object.values(_this.design_area_data).forEach((element) => {
            this.design_area_inches.push({
                label_show: element.label_show
                    ? element.label_show
                    : element.label,
                label: element.label,
                widthIn: element.widthIn,
                heightIn: element.heightIn
            });
            if (element.label == "Front") {
                _this.front_show = true;
                if (element.short_thumbnail_image) {
                    this.front_icon_canvas_type = this.setUrl(
                        element.short_thumbnail_image
                    );
                }

                if (this.active_flip == "front") {
                    let selected_design_images = [];
                    design[0]["item"]["NewProductImages"].forEach((colors) => {
                        if (
                            colors.color_id == design_images &&
                            colors.type == "front"
                        ) {
                            selected_design_images.push({
                                front: colors.url
                            });
                        }
                        if (
                            colors.color_id == design_images &&
                            colors.type == "back"
                        ) {
                            selected_design_images.push({
                                back: colors.url
                            });
                        }
                    });

                    let default_color_img = "";

                    let def_color = design[0]["item"][
                        "NewProductImages"
                    ].filter(
                        (color) =>
                            color.color_id == design_images &&
                            color.type != "front" &&
                            color.type != "back"
                    );

                    if (def_color.length > 0) {
                        default_color_img = def_color[0].url;
                    }

                    var ele_img = "";
                    var ele_img_back = "";
                    if (selected_design_images.length > 0) {
                        let filter_img = selected_design_images.filter(
                            (img) => "front" in img
                        );

                        if (filter_img.length > 0) {
                            ele_img = filter_img[0]["front"];
                        }
                        let filter_img_back = selected_design_images.filter(
                            (img) => "back" in img
                        );

                        if (filter_img_back.length > 0) {
                            ele_img_back = filter_img_back[0]["back"];
                        }
                    } else {
                        ele_img = "";
                        ele_img_back = "";
                    }
                    _this.background_image = ele_img
                        ? ele_img
                        : default_color_img;

                    if (ele_img_back) {
                        default_color_img = ele_img_back;
                    }
                    if (
                        default_color_img.length == 0 ||
                        (ele_img_back == "" && ele_img)
                    ) {
                        _this.back_show = false;
                        _this.removeBackCanvas = false;
                    } else {
                        _this.back_show = true;
                        _this.removeBackCanvas = true;
                    }

                    _this.front_canvas_height = parseFloat(element.height);
                    _this.front_canvas_width = parseFloat(element.width);
                    _this.front_canvas_top = element.top;
                    _this.front_canvas_left = element.left;
                    _this.front_canvas_angle = element.angle
                        ? element.angle
                        : 0;
                }
            }
            if (element.label == "Back") {
                if (element.short_thumbnail_image) {
                    this.back_icon_canvas_type = _this.setUrl(
                        element.short_thumbnail_image
                    );
                }
            }
            if (element.label == "Back" && _this.removeBackCanvas == 1) {
                _this.back_show = true;
            }
            if (element.label == "Left" || element.label == "Left Sleeve") {
                if (element.short_thumbnail_image) {
                    this.left_icon_canvas_type = _this.setUrl(
                        element.short_thumbnail_image
                    );
                }
                _this.left_show = element.selected;
            }
            if (element.label == "Right" || element.label == "Right Sleeve") {
                if (element.short_thumbnail_image) {
                    this.right_icon_canvas_type = _this.setUrl(
                        element.short_thumbnail_image
                    );
                }
                _this.right_show = element.selected;
            }
        });
        this.updatePrintAreas();
        this.prepareNameAndNumbers();
        this.isLoader = false;
    },
    async mounted() {
        var vm = this;
        vm.isLoader = true;
        let _this = this;
        /* eslint-disable */
        $("#undoObj").click(function () {
            _this.replay(_this.undo, _this.redo, "#redoObj", this);
            _this.undoActive = true;
            _this.redoActive = false;
            if (_this.undo.length <= 0) {
                _this.design_current_colors = [];
                $("#newResetbtn").prop("disabled", true);
                $(".new_arts_color").addClass("d-none");
            }
        });
        $("#redoObj").click(function () {
            _this.replay(_this.redo, _this.undo, "#undoObj", this);
            _this.undoActive = false;
            _this.redoActive = true;
            $(".new_arts_color").removeClass("d-none");
            if (_this.undo.length == 0) {
                $("#newResetbtn").prop("disabled", true);
            } else {
                $("#newResetbtn").prop("disabled", false);
            }
        });
        document.addEventListener("keydown", this.controlUndoRedoObject);

        $("#back_flipbtn").prop("disabled", true);

        // slider js start
        let timer = 0;
        if (
            this.$route.params.id &&
            localStorage.getItem("share_design_id") != this.$route.params.id
        ) {
            timer = 5000;
        }
        timer = 1000;
        if (
            this.$route.params.id &&
            localStorage.getItem("share_design_id") != this.$route.params.id
        ) {
            timer = 5000;
        }
        setTimeout(function () {
            _this.updateImageToBackCanvas(_this.background_image);
            _this.getLocalDesign();
        }, timer);

        $(document).ready(function () {
            $(".clearfix button,a").tooltip();
        });

        vm.isLoader = false;
        window.test = this;
        $(document.body).on("click", ".deleteBtn", function () {
            vm.delete_object();
        });
        /* eslint-enable */
        try {
            // this.product_id = "";
            let product_values = JSON.parse(
                localStorage.getItem("product_values")
            );

            if (product_values) {
                this.product_title = product_values[0]["product_title"];
                this.product_number = product_values[0]["product_number"];
                this.product_id = product_values[0]["id"];
                this.design_name = product_values[0]["design_name"];
                this.base_price = product_values[0]["retail_base_price"];
                this.base_price = this.base_price
                    ? this.base_price.toFixed(2)
                    : 0;
                this.setDesign(product_values[0]["product_details"]);
                this.user_selected_values = JSON.parse(
                    localStorage.getItem("user_selected_values")
                );
            }
            localStorage.setItem("product_id", this.product_id);
            
            // Read rush option data from localStorage
            const storedRushOptionId = localStorage.getItem("selectedRushOptionId");
            this.selectedRushOptionId = storedRushOptionId && storedRushOptionId !== "" ? storedRushOptionId : null;
            
            try {
                const storedVendorServices = localStorage.getItem("vendorServices");
                this.vendorServices = storedVendorServices ? JSON.parse(storedVendorServices) : [];
            } catch (e) {
                console.error("Error parsing vendorServices from localStorage:", e);
                this.vendorServices = [];
            }
        } catch (e) {
            console.log(e);
        }

        document.body.addEventListener("keydown", this.objectClone, false);

        this.getVinylColors();

        if (this.$route.hash == "#upload") {
            document.getElementById("add-upload-tab").click();
        } else if (this.$route.hash == "#designs") {
            document.getElementById("designs-tab").click();
        }

        if (!this.showNameNumber) {
            if (this.active_flip == "front") {
                setTimeout(() => {
                    this.flipTshirt(this.active_flip);
                }, 3000);
            }
        }

        setTimeout(() => {
            this.$refs.ItemDetails.calculatePricing(this.active_gender_key);
        }, 1000);
        this.$refs.ItemDetails.disableImprintLocations(true);
        if (this.showNameNumber) {
            setTimeout(() => {
                document.getElementById("nn-tab1").click();
            }, 2000);
        }
    },
    beforeDestroy() {
        document.body.removeEventListener("keydown", this.objectClone);
        document.removeEventListener("keydown", this.controlUndoRedoObject);
    },
    computed: {
        ...mapGetters([
            "currentUserClient",
            "isAuthenticatedClient",
            "adminOptions"
        ]),
        tag() {
            return this.$route.params.tag;
        },
        template_category_search() {
            if (this.template_search_query) {
                return this.all_templates_images.filter((item) => {
                    if (item.product_type_id == this.active_product_type) {
                        return this.template_search_query
                            .toLowerCase()
                            .split(" ")
                            .every((v) => item.name.toLowerCase().includes(v));
                    }
                });
            } else {
                return this.templates;
            }
        },
        template_subcategory_search() {
            if (this.template_subcategory_search_query) {
                return this.all_templates_images.filter((item) => {
                    if (item.product_type_id == this.active_product_type) {
                        return this.template_subcategory_search_query
                            .toLowerCase()
                            .split(" ")
                            .every((v) => item.name.toLowerCase().includes(v));
                    }
                });
            } else {
                return this.selected_template_category
                    .DesignStudioTemplateSubCategories
                    ? this.selected_template_category
                          .DesignStudioTemplateSubCategories
                    : [];
            }
        },
        saved_template_category() {
            if (this.template_search_query) {
                return this.savedDesigns.filter((item) => {
                    return this.template_search_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item.name.toLowerCase().includes(v));
                });
            } else {
                return this.templates;
            }
        },
        clipart_category_search() {
            if (this.clipart_search_query) {
                return this.all_cliparts_images.filter((item) => {
                    return this.clipart_search_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) =>
                            item.image_name.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.clipart_category;
            }
        },
        clipart_subcategory_search() {
            if (this.clipart_subcategory_search_query) {
                return this.all_cliparts_images.filter((item) => {
                    return this.clipart_subcategory_search_query
                        .toLowerCase()
                        .split(" ")
                        .every((v) =>
                            item.image_name.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.cliparts;
            }
        },
        openLoginModal: function () {
            /* eslint-disable */
            $("#login").modal("show");
            /* eslint-enable */
        }
    },
    created() {
        let _this = this;
        _this.checkObjectCanvas();
        window.addEventListener(
            "beforeunload",
            function (event) {
                let designStatus = false;
                let previouscanvasList = JSON.parse(
                    localStorage.getItem("new_canvas_elements")
                );
                if (previouscanvasList != null) {
                    if ("front" in previouscanvasList) {
                        JSON.parse(previouscanvasList["front"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                    if ("back" in previouscanvasList) {
                        JSON.parse(previouscanvasList["back"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                    if ("left" in previouscanvasList) {
                        JSON.parse(previouscanvasList["left"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                    if ("right" in previouscanvasList) {
                        JSON.parse(previouscanvasList["right"]).objects.forEach(
                            (canvas_obj) => {
                                if (canvas_obj.type != "rect") {
                                    designStatus = true;
                                }
                            }
                        );
                    }
                    if (previouscanvasList && previouscanvasList.build_id) {
                        this.saved_design.build_id =
                            previouscanvasList.build_id;
                    }
                    /* eslint-disable */
                    if (parsedJson && previouscanvasList.build_item_id) {
                        this.saved_design.build_item_id =
                            previouscanvasList.build_item_id;
                        this.saved_design.first_build_item_id =
                            previouscanvasList.first_build_item_id;
                    }
                    /* eslint-enable */
                }
                if (designStatus) return (event.returnValue = "");
            },
            { capture: true }
        );
    }
};
export default design_tool;
</script>

<style>
.cr-resizer {
    width: 270px !important;
    height: 270px !important;
}

.navbar-nav-menu .nav-item .router-link-exact-active {
    color: #0079c1 !important;
}

.clipart_img_size:last-child {
    border-right: 1px solid rgba(0, 0, 0, 0.2) !important;
}

div#add-clipart div#avatarlist {
    border-top: 1px solid rgba(0, 0, 0, 0.2) !important;
}

#custom-handle-bar {
    cursor: pointer;
    border: none !important;
    height: unset !important;
    width: 28px !important;
    background: transparent !important;
}

#appdiv {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.design_studio_tool
    .design_studio_footer
    .design_footer-flex
    .thumb_slider_footer
    .design_studio_footer_change_color_images
    .color_images_cross_icon {
    width: 15px;
    top: -4px;
}

.design_footer-flex .color_slider .owl-item {
    padding-top: 5px;
    padding-bottom: 5px;
}

.left_right_sleeve_canvas {
    border: 2px dashed #7a7a7a;
}

#tcanvas {
    border: none !important;
}

.design_studio_btns {
    max-width: 80% !important;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.design_studio_up .bottom_btn {
    float: none;
}

.design_studio_tool a.add_cart {
    max-width: 50%;
    padding: 12px;
    margin-left: 0px !important;
}

.design_studio_tool .save_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.design_studio_tool a.back_to {
    max-width: 100%;
    width: 100% !important;
}

.design_studio_up .save_btn .btn.btn_h60 {
    max-width: 60% !important;
    margin: 0px 0px 0px 10px !important;
    padding: 12px 0px !important;
}

@media (max-width: 1600px) {
    .design_studio_tool a.add_cart {
        font-size: 12px !important;
        padding: 12px 10px;
    }

    .design_studio_up .save_btn .btn.btn_h60 {
        font-size: 12px !important;
    }
}

@media (max-width: 1250px) {
    .design_studio_tool .save_btn {
        flex-direction: column;
    }

    .design_studio_up .save_btn .btn.btn_h60 {
        max-width: 100% !important;
        margin: 10px !important;
        margin: 10px 0px !important;
    }

    .design_studio_tool a.add_cart {
        max-width: 100% !important;
        width: 100%;
    }
}

.design_studio_up #save_design_modal .modal-body {
    padding: 20px !important;
}

.cursor-pointer {
    cursor: pointer;
}

.load-value {
    font-weight: 700;
    color: #fff;
    left: 49%;
    top: 47.5%;
    position: absolute;
}

#newResetbtn:disabled {
    pointer-events: none;
}

#undoObj:disabled {
    pointer-events: none;
}

#redoObj:disabled {
    pointer-events: none;
}

/* Remove Other Data for Edit / Add Items */
.ds_ad_edt_itm .nav-tabs {
    display: none !important;
}
.ds_ad_edt_itm .rt-edit-template {
    display: none !important;
}
/* .catgory_headding { display: none !important;}  */
.ds_ad_edt_itm .new_align_layers {
    display: none !important;
}
.ds_ad_edt_itm textarea.text_input_pad {
    display: none !important;
}
.ds_ad_edt_itm .add-text-panel {
    display: none !important;
}
/* .ds_ad_edt_itm .addtext_font { display: none !important;}  */
.ds_ad_edt_itm .align_full_box_main {
    display: none !important;
}
/* .custome_div { display: none !important;}  */
/* .ds_ad_edt_itm .checkbox_div { display: none !important;}  */
.ds_ad_edt_itm .heading5 {
    display: none !important;
}
.ds_ad_edt_itm .add_update_text {
    display: none !important;
}
.ds_ad_edt_itm .text_primary_blue {
    display: none !important;
}
.ds_ad_edt_itm .text_primary_blue {
    display: none !important;
}
.ds_ad_edt_itm .ml-auto {
    display: none !important;
}
/* .ds_ad_edt_itm .custome_div { display: none !important;} */
.ds_ad_edt_itm .addtext_font.align_value .layer_parent_div {
    display: none !important;
}
.ds_ad_edt_itm .addtext_rotation_wrap {
    display: none !important;
}
.ds_ad_edt_itm .addtext_text_outline_wrap .range,
.ds_ad_edt_itm .addtext_text_outline_wrap .add_text_no {
    display: none !important;
}
/* Hide Delete Button */
.ds_ad_edt_itm .canvas-container img.deleteBtn {
    display: none;
}
.emboss_shadow_box {
    display: none;
}
.shadow_width {
    display: none !important;
}
.checkbox_div input {
    display: none !important;
}
.design_studio_tool .checkbox_div span:before {
    display: none !important;
}
.design_studio_up
    .emboss_deboss_checkbox_sec
    .emboss_check_box_inner_div
    .checkbox_div
    input:checked
    + span::after {
    display: none !important;
}
</style>
